(function() {
    'use strict';

    angular
        .module('teJHipsterApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch($resource) {
        var resourceUrl =  'api/_search/users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', 'Base64'];

    function AuthServerProvider ($http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken;
        }

        function login (credentials) {
            var data = 'username=' +  encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=my-secret-token-to-change-in-production&client_id=TE_JHipsterapp';

            return $http.post('oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('TE_JHipsterapp' + ':' + 'my-secret-token-to-change-in-production')
                }
            }).success(authSucess);

            function authSucess (response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                return response;
            }
        }

        function logout () {
            $http.post('api/logout').then(function() {
                delete $localStorage.authenticationToken;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserActivationDialogController', UserActivationDialogController);

    UserActivationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'UserActivation', 'CustomUser'];

    function UserActivationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, UserActivation, CustomUser) {
        var vm = this;

        vm.userActivation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customusers = CustomUser.query({filter: 'useractivation-is-null'});
        $q.all([vm.userActivation.$promise, vm.customusers.$promise]).then(function() {
            if (!vm.userActivation.customUserId) {
                return $q.reject();
            }
            return CustomUser.get({id : vm.userActivation.customUserId}).$promise;
        }).then(function(customUser) {
            vm.customusers.push(customUser);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userActivation.id !== null) {
                UserActivation.update(vm.userActivation, onSaveSuccess, onSaveError);
            } else {
                UserActivation.save(vm.userActivation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:userActivationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastSyncTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserActivationDetailController', UserActivationDetailController);

    UserActivationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UserActivation', 'CustomUser'];

    function UserActivationDetailController($scope, $rootScope, $stateParams, previousState, entity, UserActivation, CustomUser) {
        var vm = this;

        vm.userActivation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:userActivationUpdate', function(event, result) {
            vm.userActivation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserActivationDeleteController',UserActivationDeleteController);

    UserActivationDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserActivation'];

    function UserActivationDeleteController($uibModalInstance, entity, UserActivation) {
        var vm = this;

        vm.userActivation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserActivation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-activation', {
            parent: 'entity',
            url: '/user-activation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.userActivation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-activation/user-activations.html',
                    controller: 'UserActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userActivation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-activation-detail', {
            parent: 'user-activation',
            url: '/user-activation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.userActivation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-activation/user-activation-detail.html',
                    controller: 'UserActivationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userActivation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserActivation', function($stateParams, UserActivation) {
                    return UserActivation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-activation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-activation-detail.edit', {
            parent: 'user-activation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-dialog.html',
                    controller: 'UserActivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserActivation', function(UserActivation) {
                            return UserActivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-activation.new', {
            parent: 'user-activation',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-dialog.html',
                    controller: 'UserActivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                activated: false,
                                lastSyncTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-activation', null, { reload: 'user-activation' });
                }, function() {
                    $state.go('user-activation');
                });
            }]
        })
        .state('user-activation.edit', {
            parent: 'user-activation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-dialog.html',
                    controller: 'UserActivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserActivation', function(UserActivation) {
                            return UserActivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-activation', null, { reload: 'user-activation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-activation.delete', {
            parent: 'user-activation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-delete-dialog.html',
                    controller: 'UserActivationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserActivation', function(UserActivation) {
                            return UserActivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-activation', null, { reload: 'user-activation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('UserActivation', UserActivation);

    UserActivation.$inject = ['$resource', 'DateUtils'];

    function UserActivation ($resource, DateUtils) {
        var resourceUrl =  'api/user-activations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastSyncTime = DateUtils.convertDateTimeFromServer(data.lastSyncTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('UserActivationSearch', UserActivationSearch);

    UserActivationSearch.$inject = ['$resource'];

    function UserActivationSearch($resource) {
        var resourceUrl =  'api/_search/user-activations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserActivationController', UserActivationController);

    UserActivationController.$inject = ['UserActivation', 'UserActivationSearch'];

    function UserActivationController(UserActivation, UserActivationSearch) {

        var vm = this;

        vm.userActivations = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            UserActivation.query(function(result) {
                vm.userActivations = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            UserActivationSearch.query({query: vm.searchQuery}, function(result) {
                vm.userActivations = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskObjectTypeDialogController', TaskObjectTypeDialogController);

    TaskObjectTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaskObjectType'];

    function TaskObjectTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaskObjectType) {
        var vm = this;

        vm.taskObjectType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.taskObjectType.id !== null) {
                TaskObjectType.update(vm.taskObjectType, onSaveSuccess, onSaveError);
            } else {
                TaskObjectType.save(vm.taskObjectType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:taskObjectTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskObjectTypeDetailController', TaskObjectTypeDetailController);

    TaskObjectTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TaskObjectType'];

    function TaskObjectTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TaskObjectType) {
        var vm = this;

        vm.taskObjectType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:taskObjectTypeUpdate', function(event, result) {
            vm.taskObjectType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskObjectTypeDeleteController',TaskObjectTypeDeleteController);

    TaskObjectTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaskObjectType'];

    function TaskObjectTypeDeleteController($uibModalInstance, entity, TaskObjectType) {
        var vm = this;

        vm.taskObjectType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TaskObjectType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-object-type', {
            parent: 'entity',
            url: '/task-object-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.taskObjectType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-object-type/task-object-types.html',
                    controller: 'TaskObjectTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskObjectType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-object-type-detail', {
            parent: 'task-object-type',
            url: '/task-object-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.taskObjectType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-object-type/task-object-type-detail.html',
                    controller: 'TaskObjectTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskObjectType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaskObjectType', function($stateParams, TaskObjectType) {
                    return TaskObjectType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task-object-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('task-object-type-detail.edit', {
            parent: 'task-object-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-dialog.html',
                    controller: 'TaskObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaskObjectType', function(TaskObjectType) {
                            return TaskObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task-object-type.new', {
            parent: 'task-object-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-dialog.html',
                    controller: 'TaskObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                key: null,
                                apiUrl: null,
                                backendUrl: null,
                                frontendUrl: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('task-object-type', null, { reload: 'task-object-type' });
                }, function() {
                    $state.go('task-object-type');
                });
            }]
        })
        .state('task-object-type.edit', {
            parent: 'task-object-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-dialog.html',
                    controller: 'TaskObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaskObjectType', function(TaskObjectType) {
                            return TaskObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task-object-type', null, { reload: 'task-object-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task-object-type.delete', {
            parent: 'task-object-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-object-type/task-object-type-delete-dialog.html',
                    controller: 'TaskObjectTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaskObjectType', function(TaskObjectType) {
                            return TaskObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task-object-type', null, { reload: 'task-object-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('TaskObjectType', TaskObjectType);

    TaskObjectType.$inject = ['$resource'];

    function TaskObjectType ($resource) {
        var resourceUrl =  'api/task-object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('TaskObjectTypeSearch', TaskObjectTypeSearch);

    TaskObjectTypeSearch.$inject = ['$resource'];

    function TaskObjectTypeSearch($resource) {
        var resourceUrl =  'api/_search/task-object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskObjectTypeController', TaskObjectTypeController);

    TaskObjectTypeController.$inject = ['$state', 'TaskObjectType', 'TaskObjectTypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TaskObjectTypeController($state, TaskObjectType, TaskObjectTypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TaskObjectTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TaskObjectType.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskObjectTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskDialogController', TaskDialogController);

    TaskDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Task', 'CustomUser', 'SpecificQuestion', 'Answer', 'FrequentlyAskedQuestion', 'HandbookVersion'];

    function TaskDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Task, CustomUser, SpecificQuestion, Answer, FrequentlyAskedQuestion, HandbookVersion) {
        var vm = this;

        vm.task = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customusers = CustomUser.query();
        vm.specificquestions = SpecificQuestion.query();
        vm.answers = Answer.query();
        vm.frequentlyaskedquestions = FrequentlyAskedQuestion.query();
        vm.handbookversions = HandbookVersion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.task.id !== null) {
                Task.update(vm.task, onSaveSuccess, onSaveError);
            } else {
                Task.save(vm.task, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:taskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.assignmenttime = false;
        vm.datePickerOpenStatus.completiontime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskDetailController', TaskDetailController);

    TaskDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Task', 'CustomUser', 'SpecificQuestion', 'Answer', 'FrequentlyAskedQuestion', 'HandbookVersion'];

    function TaskDetailController($scope, $rootScope, $stateParams, previousState, entity, Task, CustomUser, SpecificQuestion, Answer, FrequentlyAskedQuestion, HandbookVersion) {
        var vm = this;

        vm.task = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:taskUpdate', function(event, result) {
            vm.task = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskDeleteController',TaskDeleteController);

    TaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'Task'];

    function TaskDeleteController($uibModalInstance, entity, Task) {
        var vm = this;

        vm.task = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Task.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task', {
            parent: 'entity',
            url: '/task?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.task.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task/tasks.html',
                    controller: 'TaskController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('taskType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-detail', {
            parent: 'task',
            url: '/task/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.task.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task/task-detail.html',
                    controller: 'TaskDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('taskType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Task', function($stateParams, Task) {
                    return Task.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('task-detail.edit', {
            parent: 'task-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task.new', {
            parent: 'task',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                assignmenttime: null,
                                completiontime: null,
                                tasktype: null,
                                completionInfo: null,
                                completedInPositiveWay: null,
                                assignmentInfo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: 'task' });
                }, function() {
                    $state.go('task');
                });
            }]
        })
        .state('task.edit', {
            parent: 'task',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: 'task' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task.delete', {
            parent: 'task',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-delete-dialog.html',
                    controller: 'TaskDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: 'task' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('Task', Task);

    Task.$inject = ['$resource', 'DateUtils'];

    function Task ($resource, DateUtils) {
        var resourceUrl =  'api/tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.assignmenttime = DateUtils.convertDateTimeFromServer(data.assignmenttime);
                        data.completiontime = DateUtils.convertDateTimeFromServer(data.completiontime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('TaskSearch', TaskSearch);

    TaskSearch.$inject = ['$resource'];

    function TaskSearch($resource) {
        var resourceUrl =  'api/_search/tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskController', TaskController);

    TaskController.$inject = ['$state', 'Task', 'TaskSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TaskController($state, Task, TaskSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TaskSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Task.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tasks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('SpecificQuestionDialogController', SpecificQuestionDialogController);

    SpecificQuestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SpecificQuestion', 'Answer', 'Comment', 'Task'];

    function SpecificQuestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SpecificQuestion, Answer, Comment, Task) {
        var vm = this;

        vm.specificQuestion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.selectedanswers = Answer.query({filter: 'selectedforspecificquestion-is-null'});
        $q.all([vm.specificQuestion.$promise, vm.selectedanswers.$promise]).then(function() {
            if (!vm.specificQuestion.selectedAnswerId) {
                return $q.reject();
            }
            return Answer.get({id : vm.specificQuestion.selectedAnswerId}).$promise;
        }).then(function(selectedAnswer) {
            vm.selectedanswers.push(selectedAnswer);
        });
        vm.comments = Comment.query();
        vm.tasks = Task.query();
        vm.answers = Answer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.specificQuestion.id !== null) {
                SpecificQuestion.update(vm.specificQuestion, onSaveSuccess, onSaveError);
            } else {
                SpecificQuestion.save(vm.specificQuestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:specificQuestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationtime = false;
        vm.datePickerOpenStatus.answertime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('SpecificQuestionDetailController', SpecificQuestionDetailController);

    SpecificQuestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SpecificQuestion', 'Answer', 'Comment', 'Task'];

    function SpecificQuestionDetailController($scope, $rootScope, $stateParams, previousState, entity, SpecificQuestion, Answer, Comment, Task) {
        var vm = this;

        vm.specificQuestion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:specificQuestionUpdate', function(event, result) {
            vm.specificQuestion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('SpecificQuestionDeleteController',SpecificQuestionDeleteController);

    SpecificQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SpecificQuestion'];

    function SpecificQuestionDeleteController($uibModalInstance, entity, SpecificQuestion) {
        var vm = this;

        vm.specificQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SpecificQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('specific-question', {
            parent: 'entity',
            url: '/specific-question?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.specificQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specific-question/specific-questions.html',
                    controller: 'SpecificQuestionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specificQuestion');
                    $translatePartialLoader.addPart('specificQuestionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('specific-question-detail', {
            parent: 'specific-question',
            url: '/specific-question/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.specificQuestion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specific-question/specific-question-detail.html',
                    controller: 'SpecificQuestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specificQuestion');
                    $translatePartialLoader.addPart('specificQuestionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SpecificQuestion', function($stateParams, SpecificQuestion) {
                    return SpecificQuestion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'specific-question',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('specific-question-detail.edit', {
            parent: 'specific-question-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-dialog.html',
                    controller: 'SpecificQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SpecificQuestion', function(SpecificQuestion) {
                            return SpecificQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specific-question.new', {
            parent: 'specific-question',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-dialog.html',
                    controller: 'SpecificQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sender: null,
                                content: null,
                                creationtime: null,
                                answertime: null,
                                specificquestionstate: null,
                                name: null,
                                subject: null,
                                senderSecondaryEmail: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('specific-question', null, { reload: 'specific-question' });
                }, function() {
                    $state.go('specific-question');
                });
            }]
        })
        .state('specific-question.edit', {
            parent: 'specific-question',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-dialog.html',
                    controller: 'SpecificQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SpecificQuestion', function(SpecificQuestion) {
                            return SpecificQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specific-question', null, { reload: 'specific-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specific-question.delete', {
            parent: 'specific-question',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specific-question/specific-question-delete-dialog.html',
                    controller: 'SpecificQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SpecificQuestion', function(SpecificQuestion) {
                            return SpecificQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specific-question', null, { reload: 'specific-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('SpecificQuestion', SpecificQuestion);

    SpecificQuestion.$inject = ['$resource', 'DateUtils'];

    function SpecificQuestion ($resource, DateUtils) {
        var resourceUrl =  'api/specific-questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationtime = DateUtils.convertDateTimeFromServer(data.creationtime);
                        data.answertime = DateUtils.convertDateTimeFromServer(data.answertime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('SpecificQuestionSearch', SpecificQuestionSearch);

    SpecificQuestionSearch.$inject = ['$resource'];

    function SpecificQuestionSearch($resource) {
        var resourceUrl =  'api/_search/specific-questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('SpecificQuestionController', SpecificQuestionController);

    SpecificQuestionController.$inject = ['$state', 'SpecificQuestion', 'SpecificQuestionSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SpecificQuestionController($state, SpecificQuestion, SpecificQuestionSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SpecificQuestionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SpecificQuestion.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.specificQuestions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaGroupDialogController', ProfessionalAreaGroupDialogController);

    ProfessionalAreaGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProfessionalAreaGroup', 'ProfessionalArea'];

    function ProfessionalAreaGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProfessionalAreaGroup, ProfessionalArea) {
        var vm = this;

        vm.professionalAreaGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.professionalareas = ProfessionalArea.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.professionalAreaGroup.id !== null) {
                ProfessionalAreaGroup.update(vm.professionalAreaGroup, onSaveSuccess, onSaveError);
            } else {
                ProfessionalAreaGroup.save(vm.professionalAreaGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:professionalAreaGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaGroupDetailController', ProfessionalAreaGroupDetailController);

    ProfessionalAreaGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProfessionalAreaGroup', 'ProfessionalArea'];

    function ProfessionalAreaGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, ProfessionalAreaGroup, ProfessionalArea) {
        var vm = this;

        vm.professionalAreaGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:professionalAreaGroupUpdate', function(event, result) {
            vm.professionalAreaGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaGroupDeleteController',ProfessionalAreaGroupDeleteController);

    ProfessionalAreaGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfessionalAreaGroup'];

    function ProfessionalAreaGroupDeleteController($uibModalInstance, entity, ProfessionalAreaGroup) {
        var vm = this;

        vm.professionalAreaGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfessionalAreaGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('professional-area-group', {
            parent: 'entity',
            url: '/professional-area-group',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalAreaGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area-group/professional-area-groups.html',
                    controller: 'ProfessionalAreaGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalAreaGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('professional-area-group-detail', {
            parent: 'professional-area-group',
            url: '/professional-area-group/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalAreaGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-detail.html',
                    controller: 'ProfessionalAreaGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalAreaGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfessionalAreaGroup', function($stateParams, ProfessionalAreaGroup) {
                    return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'professional-area-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('professional-area-group-detail.edit', {
            parent: 'professional-area-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-dialog.html',
                    controller: 'ProfessionalAreaGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalAreaGroup', function(ProfessionalAreaGroup) {
                            return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area-group.new', {
            parent: 'professional-area-group',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-dialog.html',
                    controller: 'ProfessionalAreaGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                groupId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('professional-area-group', null, { reload: 'professional-area-group' });
                }, function() {
                    $state.go('professional-area-group');
                });
            }]
        })
        .state('professional-area-group.edit', {
            parent: 'professional-area-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-dialog.html',
                    controller: 'ProfessionalAreaGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalAreaGroup', function(ProfessionalAreaGroup) {
                            return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area-group', null, { reload: 'professional-area-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area-group.delete', {
            parent: 'professional-area-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area-group/professional-area-group-delete-dialog.html',
                    controller: 'ProfessionalAreaGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfessionalAreaGroup', function(ProfessionalAreaGroup) {
                            return ProfessionalAreaGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area-group', null, { reload: 'professional-area-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('ProfessionalAreaGroup', ProfessionalAreaGroup);

    ProfessionalAreaGroup.$inject = ['$resource'];

    function ProfessionalAreaGroup ($resource) {
        var resourceUrl =  'api/professional-area-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('ProfessionalAreaGroupSearch', ProfessionalAreaGroupSearch);

    ProfessionalAreaGroupSearch.$inject = ['$resource'];

    function ProfessionalAreaGroupSearch($resource) {
        var resourceUrl =  'api/_search/professional-area-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaGroupController', ProfessionalAreaGroupController);

    ProfessionalAreaGroupController.$inject = ['ProfessionalAreaGroup', 'ProfessionalAreaGroupSearch'];

    function ProfessionalAreaGroupController(ProfessionalAreaGroup, ProfessionalAreaGroupSearch) {

        var vm = this;

        vm.professionalAreaGroups = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ProfessionalAreaGroup.query(function(result) {
                vm.professionalAreaGroups = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProfessionalAreaGroupSearch.query({query: vm.searchQuery}, function(result) {
                vm.professionalAreaGroups = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaDialogController', ProfessionalAreaDialogController);

    ProfessionalAreaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProfessionalArea', 'CustomUser', 'ProfessionalAreaGroup', 'Order'];

    function ProfessionalAreaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProfessionalArea, CustomUser, ProfessionalAreaGroup, Order) {
        var vm = this;

        vm.professionalArea = entity;
        vm.clear = clear;
        vm.save = save;
        vm.customusers = CustomUser.query();
        vm.professionalareagroups = ProfessionalAreaGroup.query();
        vm.orders = Order.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.professionalArea.id !== null) {
                ProfessionalArea.update(vm.professionalArea, onSaveSuccess, onSaveError);
            } else {
                ProfessionalArea.save(vm.professionalArea, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:professionalAreaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaDetailController', ProfessionalAreaDetailController);

    ProfessionalAreaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProfessionalArea', 'CustomUser', 'ProfessionalAreaGroup', 'Order'];

    function ProfessionalAreaDetailController($scope, $rootScope, $stateParams, previousState, entity, ProfessionalArea, CustomUser, ProfessionalAreaGroup, Order) {
        var vm = this;

        vm.professionalArea = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:professionalAreaUpdate', function(event, result) {
            vm.professionalArea = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaDeleteController',ProfessionalAreaDeleteController);

    ProfessionalAreaDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfessionalArea'];

    function ProfessionalAreaDeleteController($uibModalInstance, entity, ProfessionalArea) {
        var vm = this;

        vm.professionalArea = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfessionalArea.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('professional-area', {
            parent: 'entity',
            url: '/professional-area?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalArea.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area/professional-areas.html',
                    controller: 'ProfessionalAreaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalArea');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('professional-area-detail', {
            parent: 'professional-area',
            url: '/professional-area/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalArea.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area/professional-area-detail.html',
                    controller: 'ProfessionalAreaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalArea');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfessionalArea', function($stateParams, ProfessionalArea) {
                    return ProfessionalArea.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'professional-area',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('professional-area-detail.edit', {
            parent: 'professional-area-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-dialog.html',
                    controller: 'ProfessionalAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalArea', function(ProfessionalArea) {
                            return ProfessionalArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area.new', {
            parent: 'professional-area',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-dialog.html',
                    controller: 'ProfessionalAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                areaId: null,
                                name: null,
                                description: null,
                                showInFaqList: null,
                                showInDocumentList: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('professional-area', null, { reload: 'professional-area' });
                }, function() {
                    $state.go('professional-area');
                });
            }]
        })
        .state('professional-area.edit', {
            parent: 'professional-area',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-dialog.html',
                    controller: 'ProfessionalAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalArea', function(ProfessionalArea) {
                            return ProfessionalArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area', null, { reload: 'professional-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area.delete', {
            parent: 'professional-area',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-delete-dialog.html',
                    controller: 'ProfessionalAreaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfessionalArea', function(ProfessionalArea) {
                            return ProfessionalArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area', null, { reload: 'professional-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('ProfessionalArea', ProfessionalArea);

    ProfessionalArea.$inject = ['$resource'];

    function ProfessionalArea ($resource) {
        var resourceUrl =  'api/professional-areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('ProfessionalAreaSearch', ProfessionalAreaSearch);

    ProfessionalAreaSearch.$inject = ['$resource'];

    function ProfessionalAreaSearch($resource) {
        var resourceUrl =  'api/_search/professional-areas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaController', ProfessionalAreaController);

    ProfessionalAreaController.$inject = ['$state', 'ProfessionalArea', 'ProfessionalAreaSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProfessionalAreaController($state, ProfessionalArea, ProfessionalAreaSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProfessionalAreaSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProfessionalArea.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.professionalAreas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HelpDialogController', HelpDialogController);

    HelpDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Help'];

    function HelpDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Help) {
        var vm = this;

        vm.help = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.help.id !== null) {
                Help.update(vm.help, onSaveSuccess, onSaveError);
            } else {
                Help.save(vm.help, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:helpUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HelpDetailController', HelpDetailController);

    HelpDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Help'];

    function HelpDetailController($scope, $rootScope, $stateParams, previousState, entity, Help) {
        var vm = this;

        vm.help = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:helpUpdate', function(event, result) {
            vm.help = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HelpDeleteController',HelpDeleteController);

    HelpDeleteController.$inject = ['$uibModalInstance', 'entity', 'Help'];

    function HelpDeleteController($uibModalInstance, entity, Help) {
        var vm = this;

        vm.help = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Help.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('help', {
            parent: 'entity',
            url: '/help?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.help.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/help/helps.html',
                    controller: 'HelpController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('help');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('help-detail', {
            parent: 'help',
            url: '/help/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.help.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/help/help-detail.html',
                    controller: 'HelpDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('help');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Help', function($stateParams, Help) {
                    return Help.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'help',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('help-detail.edit', {
            parent: 'help-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/help/help-dialog.html',
                    controller: 'HelpDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Help', function(Help) {
                            return Help.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('help.new', {
            parent: 'help',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/help/help-dialog.html',
                    controller: 'HelpDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                content: null,
                                helpId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('help', null, { reload: 'help' });
                }, function() {
                    $state.go('help');
                });
            }]
        })
        .state('help.edit', {
            parent: 'help',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/help/help-dialog.html',
                    controller: 'HelpDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Help', function(Help) {
                            return Help.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('help', null, { reload: 'help' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('help.delete', {
            parent: 'help',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/help/help-delete-dialog.html',
                    controller: 'HelpDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Help', function(Help) {
                            return Help.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('help', null, { reload: 'help' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('Help', Help);

    Help.$inject = ['$resource'];

    function Help ($resource) {
        var resourceUrl =  'api/helps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HelpSearch', HelpSearch);

    HelpSearch.$inject = ['$resource'];

    function HelpSearch($resource) {
        var resourceUrl =  'api/_search/helps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HelpController', HelpController);

    HelpController.$inject = ['$state', 'Help', 'HelpSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HelpController($state, Help, HelpSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HelpSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Help.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.helps = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionStateHistoryDialogController', HandbookVersionStateHistoryDialogController);

    HandbookVersionStateHistoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookVersionStateHistory', 'HandbookVersion', 'CustomUser'];

    function HandbookVersionStateHistoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookVersionStateHistory, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbookVersionStateHistory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.handbookversions = HandbookVersion.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookVersionStateHistory.id !== null) {
                HandbookVersionStateHistory.update(vm.handbookVersionStateHistory, onSaveSuccess, onSaveError);
            } else {
                HandbookVersionStateHistory.save(vm.handbookVersionStateHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookVersionStateHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.stateSetTimestamp = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionStateHistoryDetailController', HandbookVersionStateHistoryDetailController);

    HandbookVersionStateHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookVersionStateHistory', 'HandbookVersion', 'CustomUser'];

    function HandbookVersionStateHistoryDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookVersionStateHistory, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbookVersionStateHistory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookVersionStateHistoryUpdate', function(event, result) {
            vm.handbookVersionStateHistory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionStateHistoryDeleteController',HandbookVersionStateHistoryDeleteController);

    HandbookVersionStateHistoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookVersionStateHistory'];

    function HandbookVersionStateHistoryDeleteController($uibModalInstance, entity, HandbookVersionStateHistory) {
        var vm = this;

        vm.handbookVersionStateHistory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookVersionStateHistory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-version-state-history', {
            parent: 'entity',
            url: '/handbook-version-state-history?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersionStateHistory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-histories.html',
                    controller: 'HandbookVersionStateHistoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersionStateHistory');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-version-state-history-detail', {
            parent: 'handbook-version-state-history',
            url: '/handbook-version-state-history/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersionStateHistory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-detail.html',
                    controller: 'HandbookVersionStateHistoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersionStateHistory');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('handbookVersionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookVersionStateHistory', function($stateParams, HandbookVersionStateHistory) {
                    return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-version-state-history',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-version-state-history-detail.edit', {
            parent: 'handbook-version-state-history-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-dialog.html',
                    controller: 'HandbookVersionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersionStateHistory', function(HandbookVersionStateHistory) {
                            return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version-state-history.new', {
            parent: 'handbook-version-state-history',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-dialog.html',
                    controller: 'HandbookVersionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stateSetTimestamp: null,
                                stateOld: null,
                                stateNew: null,
                                info: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-version-state-history', null, { reload: 'handbook-version-state-history' });
                }, function() {
                    $state.go('handbook-version-state-history');
                });
            }]
        })
        .state('handbook-version-state-history.edit', {
            parent: 'handbook-version-state-history',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-dialog.html',
                    controller: 'HandbookVersionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersionStateHistory', function(HandbookVersionStateHistory) {
                            return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version-state-history', null, { reload: 'handbook-version-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version-state-history.delete', {
            parent: 'handbook-version-state-history',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version-state-history/handbook-version-state-history-delete-dialog.html',
                    controller: 'HandbookVersionStateHistoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookVersionStateHistory', function(HandbookVersionStateHistory) {
                            return HandbookVersionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version-state-history', null, { reload: 'handbook-version-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookVersionStateHistory', HandbookVersionStateHistory);

    HandbookVersionStateHistory.$inject = ['$resource', 'DateUtils'];

    function HandbookVersionStateHistory ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-version-state-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.stateSetTimestamp = DateUtils.convertDateTimeFromServer(data.stateSetTimestamp);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookVersionStateHistorySearch', HandbookVersionStateHistorySearch);

    HandbookVersionStateHistorySearch.$inject = ['$resource'];

    function HandbookVersionStateHistorySearch($resource) {
        var resourceUrl =  'api/_search/handbook-version-state-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionStateHistoryController', HandbookVersionStateHistoryController);

    HandbookVersionStateHistoryController.$inject = ['$state', 'HandbookVersionStateHistory', 'HandbookVersionStateHistorySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookVersionStateHistoryController($state, HandbookVersionStateHistory, HandbookVersionStateHistorySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookVersionStateHistorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                HandbookVersionStateHistory.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbookVersionStateHistories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionDialogController', HandbookVersionDialogController);

    HandbookVersionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookVersion', 'Handbook', 'CustomUser', 'HandbookNode'];

    function HandbookVersionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookVersion, Handbook, CustomUser, HandbookNode) {
        var vm = this;

        vm.handbookVersion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.handbooks = Handbook.query();
        vm.customusers = CustomUser.query();
        vm.handbooknodes = HandbookNode.query();
        vm.handbookversions = HandbookVersion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookVersion.id !== null) {
                HandbookVersion.update(vm.handbookVersion, onSaveSuccess, onSaveError);
            } else {
                HandbookVersion.save(vm.handbookVersion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookVersionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.validFrom = false;
        vm.datePickerOpenStatus.validUntil = false;
        vm.datePickerOpenStatus.publicationDate = false;
        vm.datePickerOpenStatus.creationTime = false;
        vm.datePickerOpenStatus.revisionTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionDetailController', HandbookVersionDetailController);

    HandbookVersionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookVersion', 'Handbook', 'CustomUser', 'HandbookNode'];

    function HandbookVersionDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookVersion, Handbook, CustomUser, HandbookNode) {
        var vm = this;

        vm.handbookVersion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookVersionUpdate', function(event, result) {
            vm.handbookVersion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionDeleteController',HandbookVersionDeleteController);

    HandbookVersionDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookVersion'];

    function HandbookVersionDeleteController($uibModalInstance, entity, HandbookVersion) {
        var vm = this;

        vm.handbookVersion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookVersion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-version', {
            parent: 'entity',
            url: '/handbook-version?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version/handbook-versions.html',
                    controller: 'HandbookVersionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersion');
                    $translatePartialLoader.addPart('handbookVersionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-version-detail', {
            parent: 'handbook-version',
            url: '/handbook-version/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookVersion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-version/handbook-version-detail.html',
                    controller: 'HandbookVersionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookVersion');
                    $translatePartialLoader.addPart('handbookVersionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookVersion', function($stateParams, HandbookVersion) {
                    return HandbookVersion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-version',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-version-detail.edit', {
            parent: 'handbook-version-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-dialog.html',
                    controller: 'HandbookVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersion', function(HandbookVersion) {
                            return HandbookVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version.new', {
            parent: 'handbook-version',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-dialog.html',
                    controller: 'HandbookVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                version: null,
                                validFrom: null,
                                validUntil: null,
                                publicationDate: null,
                                state: null,
                                significantChange: false,
                                note: null,
                                creationTime: null,
                                revisionTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-version', null, { reload: 'handbook-version' });
                }, function() {
                    $state.go('handbook-version');
                });
            }]
        })
        .state('handbook-version.edit', {
            parent: 'handbook-version',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-dialog.html',
                    controller: 'HandbookVersionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookVersion', function(HandbookVersion) {
                            return HandbookVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version', null, { reload: 'handbook-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-version.delete', {
            parent: 'handbook-version',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-version/handbook-version-delete-dialog.html',
                    controller: 'HandbookVersionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookVersion', function(HandbookVersion) {
                            return HandbookVersion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-version', null, { reload: 'handbook-version' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookVersion', HandbookVersion);

    HandbookVersion.$inject = ['$resource', 'DateUtils'];

    function HandbookVersion ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validFrom = DateUtils.convertDateTimeFromServer(data.validFrom);
                        data.validUntil = DateUtils.convertDateTimeFromServer(data.validUntil);
                        data.publicationDate = DateUtils.convertDateTimeFromServer(data.publicationDate);
                        data.creationTime = DateUtils.convertDateTimeFromServer(data.creationTime);
                        data.revisionTime = DateUtils.convertDateTimeFromServer(data.revisionTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookVersionSearch', HandbookVersionSearch);

    HandbookVersionSearch.$inject = ['$resource'];

    function HandbookVersionSearch($resource) {
        var resourceUrl =  'api/_search/handbook-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionController', HandbookVersionController);

    HandbookVersionController.$inject = ['$state', 'HandbookVersion', 'HandbookVersionSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookVersionController($state, HandbookVersion, HandbookVersionSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookVersionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                HandbookVersion.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbookVersions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookStatisticDialogController', HandbookStatisticDialogController);

    HandbookStatisticDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookStatistic', 'Handbook'];

    function HandbookStatisticDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookStatistic, Handbook) {
        var vm = this;

        vm.handbookStatistic = entity;
        vm.clear = clear;
        vm.save = save;
        vm.handbooks = Handbook.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookStatistic.id !== null) {
                HandbookStatistic.update(vm.handbookStatistic, onSaveSuccess, onSaveError);
            } else {
                HandbookStatistic.save(vm.handbookStatistic, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookStatisticUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookStatisticDetailController', HandbookStatisticDetailController);

    HandbookStatisticDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookStatistic', 'Handbook'];

    function HandbookStatisticDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookStatistic, Handbook) {
        var vm = this;

        vm.handbookStatistic = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookStatisticUpdate', function(event, result) {
            vm.handbookStatistic = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookStatisticDeleteController',HandbookStatisticDeleteController);

    HandbookStatisticDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookStatistic'];

    function HandbookStatisticDeleteController($uibModalInstance, entity, HandbookStatistic) {
        var vm = this;

        vm.handbookStatistic = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookStatistic.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-statistic', {
            parent: 'entity',
            url: '/handbook-statistic?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookStatistic.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistics.html',
                    controller: 'HandbookStatisticController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookStatistic');
                    $translatePartialLoader.addPart('handbookStatisticType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-statistic-detail', {
            parent: 'handbook-statistic',
            url: '/handbook-statistic/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookStatistic.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-detail.html',
                    controller: 'HandbookStatisticDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookStatistic');
                    $translatePartialLoader.addPart('handbookStatisticType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookStatistic', function($stateParams, HandbookStatistic) {
                    return HandbookStatistic.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-statistic',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-statistic-detail.edit', {
            parent: 'handbook-statistic-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-dialog.html',
                    controller: 'HandbookStatisticDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookStatistic', function(HandbookStatistic) {
                            return HandbookStatistic.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-statistic.new', {
            parent: 'handbook-statistic',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-dialog.html',
                    controller: 'HandbookStatisticDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                type: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-statistic', null, { reload: 'handbook-statistic' });
                }, function() {
                    $state.go('handbook-statistic');
                });
            }]
        })
        .state('handbook-statistic.edit', {
            parent: 'handbook-statistic',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-dialog.html',
                    controller: 'HandbookStatisticDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookStatistic', function(HandbookStatistic) {
                            return HandbookStatistic.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-statistic', null, { reload: 'handbook-statistic' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-statistic.delete', {
            parent: 'handbook-statistic',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-statistic/handbook-statistic-delete-dialog.html',
                    controller: 'HandbookStatisticDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookStatistic', function(HandbookStatistic) {
                            return HandbookStatistic.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-statistic', null, { reload: 'handbook-statistic' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookStatistic', HandbookStatistic);

    HandbookStatistic.$inject = ['$resource'];

    function HandbookStatistic ($resource) {
        var resourceUrl =  'api/handbook-statistics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookStatisticSearch', HandbookStatisticSearch);

    HandbookStatisticSearch.$inject = ['$resource'];

    function HandbookStatisticSearch($resource) {
        var resourceUrl =  'api/_search/handbook-statistics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookStatisticController', HandbookStatisticController);

    HandbookStatisticController.$inject = ['$state', 'HandbookStatistic', 'HandbookStatisticSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookStatisticController($state, HandbookStatistic, HandbookStatisticSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookStatisticSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                HandbookStatistic.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbookStatistics = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookNodeDialogController', HandbookNodeDialogController);

    HandbookNodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'HandbookNode', 'HandbookVersion', 'File'];

    function HandbookNodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, HandbookNode, HandbookVersion, File) {
        var vm = this;

        vm.handbookNode = entity;
        vm.clear = clear;
        vm.save = save;
        vm.handbookversions = HandbookVersion.query();
        vm.handbooknodes = HandbookNode.query();
        vm.files = File.query();
        vm.previoussiblingnodes = HandbookNode.query({filter: 'nextsiblingnode-is-null'});
        $q.all([vm.handbookNode.$promise, vm.previoussiblingnodes.$promise]).then(function() {
            if (!vm.handbookNode.previousSiblingNodeId) {
                return $q.reject();
            }
            return HandbookNode.get({id : vm.handbookNode.previousSiblingNodeId}).$promise;
        }).then(function(previousSiblingNode) {
            vm.previoussiblingnodes.push(previousSiblingNode);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookNode.id !== null) {
                HandbookNode.update(vm.handbookNode, onSaveSuccess, onSaveError);
            } else {
                HandbookNode.save(vm.handbookNode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookNodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookNodeDetailController', HandbookNodeDetailController);

    HandbookNodeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookNode', 'HandbookVersion', 'File'];

    function HandbookNodeDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookNode, HandbookVersion, File) {
        var vm = this;

        vm.handbookNode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookNodeUpdate', function(event, result) {
            vm.handbookNode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookNodeDeleteController',HandbookNodeDeleteController);

    HandbookNodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookNode'];

    function HandbookNodeDeleteController($uibModalInstance, entity, HandbookNode) {
        var vm = this;

        vm.handbookNode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookNode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-node', {
            parent: 'entity',
            url: '/handbook-node?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookNode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-node/handbook-nodes.html',
                    controller: 'HandbookNodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookNode');
                    $translatePartialLoader.addPart('handbookNodeType');
                    $translatePartialLoader.addPart('handbookNodeAccessRights');
                    $translatePartialLoader.addPart('mergeState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-node-detail', {
            parent: 'handbook-node',
            url: '/handbook-node/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookNode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-node/handbook-node-detail.html',
                    controller: 'HandbookNodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookNode');
                    $translatePartialLoader.addPart('handbookNodeType');
                    $translatePartialLoader.addPart('handbookNodeAccessRights');
                    $translatePartialLoader.addPart('mergeState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookNode', function($stateParams, HandbookNode) {
                    return HandbookNode.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-node',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-node-detail.edit', {
            parent: 'handbook-node-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-dialog.html',
                    controller: 'HandbookNodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookNode', function(HandbookNode) {
                            return HandbookNode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-node.new', {
            parent: 'handbook-node',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-dialog.html',
                    controller: 'HandbookNodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                type: null,
                                accessRights: null,
                                visible: null,
                                nodeUUID: null,
                                canAddHeading: null,
                                canDelete: null,
                                canEdit: null,
                                info: null,
                                treeLabel: null,
                                treeCheckboxVisible: false,
                                mergeState: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-node', null, { reload: 'handbook-node' });
                }, function() {
                    $state.go('handbook-node');
                });
            }]
        })
        .state('handbook-node.edit', {
            parent: 'handbook-node',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-dialog.html',
                    controller: 'HandbookNodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookNode', function(HandbookNode) {
                            return HandbookNode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-node', null, { reload: 'handbook-node' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-node.delete', {
            parent: 'handbook-node',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-node/handbook-node-delete-dialog.html',
                    controller: 'HandbookNodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookNode', function(HandbookNode) {
                            return HandbookNode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-node', null, { reload: 'handbook-node' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookNode', HandbookNode);

    HandbookNode.$inject = ['$resource'];

    function HandbookNode ($resource) {
        var resourceUrl =  'api/handbook-nodes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookNodeSearch', HandbookNodeSearch);

    HandbookNodeSearch.$inject = ['$resource'];

    function HandbookNodeSearch($resource) {
        var resourceUrl =  'api/_search/handbook-nodes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookNodeController', HandbookNodeController);

    HandbookNodeController.$inject = ['$state', 'HandbookNode', 'HandbookNodeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookNodeController($state, HandbookNode, HandbookNodeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookNodeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                HandbookNode.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbookNodes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeItemDialogController', HandbookMergeItemDialogController);

    HandbookMergeItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookMergeItem', 'HandbookNode', 'HandbookMergeHeader'];

    function HandbookMergeItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookMergeItem, HandbookNode, HandbookMergeHeader) {
        var vm = this;

        vm.handbookMergeItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.handbooknodes = HandbookNode.query();
        vm.handbookmergeheaders = HandbookMergeHeader.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookMergeItem.id !== null) {
                HandbookMergeItem.update(vm.handbookMergeItem, onSaveSuccess, onSaveError);
            } else {
                HandbookMergeItem.save(vm.handbookMergeItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookMergeItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.merged = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeItemDetailController', HandbookMergeItemDetailController);

    HandbookMergeItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookMergeItem', 'HandbookNode', 'HandbookMergeHeader'];

    function HandbookMergeItemDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookMergeItem, HandbookNode, HandbookMergeHeader) {
        var vm = this;

        vm.handbookMergeItem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookMergeItemUpdate', function(event, result) {
            vm.handbookMergeItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeItemDeleteController',HandbookMergeItemDeleteController);

    HandbookMergeItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookMergeItem'];

    function HandbookMergeItemDeleteController($uibModalInstance, entity, HandbookMergeItem) {
        var vm = this;

        vm.handbookMergeItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookMergeItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-merge-item', {
            parent: 'entity',
            url: '/handbook-merge-item?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-items.html',
                    controller: 'HandbookMergeItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeItem');
                    $translatePartialLoader.addPart('handbookMergeItemChangeType');
                    $translatePartialLoader.addPart('handbookMergeItemChangeIn');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-merge-item-detail', {
            parent: 'handbook-merge-item',
            url: '/handbook-merge-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-detail.html',
                    controller: 'HandbookMergeItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeItem');
                    $translatePartialLoader.addPart('handbookMergeItemChangeType');
                    $translatePartialLoader.addPart('handbookMergeItemChangeIn');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookMergeItem', function($stateParams, HandbookMergeItem) {
                    return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-merge-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-merge-item-detail.edit', {
            parent: 'handbook-merge-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-dialog.html',
                    controller: 'HandbookMergeItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeItem', function(HandbookMergeItem) {
                            return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-item.new', {
            parent: 'handbook-merge-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-dialog.html',
                    controller: 'HandbookMergeItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nodeUUID: null,
                                changeType: null,
                                changeIn: null,
                                merged: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-item', null, { reload: 'handbook-merge-item' });
                }, function() {
                    $state.go('handbook-merge-item');
                });
            }]
        })
        .state('handbook-merge-item.edit', {
            parent: 'handbook-merge-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-dialog.html',
                    controller: 'HandbookMergeItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeItem', function(HandbookMergeItem) {
                            return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-item', null, { reload: 'handbook-merge-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-item.delete', {
            parent: 'handbook-merge-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-delete-dialog.html',
                    controller: 'HandbookMergeItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookMergeItem', function(HandbookMergeItem) {
                            return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-item', null, { reload: 'handbook-merge-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookMergeItem', HandbookMergeItem);

    HandbookMergeItem.$inject = ['$resource', 'DateUtils'];

    function HandbookMergeItem ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-merge-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.merged = DateUtils.convertDateTimeFromServer(data.merged);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookMergeItemSearch', HandbookMergeItemSearch);

    HandbookMergeItemSearch.$inject = ['$resource'];

    function HandbookMergeItemSearch($resource) {
        var resourceUrl =  'api/_search/handbook-merge-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeItemController', HandbookMergeItemController);

    HandbookMergeItemController.$inject = ['$state', 'HandbookMergeItem', 'HandbookMergeItemSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookMergeItemController($state, HandbookMergeItem, HandbookMergeItemSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookMergeItemSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                HandbookMergeItem.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbookMergeItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeHeaderDialogController', HandbookMergeHeaderDialogController);

    HandbookMergeHeaderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookMergeHeader', 'Handbook', 'HandbookVersion', 'CustomUser'];

    function HandbookMergeHeaderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookMergeHeader, Handbook, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbookMergeHeader = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.handbooks = Handbook.query();
        vm.handbookversions = HandbookVersion.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookMergeHeader.id !== null) {
                HandbookMergeHeader.update(vm.handbookMergeHeader, onSaveSuccess, onSaveError);
            } else {
                HandbookMergeHeader.save(vm.handbookMergeHeader, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookMergeHeaderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.finishTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeHeaderDetailController', HandbookMergeHeaderDetailController);

    HandbookMergeHeaderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookMergeHeader', 'Handbook', 'HandbookVersion', 'CustomUser'];

    function HandbookMergeHeaderDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookMergeHeader, Handbook, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbookMergeHeader = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookMergeHeaderUpdate', function(event, result) {
            vm.handbookMergeHeader = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeHeaderDeleteController',HandbookMergeHeaderDeleteController);

    HandbookMergeHeaderDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookMergeHeader'];

    function HandbookMergeHeaderDeleteController($uibModalInstance, entity, HandbookMergeHeader) {
        var vm = this;

        vm.handbookMergeHeader = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookMergeHeader.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-merge-header', {
            parent: 'entity',
            url: '/handbook-merge-header?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeHeader.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-headers.html',
                    controller: 'HandbookMergeHeaderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeHeader');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-merge-header-detail', {
            parent: 'handbook-merge-header',
            url: '/handbook-merge-header/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeHeader.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-detail.html',
                    controller: 'HandbookMergeHeaderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeHeader');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookMergeHeader', function($stateParams, HandbookMergeHeader) {
                    return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-merge-header',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-merge-header-detail.edit', {
            parent: 'handbook-merge-header-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-dialog.html',
                    controller: 'HandbookMergeHeaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeHeader', function(HandbookMergeHeader) {
                            return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-header.new', {
            parent: 'handbook-merge-header',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-dialog.html',
                    controller: 'HandbookMergeHeaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startTime: null,
                                finishTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-header', null, { reload: 'handbook-merge-header' });
                }, function() {
                    $state.go('handbook-merge-header');
                });
            }]
        })
        .state('handbook-merge-header.edit', {
            parent: 'handbook-merge-header',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-dialog.html',
                    controller: 'HandbookMergeHeaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeHeader', function(HandbookMergeHeader) {
                            return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-header', null, { reload: 'handbook-merge-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-header.delete', {
            parent: 'handbook-merge-header',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-delete-dialog.html',
                    controller: 'HandbookMergeHeaderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookMergeHeader', function(HandbookMergeHeader) {
                            return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-header', null, { reload: 'handbook-merge-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookMergeHeader', HandbookMergeHeader);

    HandbookMergeHeader.$inject = ['$resource', 'DateUtils'];

    function HandbookMergeHeader ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-merge-headers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.finishTime = DateUtils.convertDateTimeFromServer(data.finishTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookMergeHeaderSearch', HandbookMergeHeaderSearch);

    HandbookMergeHeaderSearch.$inject = ['$resource'];

    function HandbookMergeHeaderSearch($resource) {
        var resourceUrl =  'api/_search/handbook-merge-headers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeHeaderController', HandbookMergeHeaderController);

    HandbookMergeHeaderController.$inject = ['$state', 'HandbookMergeHeader', 'HandbookMergeHeaderSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookMergeHeaderController($state, HandbookMergeHeader, HandbookMergeHeaderSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookMergeHeaderSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                HandbookMergeHeader.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbookMergeHeaders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookFolderDialogController', HandbookFolderDialogController);

    HandbookFolderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookFolder', 'Handbook', 'CustomUser'];

    function HandbookFolderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookFolder, Handbook, CustomUser) {
        var vm = this;

        vm.handbookFolder = entity;
        vm.clear = clear;
        vm.save = save;
        vm.handbooks = Handbook.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookFolder.id !== null) {
                HandbookFolder.update(vm.handbookFolder, onSaveSuccess, onSaveError);
            } else {
                HandbookFolder.save(vm.handbookFolder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookFolderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookFolderDetailController', HandbookFolderDetailController);

    HandbookFolderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookFolder', 'Handbook', 'CustomUser'];

    function HandbookFolderDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookFolder, Handbook, CustomUser) {
        var vm = this;

        vm.handbookFolder = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookFolderUpdate', function(event, result) {
            vm.handbookFolder = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookFolderDeleteController',HandbookFolderDeleteController);

    HandbookFolderDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookFolder'];

    function HandbookFolderDeleteController($uibModalInstance, entity, HandbookFolder) {
        var vm = this;

        vm.handbookFolder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookFolder.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-folder', {
            parent: 'entity',
            url: '/handbook-folder?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookFolder.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-folder/handbook-folders.html',
                    controller: 'HandbookFolderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookFolder');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-folder-detail', {
            parent: 'handbook-folder',
            url: '/handbook-folder/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookFolder.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-detail.html',
                    controller: 'HandbookFolderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookFolder');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookFolder', function($stateParams, HandbookFolder) {
                    return HandbookFolder.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-folder',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-folder-detail.edit', {
            parent: 'handbook-folder-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-dialog.html',
                    controller: 'HandbookFolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookFolder', function(HandbookFolder) {
                            return HandbookFolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-folder.new', {
            parent: 'handbook-folder',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-dialog.html',
                    controller: 'HandbookFolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-folder', null, { reload: 'handbook-folder' });
                }, function() {
                    $state.go('handbook-folder');
                });
            }]
        })
        .state('handbook-folder.edit', {
            parent: 'handbook-folder',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-dialog.html',
                    controller: 'HandbookFolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookFolder', function(HandbookFolder) {
                            return HandbookFolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-folder', null, { reload: 'handbook-folder' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-folder.delete', {
            parent: 'handbook-folder',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-folder/handbook-folder-delete-dialog.html',
                    controller: 'HandbookFolderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookFolder', function(HandbookFolder) {
                            return HandbookFolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-folder', null, { reload: 'handbook-folder' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookFolder', HandbookFolder);

    HandbookFolder.$inject = ['$resource'];

    function HandbookFolder ($resource) {
        var resourceUrl =  'api/handbook-folders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookFolderSearch', HandbookFolderSearch);

    HandbookFolderSearch.$inject = ['$resource'];

    function HandbookFolderSearch($resource) {
        var resourceUrl =  'api/_search/handbook-folders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookFolderController', HandbookFolderController);

    HandbookFolderController.$inject = ['$state', 'HandbookFolder', 'HandbookFolderSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookFolderController($state, HandbookFolder, HandbookFolderSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookFolderSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                HandbookFolder.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbookFolders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookDialogController', HandbookDialogController);

    HandbookDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Handbook', 'ProfessionalArea', 'HandbookVersion', 'CustomUser'];

    function HandbookDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Handbook, ProfessionalArea, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbook = entity;
        vm.clear = clear;
        vm.save = save;
        vm.professionalareas = ProfessionalArea.query();
        vm.handbookversions = HandbookVersion.query();
        vm.handbooks = Handbook.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbook.id !== null) {
                Handbook.update(vm.handbook, onSaveSuccess, onSaveError);
            } else {
                Handbook.save(vm.handbook, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookDetailController', HandbookDetailController);

    HandbookDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Handbook', 'ProfessionalArea', 'HandbookVersion', 'CustomUser'];

    function HandbookDetailController($scope, $rootScope, $stateParams, previousState, entity, Handbook, ProfessionalArea, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbook = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookUpdate', function(event, result) {
            vm.handbook = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookDeleteController',HandbookDeleteController);

    HandbookDeleteController.$inject = ['$uibModalInstance', 'entity', 'Handbook'];

    function HandbookDeleteController($uibModalInstance, entity, Handbook) {
        var vm = this;

        vm.handbook = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Handbook.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook', {
            parent: 'entity',
            url: '/handbook?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbook.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook/handbooks.html',
                    controller: 'HandbookController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbook');
                    $translatePartialLoader.addPart('handbookDocumentType');
                    $translatePartialLoader.addPart('documentDataType');
                    $translatePartialLoader.addPart('handbookVisibleFor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-detail', {
            parent: 'handbook',
            url: '/handbook/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbook.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook/handbook-detail.html',
                    controller: 'HandbookDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbook');
                    $translatePartialLoader.addPart('handbookDocumentType');
                    $translatePartialLoader.addPart('documentDataType');
                    $translatePartialLoader.addPart('handbookVisibleFor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Handbook', function($stateParams, Handbook) {
                    return Handbook.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-detail.edit', {
            parent: 'handbook-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-dialog.html',
                    controller: 'HandbookDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Handbook', function(Handbook) {
                            return Handbook.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook.new', {
            parent: 'handbook',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-dialog.html',
                    controller: 'HandbookDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                documentType: null,
                                name: null,
                                isTemplate: null,
                                isPublic: null,
                                documentDataType: null,
                                additionalInfo: null,
                                visibleFor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook', null, { reload: 'handbook' });
                }, function() {
                    $state.go('handbook');
                });
            }]
        })
        .state('handbook.edit', {
            parent: 'handbook',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-dialog.html',
                    controller: 'HandbookDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Handbook', function(Handbook) {
                            return Handbook.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook', null, { reload: 'handbook' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook.delete', {
            parent: 'handbook',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-delete-dialog.html',
                    controller: 'HandbookDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Handbook', function(Handbook) {
                            return Handbook.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook', null, { reload: 'handbook' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('Handbook', Handbook);

    Handbook.$inject = ['$resource'];

    function Handbook ($resource) {
        var resourceUrl =  'api/handbooks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookSearch', HandbookSearch);

    HandbookSearch.$inject = ['$resource'];

    function HandbookSearch($resource) {
        var resourceUrl =  'api/_search/handbooks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookController', HandbookController);

    HandbookController.$inject = ['$state', 'Handbook', 'HandbookSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function HandbookController($state, Handbook, HandbookSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                HandbookSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Handbook.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.handbooks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionStateHistoryDialogController', FrequentlyAskedQuestionStateHistoryDialogController);

    FrequentlyAskedQuestionStateHistoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FrequentlyAskedQuestionStateHistory', 'FrequentlyAskedQuestion', 'CustomUser'];

    function FrequentlyAskedQuestionStateHistoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FrequentlyAskedQuestionStateHistory, FrequentlyAskedQuestion, CustomUser) {
        var vm = this;

        vm.frequentlyAskedQuestionStateHistory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.frequentlyaskedquestions = FrequentlyAskedQuestion.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.frequentlyAskedQuestionStateHistory.id !== null) {
                FrequentlyAskedQuestionStateHistory.update(vm.frequentlyAskedQuestionStateHistory, onSaveSuccess, onSaveError);
            } else {
                FrequentlyAskedQuestionStateHistory.save(vm.frequentlyAskedQuestionStateHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:frequentlyAskedQuestionStateHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.stateSetTimestamp = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionStateHistoryDetailController', FrequentlyAskedQuestionStateHistoryDetailController);

    FrequentlyAskedQuestionStateHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FrequentlyAskedQuestionStateHistory', 'FrequentlyAskedQuestion', 'CustomUser'];

    function FrequentlyAskedQuestionStateHistoryDetailController($scope, $rootScope, $stateParams, previousState, entity, FrequentlyAskedQuestionStateHistory, FrequentlyAskedQuestion, CustomUser) {
        var vm = this;

        vm.frequentlyAskedQuestionStateHistory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:frequentlyAskedQuestionStateHistoryUpdate', function(event, result) {
            vm.frequentlyAskedQuestionStateHistory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionStateHistoryDeleteController',FrequentlyAskedQuestionStateHistoryDeleteController);

    FrequentlyAskedQuestionStateHistoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'FrequentlyAskedQuestionStateHistory'];

    function FrequentlyAskedQuestionStateHistoryDeleteController($uibModalInstance, entity, FrequentlyAskedQuestionStateHistory) {
        var vm = this;

        vm.frequentlyAskedQuestionStateHistory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FrequentlyAskedQuestionStateHistory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frequently-asked-question-state-history', {
            parent: 'entity',
            url: '/frequently-asked-question-state-history?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestionStateHistory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-histories.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestionStateHistory');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('frequently-asked-question-state-history-detail', {
            parent: 'frequently-asked-question-state-history',
            url: '/frequently-asked-question-state-history/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestionStateHistory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-detail.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestionStateHistory');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FrequentlyAskedQuestionStateHistory', function($stateParams, FrequentlyAskedQuestionStateHistory) {
                    return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'frequently-asked-question-state-history',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('frequently-asked-question-state-history-detail.edit', {
            parent: 'frequently-asked-question-state-history-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestionStateHistory', function(FrequentlyAskedQuestionStateHistory) {
                            return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question-state-history.new', {
            parent: 'frequently-asked-question-state-history',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stateSetTimestamp: null,
                                faqStateOld: null,
                                faqStateNew: null,
                                info: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question-state-history', null, { reload: 'frequently-asked-question-state-history' });
                }, function() {
                    $state.go('frequently-asked-question-state-history');
                });
            }]
        })
        .state('frequently-asked-question-state-history.edit', {
            parent: 'frequently-asked-question-state-history',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestionStateHistory', function(FrequentlyAskedQuestionStateHistory) {
                            return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question-state-history', null, { reload: 'frequently-asked-question-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question-state-history.delete', {
            parent: 'frequently-asked-question-state-history',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-delete-dialog.html',
                    controller: 'FrequentlyAskedQuestionStateHistoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FrequentlyAskedQuestionStateHistory', function(FrequentlyAskedQuestionStateHistory) {
                            return FrequentlyAskedQuestionStateHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question-state-history', null, { reload: 'frequently-asked-question-state-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('FrequentlyAskedQuestionStateHistory', FrequentlyAskedQuestionStateHistory);

    FrequentlyAskedQuestionStateHistory.$inject = ['$resource', 'DateUtils'];

    function FrequentlyAskedQuestionStateHistory ($resource, DateUtils) {
        var resourceUrl =  'api/frequently-asked-question-state-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.stateSetTimestamp = DateUtils.convertDateTimeFromServer(data.stateSetTimestamp);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('FrequentlyAskedQuestionStateHistorySearch', FrequentlyAskedQuestionStateHistorySearch);

    FrequentlyAskedQuestionStateHistorySearch.$inject = ['$resource'];

    function FrequentlyAskedQuestionStateHistorySearch($resource) {
        var resourceUrl =  'api/_search/frequently-asked-question-state-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionStateHistoryController', FrequentlyAskedQuestionStateHistoryController);

    FrequentlyAskedQuestionStateHistoryController.$inject = ['$state', 'FrequentlyAskedQuestionStateHistory', 'FrequentlyAskedQuestionStateHistorySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FrequentlyAskedQuestionStateHistoryController($state, FrequentlyAskedQuestionStateHistory, FrequentlyAskedQuestionStateHistorySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FrequentlyAskedQuestionStateHistorySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FrequentlyAskedQuestionStateHistory.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.frequentlyAskedQuestionStateHistories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionDialogController', FrequentlyAskedQuestionDialogController);

    FrequentlyAskedQuestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FrequentlyAskedQuestion', 'CustomUser', 'Comment', 'Task', 'ProfessionalArea', 'Answer'];

    function FrequentlyAskedQuestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FrequentlyAskedQuestion, CustomUser, Comment, Task, ProfessionalArea, Answer) {
        var vm = this;

        vm.frequentlyAskedQuestion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customusers = CustomUser.query();
        vm.comments = Comment.query();
        vm.tasks = Task.query();
        vm.professionalareas = ProfessionalArea.query();
        vm.answers = Answer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.frequentlyAskedQuestion.id !== null) {
                FrequentlyAskedQuestion.update(vm.frequentlyAskedQuestion, onSaveSuccess, onSaveError);
            } else {
                FrequentlyAskedQuestion.save(vm.frequentlyAskedQuestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:frequentlyAskedQuestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationTime = false;
        vm.datePickerOpenStatus.updateTime = false;
        vm.datePickerOpenStatus.revisionTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionDetailController', FrequentlyAskedQuestionDetailController);

    FrequentlyAskedQuestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FrequentlyAskedQuestion', 'CustomUser', 'Comment', 'Task', 'ProfessionalArea', 'Answer'];

    function FrequentlyAskedQuestionDetailController($scope, $rootScope, $stateParams, previousState, entity, FrequentlyAskedQuestion, CustomUser, Comment, Task, ProfessionalArea, Answer) {
        var vm = this;

        vm.frequentlyAskedQuestion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:frequentlyAskedQuestionUpdate', function(event, result) {
            vm.frequentlyAskedQuestion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionDeleteController',FrequentlyAskedQuestionDeleteController);

    FrequentlyAskedQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'FrequentlyAskedQuestion'];

    function FrequentlyAskedQuestionDeleteController($uibModalInstance, entity, FrequentlyAskedQuestion) {
        var vm = this;

        vm.frequentlyAskedQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FrequentlyAskedQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frequently-asked-question', {
            parent: 'entity',
            url: '/frequently-asked-question?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-questions.html',
                    controller: 'FrequentlyAskedQuestionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestion');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionVisibleFor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('frequently-asked-question-detail', {
            parent: 'frequently-asked-question',
            url: '/frequently-asked-question/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-detail.html',
                    controller: 'FrequentlyAskedQuestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestion');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionVisibleFor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FrequentlyAskedQuestion', function($stateParams, FrequentlyAskedQuestion) {
                    return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'frequently-asked-question',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('frequently-asked-question-detail.edit', {
            parent: 'frequently-asked-question-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-dialog.html',
                    controller: 'FrequentlyAskedQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestion', function(FrequentlyAskedQuestion) {
                            return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question.new', {
            parent: 'frequently-asked-question',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-dialog.html',
                    controller: 'FrequentlyAskedQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                question: null,
                                answer: null,
                                faqstate: null,
                                visibleFor: null,
                                creationTime: null,
                                updateTime: null,
                                revisionTime: null,
                                priority: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question', null, { reload: 'frequently-asked-question' });
                }, function() {
                    $state.go('frequently-asked-question');
                });
            }]
        })
        .state('frequently-asked-question.edit', {
            parent: 'frequently-asked-question',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-dialog.html',
                    controller: 'FrequentlyAskedQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestion', function(FrequentlyAskedQuestion) {
                            return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question', null, { reload: 'frequently-asked-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question.delete', {
            parent: 'frequently-asked-question',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-delete-dialog.html',
                    controller: 'FrequentlyAskedQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FrequentlyAskedQuestion', function(FrequentlyAskedQuestion) {
                            return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question', null, { reload: 'frequently-asked-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('FrequentlyAskedQuestion', FrequentlyAskedQuestion);

    FrequentlyAskedQuestion.$inject = ['$resource', 'DateUtils'];

    function FrequentlyAskedQuestion ($resource, DateUtils) {
        var resourceUrl =  'api/frequently-asked-questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationTime = DateUtils.convertDateTimeFromServer(data.creationTime);
                        data.updateTime = DateUtils.convertDateTimeFromServer(data.updateTime);
                        data.revisionTime = DateUtils.convertDateTimeFromServer(data.revisionTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('FrequentlyAskedQuestionSearch', FrequentlyAskedQuestionSearch);

    FrequentlyAskedQuestionSearch.$inject = ['$resource'];

    function FrequentlyAskedQuestionSearch($resource) {
        var resourceUrl =  'api/_search/frequently-asked-questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionController', FrequentlyAskedQuestionController);

    FrequentlyAskedQuestionController.$inject = ['$state', 'FrequentlyAskedQuestion', 'FrequentlyAskedQuestionSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FrequentlyAskedQuestionController($state, FrequentlyAskedQuestion, FrequentlyAskedQuestionSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FrequentlyAskedQuestionSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FrequentlyAskedQuestion.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.frequentlyAskedQuestions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileContentDialogController', FileContentDialogController);

    FileContentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'FileContent'];

    function FileContentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, FileContent) {
        var vm = this;

        vm.fileContent = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fileContent.id !== null) {
                FileContent.update(vm.fileContent, onSaveSuccess, onSaveError);
            } else {
                FileContent.save(vm.fileContent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:fileContentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setContent = function ($file, fileContent) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        fileContent.content = base64Data;
                        fileContent.contentContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileContentDetailController', FileContentDetailController);

    FileContentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'FileContent'];

    function FileContentDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, FileContent) {
        var vm = this;

        vm.fileContent = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('teJHipsterApp:fileContentUpdate', function(event, result) {
            vm.fileContent = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileContentDeleteController',FileContentDeleteController);

    FileContentDeleteController.$inject = ['$uibModalInstance', 'entity', 'FileContent'];

    function FileContentDeleteController($uibModalInstance, entity, FileContent) {
        var vm = this;

        vm.fileContent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FileContent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('file-content', {
            parent: 'entity',
            url: '/file-content',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.fileContent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file-content/file-contents.html',
                    controller: 'FileContentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fileContent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('file-content-detail', {
            parent: 'file-content',
            url: '/file-content/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.fileContent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file-content/file-content-detail.html',
                    controller: 'FileContentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fileContent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FileContent', function($stateParams, FileContent) {
                    return FileContent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'file-content',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('file-content-detail.edit', {
            parent: 'file-content-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-dialog.html',
                    controller: 'FileContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FileContent', function(FileContent) {
                            return FileContent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('file-content.new', {
            parent: 'file-content',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-dialog.html',
                    controller: 'FileContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                contentContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('file-content', null, { reload: 'file-content' });
                }, function() {
                    $state.go('file-content');
                });
            }]
        })
        .state('file-content.edit', {
            parent: 'file-content',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-dialog.html',
                    controller: 'FileContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FileContent', function(FileContent) {
                            return FileContent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('file-content', null, { reload: 'file-content' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('file-content.delete', {
            parent: 'file-content',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-content/file-content-delete-dialog.html',
                    controller: 'FileContentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FileContent', function(FileContent) {
                            return FileContent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('file-content', null, { reload: 'file-content' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('FileContent', FileContent);

    FileContent.$inject = ['$resource'];

    function FileContent ($resource) {
        var resourceUrl =  'api/file-contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('FileContentSearch', FileContentSearch);

    FileContentSearch.$inject = ['$resource'];

    function FileContentSearch($resource) {
        var resourceUrl =  'api/_search/file-contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileContentController', FileContentController);

    FileContentController.$inject = ['DataUtils', 'FileContent', 'FileContentSearch'];

    function FileContentController(DataUtils, FileContent, FileContentSearch) {

        var vm = this;

        vm.fileContents = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            FileContent.query(function(result) {
                vm.fileContents = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            FileContentSearch.query({query: vm.searchQuery}, function(result) {
                vm.fileContents = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileDialogController', FileDialogController);

    FileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'File'];

    function FileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, File) {
        var vm = this;

        vm.file = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.file.id !== null) {
                File.update(vm.file, onSaveSuccess, onSaveError);
            } else {
                File.save(vm.file, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:fileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.uploadTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileDetailController', FileDetailController);

    FileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'File'];

    function FileDetailController($scope, $rootScope, $stateParams, previousState, entity, File) {
        var vm = this;

        vm.file = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:fileUpdate', function(event, result) {
            vm.file = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileDeleteController',FileDeleteController);

    FileDeleteController.$inject = ['$uibModalInstance', 'entity', 'File'];

    function FileDeleteController($uibModalInstance, entity, File) {
        var vm = this;

        vm.file = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            File.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('file', {
            parent: 'entity',
            url: '/file?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.file.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file/files.html',
                    controller: 'FileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('file');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('file-detail', {
            parent: 'file',
            url: '/file/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.file.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file/file-detail.html',
                    controller: 'FileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('file');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'File', function($stateParams, File) {
                    return File.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'file',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('file-detail.edit', {
            parent: 'file-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file/file-dialog.html',
                    controller: 'FileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['File', function(File) {
                            return File.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('file.new', {
            parent: 'file',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file/file-dialog.html',
                    controller: 'FileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                size: null,
                                uploadTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('file', null, { reload: 'file' });
                }, function() {
                    $state.go('file');
                });
            }]
        })
        .state('file.edit', {
            parent: 'file',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file/file-dialog.html',
                    controller: 'FileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['File', function(File) {
                            return File.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('file', null, { reload: 'file' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('file.delete', {
            parent: 'file',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file/file-delete-dialog.html',
                    controller: 'FileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['File', function(File) {
                            return File.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('file', null, { reload: 'file' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('File', File);

    File.$inject = ['$resource', 'DateUtils'];

    function File ($resource, DateUtils) {
        var resourceUrl =  'api/files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.uploadTime = DateUtils.convertDateTimeFromServer(data.uploadTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('FileSearch', FileSearch);

    FileSearch.$inject = ['$resource'];

    function FileSearch($resource) {
        var resourceUrl =  'api/_search/files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileController', FileController);

    FileController.$inject = ['$state', 'File', 'FileSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FileController($state, File, FileSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FileSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                File.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.files = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomUserDialogController', CustomUserDialogController);

    CustomUserDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'CustomUser', 'User', 'ProfessionalArea', 'Answer', 'Comment', 'Task', 'FrequentlyAskedQuestion'];

    function CustomUserDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, CustomUser, User, ProfessionalArea, Answer, Comment, Task, FrequentlyAskedQuestion) {
        var vm = this;

        vm.customUser = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.professionalareas = ProfessionalArea.query();
        vm.answers = Answer.query();
        vm.comments = Comment.query();
        vm.tasks = Task.query();
        vm.frequentlyaskedquestions = FrequentlyAskedQuestion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customUser.id !== null) {
                CustomUser.update(vm.customUser, onSaveSuccess, onSaveError);
            } else {
                CustomUser.save(vm.customUser, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:customUserUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastLogin = false;
        vm.datePickerOpenStatus.processingOfPersonalDataContractAgreement = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomUserDetailController', CustomUserDetailController);

    CustomUserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomUser', 'User', 'ProfessionalArea', 'Answer', 'Comment', 'Task', 'FrequentlyAskedQuestion'];

    function CustomUserDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomUser, User, ProfessionalArea, Answer, Comment, Task, FrequentlyAskedQuestion) {
        var vm = this;

        vm.customUser = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:customUserUpdate', function(event, result) {
            vm.customUser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomUserDeleteController',CustomUserDeleteController);

    CustomUserDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomUser'];

    function CustomUserDeleteController($uibModalInstance, entity, CustomUser) {
        var vm = this;

        vm.customUser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomUser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-user', {
            parent: 'entity',
            url: '/custom-user?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.customUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-user/custom-users.html',
                    controller: 'CustomUserController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-user-detail', {
            parent: 'custom-user',
            url: '/custom-user/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.customUser.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-user/custom-user-detail.html',
                    controller: 'CustomUserDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customUser');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomUser', function($stateParams, CustomUser) {
                    return CustomUser.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-user',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-user-detail.edit', {
            parent: 'custom-user-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-user/custom-user-dialog.html',
                    controller: 'CustomUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomUser', function(CustomUser) {
                            return CustomUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-user.new', {
            parent: 'custom-user',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-user/custom-user-dialog.html',
                    controller: 'CustomUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                email: null,
                                phone: null,
                                lastLogin: null,
                                visId: null,
                                termsApproved: null,
                                dailyNewsActivated: null,
                                processingOfPersonalDataAgreementForApp: false,
                                processingOfPersonalDataAgreementForMarketing: false,
                                processingOfPersonalDataContractAgreement: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-user', null, { reload: 'custom-user' });
                }, function() {
                    $state.go('custom-user');
                });
            }]
        })
        .state('custom-user.edit', {
            parent: 'custom-user',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-user/custom-user-dialog.html',
                    controller: 'CustomUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomUser', function(CustomUser) {
                            return CustomUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-user', null, { reload: 'custom-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-user.delete', {
            parent: 'custom-user',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-user/custom-user-delete-dialog.html',
                    controller: 'CustomUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomUser', function(CustomUser) {
                            return CustomUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-user', null, { reload: 'custom-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('CustomUser', CustomUser);

    CustomUser.$inject = ['$resource', 'DateUtils'];

    function CustomUser ($resource, DateUtils) {
        var resourceUrl =  'api/custom-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastLogin = DateUtils.convertDateTimeFromServer(data.lastLogin);
                        data.processingOfPersonalDataContractAgreement = DateUtils.convertDateTimeFromServer(data.processingOfPersonalDataContractAgreement);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('CustomUserSearch', CustomUserSearch);

    CustomUserSearch.$inject = ['$resource'];

    function CustomUserSearch($resource) {
        var resourceUrl =  'api/_search/custom-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomUserController', CustomUserController);

    CustomUserController.$inject = ['$state', 'CustomUser', 'CustomUserSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomUserController($state, CustomUser, CustomUserSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CustomUserSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CustomUser.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customUsers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomActivityDialogController', CustomActivityDialogController);

    CustomActivityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomActivity'];

    function CustomActivityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomActivity) {
        var vm = this;

        vm.customActivity = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customActivity.id !== null) {
                CustomActivity.update(vm.customActivity, onSaveSuccess, onSaveError);
            } else {
                CustomActivity.save(vm.customActivity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:customActivityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationTime = false;
        vm.datePickerOpenStatus.validUntil = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomActivityDetailController', CustomActivityDetailController);

    CustomActivityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomActivity'];

    function CustomActivityDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomActivity) {
        var vm = this;

        vm.customActivity = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:customActivityUpdate', function(event, result) {
            vm.customActivity = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomActivityDeleteController',CustomActivityDeleteController);

    CustomActivityDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomActivity'];

    function CustomActivityDeleteController($uibModalInstance, entity, CustomActivity) {
        var vm = this;

        vm.customActivity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomActivity.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custom-activity', {
            parent: 'entity',
            url: '/custom-activity?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.customActivity.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-activity/custom-activities.html',
                    controller: 'CustomActivityController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customActivity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custom-activity-detail', {
            parent: 'custom-activity',
            url: '/custom-activity/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.customActivity.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custom-activity/custom-activity-detail.html',
                    controller: 'CustomActivityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customActivity');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomActivity', function($stateParams, CustomActivity) {
                    return CustomActivity.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custom-activity',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custom-activity-detail.edit', {
            parent: 'custom-activity-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-activity/custom-activity-dialog.html',
                    controller: 'CustomActivityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomActivity', function(CustomActivity) {
                            return CustomActivity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-activity.new', {
            parent: 'custom-activity',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-activity/custom-activity-dialog.html',
                    controller: 'CustomActivityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                content: null,
                                link: null,
                                creationTime: null,
                                validUntil: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custom-activity', null, { reload: 'custom-activity' });
                }, function() {
                    $state.go('custom-activity');
                });
            }]
        })
        .state('custom-activity.edit', {
            parent: 'custom-activity',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-activity/custom-activity-dialog.html',
                    controller: 'CustomActivityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomActivity', function(CustomActivity) {
                            return CustomActivity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-activity', null, { reload: 'custom-activity' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custom-activity.delete', {
            parent: 'custom-activity',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custom-activity/custom-activity-delete-dialog.html',
                    controller: 'CustomActivityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomActivity', function(CustomActivity) {
                            return CustomActivity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custom-activity', null, { reload: 'custom-activity' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('CustomActivity', CustomActivity);

    CustomActivity.$inject = ['$resource', 'DateUtils'];

    function CustomActivity ($resource, DateUtils) {
        var resourceUrl =  'api/custom-activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationTime = DateUtils.convertDateTimeFromServer(data.creationTime);
                        data.validUntil = DateUtils.convertDateTimeFromServer(data.validUntil);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('CustomActivitySearch', CustomActivitySearch);

    CustomActivitySearch.$inject = ['$resource'];

    function CustomActivitySearch($resource) {
        var resourceUrl =  'api/_search/custom-activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CustomActivityController', CustomActivityController);

    CustomActivityController.$inject = ['$state', 'CustomActivity', 'CustomActivitySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomActivityController($state, CustomActivity, CustomActivitySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CustomActivitySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CustomActivity.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customActivities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CommentDialogController', CommentDialogController);

    CommentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comment', 'CustomUser', 'SpecificQuestion', 'Answer', 'FrequentlyAskedQuestion', 'Handbook'];

    function CommentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comment, CustomUser, SpecificQuestion, Answer, FrequentlyAskedQuestion, Handbook) {
        var vm = this;

        vm.comment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customusers = CustomUser.query();
        vm.specificquestions = SpecificQuestion.query();
        vm.answers = Answer.query();
        vm.frequentlyaskedquestions = FrequentlyAskedQuestion.query();
        vm.handbooks = Handbook.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.comment.id !== null) {
                Comment.update(vm.comment, onSaveSuccess, onSaveError);
            } else {
                Comment.save(vm.comment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:commentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationtime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CommentDetailController', CommentDetailController);

    CommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comment', 'CustomUser', 'SpecificQuestion', 'Answer', 'FrequentlyAskedQuestion', 'Handbook'];

    function CommentDetailController($scope, $rootScope, $stateParams, previousState, entity, Comment, CustomUser, SpecificQuestion, Answer, FrequentlyAskedQuestion, Handbook) {
        var vm = this;

        vm.comment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:commentUpdate', function(event, result) {
            vm.comment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CommentDeleteController',CommentDeleteController);

    CommentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comment'];

    function CommentDeleteController($uibModalInstance, entity, Comment) {
        var vm = this;

        vm.comment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comment', {
            parent: 'entity',
            url: '/comment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.comment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comment/comments.html',
                    controller: 'CommentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comment-detail', {
            parent: 'comment',
            url: '/comment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.comment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comment/comment-detail.html',
                    controller: 'CommentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comment', function($stateParams, Comment) {
                    return Comment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comment-detail.edit', {
            parent: 'comment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comment/comment-dialog.html',
                    controller: 'CommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comment', function(Comment) {
                            return Comment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comment.new', {
            parent: 'comment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comment/comment-dialog.html',
                    controller: 'CommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                creationtime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comment', null, { reload: 'comment' });
                }, function() {
                    $state.go('comment');
                });
            }]
        })
        .state('comment.edit', {
            parent: 'comment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comment/comment-dialog.html',
                    controller: 'CommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comment', function(Comment) {
                            return Comment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comment', null, { reload: 'comment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comment.delete', {
            parent: 'comment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                    controller: 'CommentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comment', function(Comment) {
                            return Comment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comment', null, { reload: 'comment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('Comment', Comment);

    Comment.$inject = ['$resource', 'DateUtils'];

    function Comment ($resource, DateUtils) {
        var resourceUrl =  'api/comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationtime = DateUtils.convertDateTimeFromServer(data.creationtime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('CommentSearch', CommentSearch);

    CommentSearch.$inject = ['$resource'];

    function CommentSearch($resource) {
        var resourceUrl =  'api/_search/comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CommentController', CommentController);

    CommentController.$inject = ['$state', 'Comment', 'CommentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CommentController($state, Comment, CommentSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CommentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Comment.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.comments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('AnswerDialogController', AnswerDialogController);

    AnswerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Answer', 'SpecificQuestion', 'CustomUser', 'Comment', 'Task'];

    function AnswerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Answer, SpecificQuestion, CustomUser, Comment, Task) {
        var vm = this;

        vm.answer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.specificquestions = SpecificQuestion.query();
        vm.customusers = CustomUser.query();
        vm.comments = Comment.query();
        vm.tasks = Task.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.answer.id !== null) {
                Answer.update(vm.answer, onSaveSuccess, onSaveError);
            } else {
                Answer.save(vm.answer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:answerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationtime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('AnswerDetailController', AnswerDetailController);

    AnswerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Answer', 'SpecificQuestion', 'CustomUser', 'Comment', 'Task'];

    function AnswerDetailController($scope, $rootScope, $stateParams, previousState, entity, Answer, SpecificQuestion, CustomUser, Comment, Task) {
        var vm = this;

        vm.answer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:answerUpdate', function(event, result) {
            vm.answer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('AnswerDeleteController',AnswerDeleteController);

    AnswerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Answer'];

    function AnswerDeleteController($uibModalInstance, entity, Answer) {
        var vm = this;

        vm.answer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Answer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('answer', {
            parent: 'entity',
            url: '/answer?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.answer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/answer/answers.html',
                    controller: 'AnswerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('answer');
                    $translatePartialLoader.addPart('answerState');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('answer-detail', {
            parent: 'answer',
            url: '/answer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.answer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/answer/answer-detail.html',
                    controller: 'AnswerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('answer');
                    $translatePartialLoader.addPart('answerState');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Answer', function($stateParams, Answer) {
                    return Answer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'answer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('answer-detail.edit', {
            parent: 'answer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/answer/answer-dialog.html',
                    controller: 'AnswerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Answer', function(Answer) {
                            return Answer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('answer.new', {
            parent: 'answer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/answer/answer-dialog.html',
                    controller: 'AnswerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                content: null,
                                creationtime: null,
                                asnwerstate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('answer', null, { reload: 'answer' });
                }, function() {
                    $state.go('answer');
                });
            }]
        })
        .state('answer.edit', {
            parent: 'answer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/answer/answer-dialog.html',
                    controller: 'AnswerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Answer', function(Answer) {
                            return Answer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('answer', null, { reload: 'answer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('answer.delete', {
            parent: 'answer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/answer/answer-delete-dialog.html',
                    controller: 'AnswerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Answer', function(Answer) {
                            return Answer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('answer', null, { reload: 'answer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('Answer', Answer);

    Answer.$inject = ['$resource', 'DateUtils'];

    function Answer ($resource, DateUtils) {
        var resourceUrl =  'api/answers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationtime = DateUtils.convertDateTimeFromServer(data.creationtime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('AnswerSearch', AnswerSearch);

    AnswerSearch.$inject = ['$resource'];

    function AnswerSearch($resource) {
        var resourceUrl =  'api/_search/answers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('AnswerController', AnswerController);

    AnswerController.$inject = ['$state', 'Answer', 'AnswerSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AnswerController($state, Answer, AnswerSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AnswerSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Answer.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.answers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('teJHipsterApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'cs',
            'en',
            'sk'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('teJHipsterApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('teJHipsterApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('teJHipsterApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('teJHipsterApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('teJHipsterApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                config.headers.Authorization = 'Bearer ' + token.access_token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "cs"');
                $cookies.putObject(name, 'cs');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('cs');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('teJHipsterApp')
        .constant('VERSION', "1.1.0-release198")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_EXPERT', 'ROLE_SALESMAN', 'ROLE_AUDITOR', 'ROLE_TRASH', 'ROLE_SQ_ASSIGN_TO_EXPERTS', 'ROLE_SQ_PROCESS_ANSWER', 'ROLE_SERVICEMAN', 'ROLE_FAQ_PUBLISH'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'UserSearch', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, UserSearch, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_EXPERT', 'ROLE_SALESMAN', 'ROLE_AUDITOR', 'ROLE_TRASH', 'ROLE_SQ_ASSIGN_TO_EXPERTS', 'ROLE_SQ_PROCESS_ANSWER', 'ROLE_SERVICEMAN', 'ROLE_FAQ_PUBLISH'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            if (pagingParams.search) {
            	UserSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
            	User.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('teJHipsterApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ActivateController', ActivateController);

    ActivateController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivateController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('teJHipsterApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><p class="lead" data-translate="home.subtitle">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div></div><p data-translate="home.question">If you have any question on JHipster:</p><ul><li><a href="http://jhipster.github.io/" target="_blank" data-translate="home.link.homepage">JHipster homepage</a></li><li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li><li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" data-translate="home.link.bugtracker">JHipster bug tracker</a></li><li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" data-translate="home.link.chat">JHipster public chat room</a></li><li><a href="https://twitter.com/java_hipster" target="_blank" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li></ul><p><span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" data-translate="home.github">Github</a>!</p></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline" ng-submit="vm.search()"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'userManagement.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><div class="row"></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span data-translate="userManagement.firstName">First name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span data-translate="userManagement.lastName">Last name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td><a ui-sref="user-management-detail({login:user.login})">{{user.login}}</a></td><td>{{user.email}}</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/answer/answer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.answer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.answer.delete.question" translate-values="{id: \'{{vm.answer.id}}\'}">Are you sure you want to delete this Answer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/answer/answer-detail.html','<div><h2><span data-translate="teJHipsterApp.answer.detail.title">Answer</span> {{vm.answer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.answer.content">Content</span></dt><dd><span>{{vm.answer.content}}</span></dd><dt><span data-translate="teJHipsterApp.answer.creationtime">Creationtime</span></dt><dd><span>{{vm.answer.creationtime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.answer.asnwerstate">Asnwerstate</span></dt><dd><span data-translate="{{\'teJHipsterApp.AnswerState.\' + vm.answer.asnwerstate}}">{{vm.answer.asnwerstate}}</span></dd><dt><span data-translate="teJHipsterApp.answer.specificQuestion">Specific Question</span></dt><dd><a ui-sref="specific-question-detail({id:vm.answer.specificQuestionId})">{{vm.answer.specificQuestionId}}</a></dd><dt><span data-translate="teJHipsterApp.answer.author">Author</span></dt><dd><a ui-sref="custom-user-detail({id:vm.answer.authorId})">{{vm.answer.authorEmail}}</a></dd><dt><span data-translate="teJHipsterApp.answer.commments">Commments</span></dt><dd><span ng-repeat="commments in vm.answer.commments"><a ui-sref="comment-detail({id: commments.id})">{{commments.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="teJHipsterApp.answer.tasks">Tasks</span></dt><dd><span ng-repeat="tasks in vm.answer.tasks"><a ui-sref="task-detail({id: tasks.id})">{{tasks.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="answer-detail.edit({id:vm.answer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/answer/answer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAnswerLabel" data-translate="teJHipsterApp.answer.home.createOrEditLabel">Create or edit a Answer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.answer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.answer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.answer.content" for="field_content">Content</label><input type="text" class="form-control" name="content" id="field_content" ng-model="vm.answer.content"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.answer.creationtime" for="field_creationtime">Creationtime</label><div class="input-group"><input id="field_creationtime" type="text" class="form-control" name="creationtime" datetime-picker="{{dateformat}}" ng-model="vm.answer.creationtime" is-open="vm.datePickerOpenStatus.creationtime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationtime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.creationtime.$invalid"><p class="help-block" ng-show="editForm.creationtime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.creationtime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.answer.asnwerstate" for="field_asnwerstate">Asnwerstate</label><select class="form-control" name="asnwerstate" ng-model="vm.answer.asnwerstate" id="field_asnwerstate" required><option value="CREATED" data-translate="teJHipsterApp.AnswerState.CREATED">CREATED</option><option value="DONE" data-translate="teJHipsterApp.AnswerState.DONE">DONE</option><option value="REJECTED" data-translate="teJHipsterApp.AnswerState.REJECTED">REJECTED</option></select><div ng-show="editForm.asnwerstate.$invalid"><p class="help-block" ng-show="editForm.asnwerstate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="teJHipsterApp.answer.specificQuestion" for="field_specificQuestion">Specific Question</label><select class="form-control" id="field_specificQuestion" name="specificQuestion" ng-model="vm.answer.specificQuestionId" ng-options="specificQuestion.id as specificQuestion.id for specificQuestion in vm.specificquestions"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.answer.author" for="field_author">Author</label><select class="form-control" id="field_author" name="author" ng-model="vm.answer.authorId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.author.$invalid"><p class="help-block" ng-show="editForm.author.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.answer.commments" for="field_commments">Commments</label><select class="form-control" id="field_commments" multiple="multiple" name="commments" ng-model="vm.answer.commments" ng-options="comment as comment.id for comment in vm.comments track by comment.id"></select></div><div class="form-group"><label data-translate="teJHipsterApp.answer.tasks" for="field_tasks">Tasks</label><select class="form-control" id="field_tasks" multiple="multiple" name="tasks" ng-model="vm.answer.tasks" ng-options="task as task.id for task in vm.tasks track by task.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/answer/answers.html','<div><h2 data-translate="teJHipsterApp.answer.home.title">Answers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="answer.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.answer.home.createLabel">Create new Answer</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.answer.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span data-translate="teJHipsterApp.answer.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationtime"><span data-translate="teJHipsterApp.answer.creationtime">Creationtime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="asnwerstate"><span data-translate="teJHipsterApp.answer.asnwerstate">Asnwerstate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="specificQuestionId"><span data-translate="teJHipsterApp.answer.specificQuestion">Specific Question</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="authorEmail"><span data-translate="teJHipsterApp.answer.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="answer in vm.answers track by answer.id"><td><a ui-sref="answer-detail({id:answer.id})">{{answer.id}}</a></td><td>{{answer.content}}</td><td>{{answer.creationtime | date:\'medium\'}}</td><td data-translate="{{\'teJHipsterApp.AnswerState.\' + answer.asnwerstate}}">{{answer.asnwerstate}}</td><td><a ui-sref="specific-question-detail({id:answer.specificQuestionId})">{{answer.specificQuestionId}}</a></td><td><a ui-sref="custom-user-detail({id:answer.authorId})">{{answer.authorEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="answer-detail({id:answer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="answer.edit({id:answer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="answer.delete({id:answer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/comment/comment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.comment.delete.question" translate-values="{id: \'{{vm.comment.id}}\'}">Are you sure you want to delete this Comment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/comment/comment-detail.html','<div><h2><span data-translate="teJHipsterApp.comment.detail.title">Comment</span> {{vm.comment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.comment.content">Content</span></dt><dd><span>{{vm.comment.content}}</span></dd><dt><span data-translate="teJHipsterApp.comment.creationtime">Creationtime</span></dt><dd><span>{{vm.comment.creationtime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.comment.author">Author</span></dt><dd><a ui-sref="custom-user-detail({id:vm.comment.authorId})">{{vm.comment.authorEmail}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="comment-detail.edit({id:vm.comment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/comment/comment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCommentLabel" data-translate="teJHipsterApp.comment.home.createOrEditLabel">Create or edit a Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.comment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.comment.content" for="field_content">Content</label><input type="text" class="form-control" name="content" id="field_content" ng-model="vm.comment.content" required><div ng-show="editForm.content.$invalid"><p class="help-block" ng-show="editForm.content.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.comment.creationtime" for="field_creationtime">Creationtime</label><div class="input-group"><input id="field_creationtime" type="text" class="form-control" name="creationtime" datetime-picker="{{dateformat}}" ng-model="vm.comment.creationtime" is-open="vm.datePickerOpenStatus.creationtime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationtime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.creationtime.$invalid"><p class="help-block" ng-show="editForm.creationtime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.creationtime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label data-translate="teJHipsterApp.comment.author" for="field_author">Author</label><select class="form-control" id="field_author" name="author" ng-model="vm.comment.authorId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.author.$invalid"><p class="help-block" ng-show="editForm.author.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/comment/comments.html','<div><h2 data-translate="teJHipsterApp.comment.home.title">Comments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="comment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.comment.home.createLabel">Create new Comment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.comment.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span data-translate="teJHipsterApp.comment.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationtime"><span data-translate="teJHipsterApp.comment.creationtime">Creationtime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="authorEmail"><span data-translate="teJHipsterApp.comment.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="comment in vm.comments track by comment.id"><td><a ui-sref="comment-detail({id:comment.id})">{{comment.id}}</a></td><td>{{comment.content}}</td><td>{{comment.creationtime | date:\'medium\'}}</td><td><a ui-sref="custom-user-detail({id:comment.authorId})">{{comment.authorEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="comment-detail({id:comment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="comment.edit({id:comment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="comment.delete({id:comment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/custom-activity/custom-activities.html','<div><h2 data-translate="teJHipsterApp.customActivity.home.title">Custom Activities</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custom-activity.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.customActivity.home.createLabel">Create new Custom Activity</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.customActivity.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span data-translate="teJHipsterApp.customActivity.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span data-translate="teJHipsterApp.customActivity.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="link"><span data-translate="teJHipsterApp.customActivity.link">Link</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationTime"><span data-translate="teJHipsterApp.customActivity.creationTime">Creation Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validUntil"><span data-translate="teJHipsterApp.customActivity.validUntil">Valid Until</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="customActivity in vm.customActivities track by customActivity.id"><td><a ui-sref="custom-activity-detail({id:customActivity.id})">{{customActivity.id}}</a></td><td>{{customActivity.title}}</td><td>{{customActivity.content}}</td><td>{{customActivity.link}}</td><td>{{customActivity.creationTime | date:\'medium\'}}</td><td>{{customActivity.validUntil | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custom-activity-detail({id:customActivity.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custom-activity.edit({id:customActivity.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custom-activity.delete({id:customActivity.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/custom-activity/custom-activity-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customActivity.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.customActivity.delete.question" translate-values="{id: \'{{vm.customActivity.id}}\'}">Are you sure you want to delete this Custom Activity?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-activity/custom-activity-detail.html','<div><h2><span data-translate="teJHipsterApp.customActivity.detail.title">Custom Activity</span> {{vm.customActivity.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.customActivity.title">Title</span></dt><dd><span>{{vm.customActivity.title}}</span></dd><dt><span data-translate="teJHipsterApp.customActivity.content">Content</span></dt><dd><span>{{vm.customActivity.content}}</span></dd><dt><span data-translate="teJHipsterApp.customActivity.link">Link</span></dt><dd><span>{{vm.customActivity.link}}</span></dd><dt><span data-translate="teJHipsterApp.customActivity.creationTime">Creation Time</span></dt><dd><span>{{vm.customActivity.creationTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.customActivity.validUntil">Valid Until</span></dt><dd><span>{{vm.customActivity.validUntil | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-activity-detail.edit({id:vm.customActivity.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-activity/custom-activity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomActivityLabel" data-translate="teJHipsterApp.customActivity.home.createOrEditLabel">Create or edit a Custom Activity</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.customActivity.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.customActivity.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customActivity.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.customActivity.title"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customActivity.content" for="field_content">Content</label><input type="text" class="form-control" name="content" id="field_content" ng-model="vm.customActivity.content"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customActivity.link" for="field_link">Link</label><input type="text" class="form-control" name="link" id="field_link" ng-model="vm.customActivity.link"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customActivity.creationTime" for="field_creationTime">Creation Time</label><div class="input-group"><input id="field_creationTime" type="text" class="form-control" name="creationTime" datetime-picker="{{dateformat}}" ng-model="vm.customActivity.creationTime" is-open="vm.datePickerOpenStatus.creationTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customActivity.validUntil" for="field_validUntil">Valid Until</label><div class="input-group"><input id="field_validUntil" type="text" class="form-control" name="validUntil" datetime-picker="{{dateformat}}" ng-model="vm.customActivity.validUntil" is-open="vm.datePickerOpenStatus.validUntil"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validUntil\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custom-user/custom-user-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customUser.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.customUser.delete.question" translate-values="{id: \'{{vm.customUser.id}}\'}">Are you sure you want to delete this Custom User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custom-user/custom-user-detail.html','<div><h2><span data-translate="teJHipsterApp.customUser.detail.title">Custom User</span> {{vm.customUser.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.customUser.email">Email</span></dt><dd><span>{{vm.customUser.email}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.phone">Phone</span></dt><dd><span>{{vm.customUser.phone}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.lastLogin">Last Login</span></dt><dd><span>{{vm.customUser.lastLogin | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.visId">Vis Id</span></dt><dd><span>{{vm.customUser.visId}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.termsApproved">Terms Approved</span></dt><dd><span>{{vm.customUser.termsApproved}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.dailyNewsActivated">Daily News Activated</span></dt><dd><span>{{vm.customUser.dailyNewsActivated}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.processingOfPersonalDataAgreementForApp">Processing Of Personal Data Agreement For App</span></dt><dd><span>{{vm.customUser.processingOfPersonalDataAgreementForApp}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.processingOfPersonalDataAgreementForMarketing">Processing Of Personal Data Agreement For Marketing</span></dt><dd><span>{{vm.customUser.processingOfPersonalDataAgreementForMarketing}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.processingOfPersonalDataContractAgreement">Processing Of Personal Data Contract Agreement</span></dt><dd><span>{{vm.customUser.processingOfPersonalDataContractAgreement | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.customUser.user">User</span></dt><dd>{{vm.customUser.userEmail}}</dd><dt><span data-translate="teJHipsterApp.customUser.primaryProfessionalArea">Primary Professional Area</span></dt><dd><a ui-sref="professional-area-detail({id:vm.customUser.primaryProfessionalAreaId})">{{vm.customUser.primaryProfessionalAreaName}}</a></dd><dt><span data-translate="teJHipsterApp.customUser.secondaryProfessionalAreas">Secondary Professional Areas</span></dt><dd><span ng-repeat="secondaryProfessionalAreas in vm.customUser.secondaryProfessionalAreas"><a ui-sref="professional-area-detail({id: secondaryProfessionalAreas.id})">{{secondaryProfessionalAreas.name}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custom-user-detail.edit({id:vm.customUser.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custom-user/custom-user-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomUserLabel" data-translate="teJHipsterApp.customUser.home.createOrEditLabel">Create or edit a Custom User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.customUser.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.customUser.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.customUser.email"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.customUser.phone"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.lastLogin" for="field_lastLogin">Last Login</label><div class="input-group"><input id="field_lastLogin" type="text" class="form-control" name="lastLogin" datetime-picker="{{dateformat}}" ng-model="vm.customUser.lastLogin" is-open="vm.datePickerOpenStatus.lastLogin"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastLogin\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.visId" for="field_visId">Vis Id</label><input type="number" class="form-control" name="visId" id="field_visId" ng-model="vm.customUser.visId"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.termsApproved" for="field_termsApproved">Terms Approved</label><input type="checkbox" name="termsApproved" id="field_termsApproved" ng-model="vm.customUser.termsApproved"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.dailyNewsActivated" for="field_dailyNewsActivated">Daily News Activated</label><input type="checkbox" name="dailyNewsActivated" id="field_dailyNewsActivated" ng-model="vm.customUser.dailyNewsActivated"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.processingOfPersonalDataAgreementForApp" for="field_processingOfPersonalDataAgreementForApp">Processing Of Personal Data Agreement For App</label><input type="checkbox" name="processingOfPersonalDataAgreementForApp" id="field_processingOfPersonalDataAgreementForApp" ng-model="vm.customUser.processingOfPersonalDataAgreementForApp"><div ng-show="editForm.processingOfPersonalDataAgreementForApp.$invalid"><p class="help-block" ng-show="editForm.processingOfPersonalDataAgreementForApp.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.processingOfPersonalDataAgreementForMarketing" for="field_processingOfPersonalDataAgreementForMarketing">Processing Of Personal Data Agreement For Marketing</label><input type="checkbox" name="processingOfPersonalDataAgreementForMarketing" id="field_processingOfPersonalDataAgreementForMarketing" ng-model="vm.customUser.processingOfPersonalDataAgreementForMarketing"><div ng-show="editForm.processingOfPersonalDataAgreementForMarketing.$invalid"><p class="help-block" ng-show="editForm.processingOfPersonalDataAgreementForMarketing.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.customUser.processingOfPersonalDataContractAgreement" for="field_processingOfPersonalDataContractAgreement">Processing Of Personal Data Contract Agreement</label><div class="input-group"><input id="field_processingOfPersonalDataContractAgreement" type="text" class="form-control" name="processingOfPersonalDataContractAgreement" datetime-picker="{{dateformat}}" ng-model="vm.customUser.processingOfPersonalDataContractAgreement" is-open="vm.datePickerOpenStatus.processingOfPersonalDataContractAgreement"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'processingOfPersonalDataContractAgreement\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="teJHipsterApp.customUser.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.customUser.userId" ng-options="user.id as user.email for user in vm.users"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.customUser.primaryProfessionalArea" for="field_primaryProfessionalArea">Primary Professional Area</label><select class="form-control" id="field_primaryProfessionalArea" name="primaryProfessionalArea" ng-model="vm.customUser.primaryProfessionalAreaId" ng-options="professionalArea.id as professionalArea.name for professionalArea in vm.professionalareas"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.customUser.secondaryProfessionalAreas" for="field_secondaryProfessionalAreas">Secondary Professional Areas</label><select class="form-control" id="field_secondaryProfessionalAreas" multiple="multiple" name="secondaryProfessionalAreas" ng-model="vm.customUser.secondaryProfessionalAreas" ng-options="professionalArea as professionalArea.name for professionalArea in vm.professionalareas track by professionalArea.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custom-user/custom-users.html','<div><h2 data-translate="teJHipsterApp.customUser.home.title">Custom Users</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custom-user.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.customUser.home.createLabel">Create new Custom User</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.customUser.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="teJHipsterApp.customUser.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span data-translate="teJHipsterApp.customUser.phone">Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastLogin"><span data-translate="teJHipsterApp.customUser.lastLogin">Last Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visId"><span data-translate="teJHipsterApp.customUser.visId">Vis Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="termsApproved"><span data-translate="teJHipsterApp.customUser.termsApproved">Terms Approved</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dailyNewsActivated"><span data-translate="teJHipsterApp.customUser.dailyNewsActivated">Daily News Activated</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processingOfPersonalDataAgreementForApp"><span data-translate="teJHipsterApp.customUser.processingOfPersonalDataAgreementForApp">Processing Of Personal Data Agreement For App</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processingOfPersonalDataAgreementForMarketing"><span data-translate="teJHipsterApp.customUser.processingOfPersonalDataAgreementForMarketing">Processing Of Personal Data Agreement For Marketing</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="processingOfPersonalDataContractAgreement"><span data-translate="teJHipsterApp.customUser.processingOfPersonalDataContractAgreement">Processing Of Personal Data Contract Agreement</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userEmail"><span data-translate="teJHipsterApp.customUser.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="primaryProfessionalAreaName"><span data-translate="teJHipsterApp.customUser.primaryProfessionalArea">Primary Professional Area</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="customUser in vm.customUsers track by customUser.id"><td><a ui-sref="custom-user-detail({id:customUser.id})">{{customUser.id}}</a></td><td>{{customUser.email}}</td><td>{{customUser.phone}}</td><td>{{customUser.lastLogin | date:\'medium\'}}</td><td>{{customUser.visId}}</td><td>{{customUser.termsApproved}}</td><td>{{customUser.dailyNewsActivated}}</td><td>{{customUser.processingOfPersonalDataAgreementForApp}}</td><td>{{customUser.processingOfPersonalDataAgreementForMarketing}}</td><td>{{customUser.processingOfPersonalDataContractAgreement | date:\'medium\'}}</td><td>{{customUser.userEmail}}</td><td><a ui-sref="professional-area-detail({id:customUser.primaryProfessionalAreaId})">{{customUser.primaryProfessionalAreaName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custom-user-detail({id:customUser.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custom-user.edit({id:customUser.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custom-user.delete({id:customUser.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/file/file-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.file.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.file.delete.question" translate-values="{id: \'{{vm.file.id}}\'}">Are you sure you want to delete this File?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/file/file-detail.html','<div><h2><span data-translate="teJHipsterApp.file.detail.title">File</span> {{vm.file.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.file.name">Name</span></dt><dd><span>{{vm.file.name}}</span></dd><dt><span data-translate="teJHipsterApp.file.description">Description</span></dt><dd><span>{{vm.file.description}}</span></dd><dt><span data-translate="teJHipsterApp.file.size">Size</span></dt><dd><span>{{vm.file.size}}</span></dd><dt><span data-translate="teJHipsterApp.file.uploadTime">Upload Time</span></dt><dd><span>{{vm.file.uploadTime | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="file-detail.edit({id:vm.file.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/file/file-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFileLabel" data-translate="teJHipsterApp.file.home.createOrEditLabel">Create or edit a File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.file.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.file.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.file.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.file.name"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.file.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.file.description"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.file.size" for="field_size">Size</label><input type="number" class="form-control" name="size" id="field_size" ng-model="vm.file.size"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.file.uploadTime" for="field_uploadTime">Upload Time</label><div class="input-group"><input id="field_uploadTime" type="text" class="form-control" name="uploadTime" datetime-picker="{{dateformat}}" ng-model="vm.file.uploadTime" is-open="vm.datePickerOpenStatus.uploadTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'uploadTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.uploadTime.$invalid"><p class="help-block" ng-show="editForm.uploadTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.uploadTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/file/files.html','<div><h2 data-translate="teJHipsterApp.file.home.title">Files</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="file.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.file.home.createLabel">Create new File</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.file.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="teJHipsterApp.file.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="teJHipsterApp.file.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="size"><span data-translate="teJHipsterApp.file.size">Size</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="uploadTime"><span data-translate="teJHipsterApp.file.uploadTime">Upload Time</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="file in vm.files track by file.id"><td><a ui-sref="file-detail({id:file.id})">{{file.id}}</a></td><td>{{file.name}}</td><td>{{file.description}}</td><td>{{file.size}}</td><td>{{file.uploadTime | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="file-detail({id:file.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="file.edit({id:file.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="file.delete({id:file.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/file-content/file-content-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.fileContent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.fileContent.delete.question" translate-values="{id: \'{{vm.fileContent.id}}\'}">Are you sure you want to delete this File Content?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/file-content/file-content-detail.html','<div><h2><span data-translate="teJHipsterApp.fileContent.detail.title">File Content</span> {{vm.fileContent.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.fileContent.content">Content</span></dt><dd><div ng-if="vm.fileContent.content"><a ng-click="vm.openFile(vm.fileContent.contentContentType, vm.fileContent.content)" data-translate="entity.action.open">open</a> {{vm.fileContent.contentContentType}}, {{vm.byteSize(vm.fileContent.content)}}</div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="file-content-detail.edit({id:vm.fileContent.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/file-content/file-content-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFileContentLabel" data-translate="teJHipsterApp.fileContent.home.createOrEditLabel">Create or edit a File Content</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.fileContent.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.fileContent.id" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setContent($file, vm.fileContent)"><label class="control-label" data-translate="teJHipsterApp.fileContent.content" for="field_content">Content</label><div><div ng-if="vm.fileContent.content" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.fileContent.contentContentType, vm.fileContent.content)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.fileContent.contentContentType}}, {{vm.byteSize(vm.fileContent.content)}}</span> <button type="button" ng-click="vm.fileContent.content=null;vm.fileContent.contentContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setContent($file, vm.fileContent)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="content" id="field_content" ng-model="vm.fileContent.content"> <input type="hidden" class="form-control" name="contentContentType" id="field_contentContentType" ng-model="vm.fileContent.contentContentType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/file-content/file-contents.html','<div><h2 data-translate="teJHipsterApp.fileContent.home.title">File Contents</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="file-content.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.fileContent.home.createLabel">Create new File Content</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.fileContent.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="teJHipsterApp.fileContent.content">Content</span></th><th></th></tr></thead><tbody><tr ng-repeat="fileContent in vm.fileContents track by fileContent.id"><td><a ui-sref="file-content-detail({id:fileContent.id})">{{fileContent.id}}</a></td><td><a ng-if="fileContent.content" ng-click="vm.openFile(fileContent.contentContentType, fileContent.content)" data-translate="entity.action.open">open</a> <span ng-if="fileContent.content">{{fileContent.contentContentType}}, {{vm.byteSize(fileContent.content)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="file-content-detail({id:fileContent.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="file-content.edit({id:fileContent.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="file-content.delete({id:fileContent.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/frequently-asked-question/frequently-asked-question-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.frequentlyAskedQuestion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.frequentlyAskedQuestion.delete.question" translate-values="{id: \'{{vm.frequentlyAskedQuestion.id}}\'}">Are you sure you want to delete this Frequently Asked Question?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/frequently-asked-question/frequently-asked-question-detail.html','<div><h2><span data-translate="teJHipsterApp.frequentlyAskedQuestion.detail.title">Frequently Asked Question</span> {{vm.frequentlyAskedQuestion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.name">Name</span></dt><dd><span>{{vm.frequentlyAskedQuestion.name}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.question">Question</span></dt><dd><span>{{vm.frequentlyAskedQuestion.question}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.answer">Answer</span></dt><dd><span>{{vm.frequentlyAskedQuestion.answer}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.faqstate">Faqstate</span></dt><dd><span data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionState.\' + vm.frequentlyAskedQuestion.faqstate}}">{{vm.frequentlyAskedQuestion.faqstate}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.visibleFor">Visible For</span></dt><dd><span data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionVisibleFor.\' + vm.frequentlyAskedQuestion.visibleFor}}">{{vm.frequentlyAskedQuestion.visibleFor}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.creationTime">Creation Time</span></dt><dd><span>{{vm.frequentlyAskedQuestion.creationTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.updateTime">Update Time</span></dt><dd><span>{{vm.frequentlyAskedQuestion.updateTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.revisionTime">Revision Time</span></dt><dd><span>{{vm.frequentlyAskedQuestion.revisionTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.priority">Priority</span></dt><dd><span>{{vm.frequentlyAskedQuestion.priority}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.author">Author</span></dt><dd><a ui-sref="custom-user-detail({id:vm.frequentlyAskedQuestion.authorId})">{{vm.frequentlyAskedQuestion.authorEmail}}</a></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.comments">Comments</span></dt><dd><span ng-repeat="comments in vm.frequentlyAskedQuestion.comments"><a ui-sref="comment-detail({id: comments.id})">{{comments.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.tasks">Tasks</span></dt><dd><span ng-repeat="tasks in vm.frequentlyAskedQuestion.tasks"><a ui-sref="task-detail({id: tasks.id})">{{tasks.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.professionalArea">Professional Area</span></dt><dd><a ui-sref="professional-area-detail({id:vm.frequentlyAskedQuestion.professionalAreaId})">{{vm.frequentlyAskedQuestion.professionalAreaName}}</a></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.secondaryProfessionalAreas">Secondary Professional Areas</span></dt><dd><span ng-repeat="secondaryProfessionalAreas in vm.frequentlyAskedQuestion.secondaryProfessionalAreas"><a ui-sref="professional-area-detail({id: secondaryProfessionalAreas.id})">{{secondaryProfessionalAreas.name}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestion.originalSQAnswer">Original SQ Answer</span></dt><dd><a ui-sref="answer-detail({id:vm.frequentlyAskedQuestion.originalSQAnswerId})">{{vm.frequentlyAskedQuestion.originalSQAnswerId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="frequently-asked-question-detail.edit({id:vm.frequentlyAskedQuestion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/frequently-asked-question/frequently-asked-question-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFrequentlyAskedQuestionLabel" data-translate="teJHipsterApp.frequentlyAskedQuestion.home.createOrEditLabel">Create or edit a Frequently Asked Question</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.frequentlyAskedQuestion.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.frequentlyAskedQuestion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.frequentlyAskedQuestion.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.question" for="field_question">Question</label><input type="text" class="form-control" name="question" id="field_question" ng-model="vm.frequentlyAskedQuestion.question" required><div ng-show="editForm.question.$invalid"><p class="help-block" ng-show="editForm.question.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.answer" for="field_answer">Answer</label><input type="text" class="form-control" name="answer" id="field_answer" ng-model="vm.frequentlyAskedQuestion.answer" required><div ng-show="editForm.answer.$invalid"><p class="help-block" ng-show="editForm.answer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.faqstate" for="field_faqstate">Faqstate</label><select class="form-control" name="faqstate" ng-model="vm.frequentlyAskedQuestion.faqstate" id="field_faqstate" required><option value="CREATED" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.CREATED">CREATED</option><option value="DONE" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.DONE">DONE</option><option value="READY_FOR_PUBLICATION" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.READY_FOR_PUBLICATION">READY_FOR_PUBLICATION</option><option value="PUBLIC" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.PUBLIC">PUBLIC</option></select><div ng-show="editForm.faqstate.$invalid"><p class="help-block" ng-show="editForm.faqstate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.visibleFor" for="field_visibleFor">Visible For</label><select class="form-control" name="visibleFor" ng-model="vm.frequentlyAskedQuestion.visibleFor" id="field_visibleFor"><option value="ANONYMOUS" data-translate="teJHipsterApp.FrequentlyAskedQuestionVisibleFor.ANONYMOUS">ANONYMOUS</option><option value="REGISTERED" data-translate="teJHipsterApp.FrequentlyAskedQuestionVisibleFor.REGISTERED">REGISTERED</option><option value="PAYER" data-translate="teJHipsterApp.FrequentlyAskedQuestionVisibleFor.PAYER">PAYER</option></select></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.creationTime" for="field_creationTime">Creation Time</label><div class="input-group"><input id="field_creationTime" type="text" class="form-control" name="creationTime" datetime-picker="{{dateformat}}" ng-model="vm.frequentlyAskedQuestion.creationTime" is-open="vm.datePickerOpenStatus.creationTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.updateTime" for="field_updateTime">Update Time</label><div class="input-group"><input id="field_updateTime" type="text" class="form-control" name="updateTime" datetime-picker="{{dateformat}}" ng-model="vm.frequentlyAskedQuestion.updateTime" is-open="vm.datePickerOpenStatus.updateTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updateTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.revisionTime" for="field_revisionTime">Revision Time</label><div class="input-group"><input id="field_revisionTime" type="text" class="form-control" name="revisionTime" datetime-picker="{{dateformat}}" ng-model="vm.frequentlyAskedQuestion.revisionTime" is-open="vm.datePickerOpenStatus.revisionTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'revisionTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestion.priority" for="field_priority">Priority</label><input type="number" class="form-control" name="priority" id="field_priority" ng-model="vm.frequentlyAskedQuestion.priority" required><div ng-show="editForm.priority.$invalid"><p class="help-block" ng-show="editForm.priority.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.priority.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestion.author" for="field_author">Author</label><select class="form-control" id="field_author" name="author" ng-model="vm.frequentlyAskedQuestion.authorId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.author.$invalid"><p class="help-block" ng-show="editForm.author.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestion.comments" for="field_comments">Comments</label><select class="form-control" id="field_comments" multiple="multiple" name="comments" ng-model="vm.frequentlyAskedQuestion.comments" ng-options="comment as comment.id for comment in vm.comments track by comment.id"></select></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestion.tasks" for="field_tasks">Tasks</label><select class="form-control" id="field_tasks" multiple="multiple" name="tasks" ng-model="vm.frequentlyAskedQuestion.tasks" ng-options="task as task.id for task in vm.tasks track by task.id"></select></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestion.professionalArea" for="field_professionalArea">Professional Area</label><select class="form-control" id="field_professionalArea" name="professionalArea" ng-model="vm.frequentlyAskedQuestion.professionalAreaId" ng-options="professionalArea.id as professionalArea.name for professionalArea in vm.professionalareas"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestion.secondaryProfessionalAreas" for="field_secondaryProfessionalAreas">Secondary Professional Areas</label><select class="form-control" id="field_secondaryProfessionalAreas" multiple="multiple" name="secondaryProfessionalAreas" ng-model="vm.frequentlyAskedQuestion.secondaryProfessionalAreas" ng-options="professionalArea as professionalArea.name for professionalArea in vm.professionalareas track by professionalArea.id"></select></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestion.originalSQAnswer" for="field_originalSQAnswer">Original SQ Answer</label><select class="form-control" id="field_originalSQAnswer" name="originalSQAnswer" ng-model="vm.frequentlyAskedQuestion.originalSQAnswerId" ng-options="answer.id as answer.id for answer in vm.answers"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/frequently-asked-question/frequently-asked-questions.html','<div><h2 data-translate="teJHipsterApp.frequentlyAskedQuestion.home.title">Frequently Asked Questions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="frequently-asked-question.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.frequentlyAskedQuestion.home.createLabel">Create new Frequently Asked Question</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.frequentlyAskedQuestion.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="question"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.question">Question</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="answer"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.answer">Answer</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="faqstate"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.faqstate">Faqstate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visibleFor"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.visibleFor">Visible For</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationTime"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.creationTime">Creation Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="updateTime"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.updateTime">Update Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="revisionTime"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.revisionTime">Revision Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="priority"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.priority">Priority</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="authorEmail"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="professionalAreaName"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.professionalArea">Professional Area</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="originalSQAnswerId"><span data-translate="teJHipsterApp.frequentlyAskedQuestion.originalSQAnswer">Original SQ Answer</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="frequentlyAskedQuestion in vm.frequentlyAskedQuestions track by frequentlyAskedQuestion.id"><td><a ui-sref="frequently-asked-question-detail({id:frequentlyAskedQuestion.id})">{{frequentlyAskedQuestion.id}}</a></td><td>{{frequentlyAskedQuestion.name}}</td><td>{{frequentlyAskedQuestion.question}}</td><td>{{frequentlyAskedQuestion.answer}}</td><td data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionState.\' + frequentlyAskedQuestion.faqstate}}">{{frequentlyAskedQuestion.faqstate}}</td><td data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionVisibleFor.\' + frequentlyAskedQuestion.visibleFor}}">{{frequentlyAskedQuestion.visibleFor}}</td><td>{{frequentlyAskedQuestion.creationTime | date:\'medium\'}}</td><td>{{frequentlyAskedQuestion.updateTime | date:\'medium\'}}</td><td>{{frequentlyAskedQuestion.revisionTime | date:\'medium\'}}</td><td>{{frequentlyAskedQuestion.priority}}</td><td><a ui-sref="custom-user-detail({id:frequentlyAskedQuestion.authorId})">{{frequentlyAskedQuestion.authorEmail}}</a></td><td><a ui-sref="professional-area-detail({id:frequentlyAskedQuestion.professionalAreaId})">{{frequentlyAskedQuestion.professionalAreaName}}</a></td><td><a ui-sref="answer-detail({id:frequentlyAskedQuestion.originalSQAnswerId})">{{frequentlyAskedQuestion.originalSQAnswerId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="frequently-asked-question-detail({id:frequentlyAskedQuestion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="frequently-asked-question.edit({id:frequentlyAskedQuestion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="frequently-asked-question.delete({id:frequentlyAskedQuestion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/frequently-asked-question-state-history/frequently-asked-question-state-histories.html','<div><h2 data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.home.title">Frequently Asked Question State Histories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="frequently-asked-question-state-history.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.home.createLabel">Create new Frequently Asked Question State History</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.frequentlyAskedQuestionStateHistory.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="stateSetTimestamp"><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.stateSetTimestamp">State Set Timestamp</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="faqStateOld"><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.faqStateOld">Faq State Old</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="faqStateNew"><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.faqStateNew">Faq State New</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="info"><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.info">Info</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="frequentlyAskedQuestionName"><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.frequentlyAskedQuestion">Frequently Asked Question</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="updateUserId"><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.updateUser">Update User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="frequentlyAskedQuestionStateHistory in vm.frequentlyAskedQuestionStateHistories track by frequentlyAskedQuestionStateHistory.id"><td><a ui-sref="frequently-asked-question-state-history-detail({id:frequentlyAskedQuestionStateHistory.id})">{{frequentlyAskedQuestionStateHistory.id}}</a></td><td>{{frequentlyAskedQuestionStateHistory.stateSetTimestamp | date:\'medium\'}}</td><td data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionState.\' + frequentlyAskedQuestionStateHistory.faqStateOld}}">{{frequentlyAskedQuestionStateHistory.faqStateOld}}</td><td data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionState.\' + frequentlyAskedQuestionStateHistory.faqStateNew}}">{{frequentlyAskedQuestionStateHistory.faqStateNew}}</td><td>{{frequentlyAskedQuestionStateHistory.info}}</td><td><a ui-sref="frequently-asked-question-detail({id:frequentlyAskedQuestionStateHistory.frequentlyAskedQuestionId})">{{frequentlyAskedQuestionStateHistory.frequentlyAskedQuestionName}}</a></td><td><a ui-sref="custom-user-detail({id:frequentlyAskedQuestionStateHistory.updateUserId})">{{frequentlyAskedQuestionStateHistory.updateUserId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="frequently-asked-question-state-history-detail({id:frequentlyAskedQuestionStateHistory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="frequently-asked-question-state-history.edit({id:frequentlyAskedQuestionStateHistory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="frequently-asked-question-state-history.delete({id:frequentlyAskedQuestionStateHistory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.frequentlyAskedQuestionStateHistory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.delete.question" translate-values="{id: \'{{vm.frequentlyAskedQuestionStateHistory.id}}\'}">Are you sure you want to delete this Frequently Asked Question State History?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-detail.html','<div><h2><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.detail.title">Frequently Asked Question State History</span> {{vm.frequentlyAskedQuestionStateHistory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.stateSetTimestamp">State Set Timestamp</span></dt><dd><span>{{vm.frequentlyAskedQuestionStateHistory.stateSetTimestamp | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.faqStateOld">Faq State Old</span></dt><dd><span data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionState.\' + vm.frequentlyAskedQuestionStateHistory.faqStateOld}}">{{vm.frequentlyAskedQuestionStateHistory.faqStateOld}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.faqStateNew">Faq State New</span></dt><dd><span data-translate="{{\'teJHipsterApp.FrequentlyAskedQuestionState.\' + vm.frequentlyAskedQuestionStateHistory.faqStateNew}}">{{vm.frequentlyAskedQuestionStateHistory.faqStateNew}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.info">Info</span></dt><dd><span>{{vm.frequentlyAskedQuestionStateHistory.info}}</span></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.frequentlyAskedQuestion">Frequently Asked Question</span></dt><dd><a ui-sref="frequently-asked-question-detail({id:vm.frequentlyAskedQuestionStateHistory.frequentlyAskedQuestionId})">{{vm.frequentlyAskedQuestionStateHistory.frequentlyAskedQuestionName}}</a></dd><dt><span data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.updateUser">Update User</span></dt><dd><a ui-sref="custom-user-detail({id:vm.frequentlyAskedQuestionStateHistory.updateUserId})">{{vm.frequentlyAskedQuestionStateHistory.updateUserId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="frequently-asked-question-state-history-detail.edit({id:vm.frequentlyAskedQuestionStateHistory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/frequently-asked-question-state-history/frequently-asked-question-state-history-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFrequentlyAskedQuestionStateHistoryLabel" data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.home.createOrEditLabel">Create or edit a Frequently Asked Question State History</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.frequentlyAskedQuestionStateHistory.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.frequentlyAskedQuestionStateHistory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.stateSetTimestamp" for="field_stateSetTimestamp">State Set Timestamp</label><div class="input-group"><input id="field_stateSetTimestamp" type="text" class="form-control" name="stateSetTimestamp" datetime-picker="{{dateformat}}" ng-model="vm.frequentlyAskedQuestionStateHistory.stateSetTimestamp" is-open="vm.datePickerOpenStatus.stateSetTimestamp" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'stateSetTimestamp\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.stateSetTimestamp.$invalid"><p class="help-block" ng-show="editForm.stateSetTimestamp.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.stateSetTimestamp.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.faqStateOld" for="field_faqStateOld">Faq State Old</label><select class="form-control" name="faqStateOld" ng-model="vm.frequentlyAskedQuestionStateHistory.faqStateOld" id="field_faqStateOld"><option value="CREATED" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.CREATED">CREATED</option><option value="DONE" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.DONE">DONE</option><option value="READY_FOR_PUBLICATION" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.READY_FOR_PUBLICATION">READY_FOR_PUBLICATION</option><option value="PUBLIC" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.PUBLIC">PUBLIC</option></select></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.faqStateNew" for="field_faqStateNew">Faq State New</label><select class="form-control" name="faqStateNew" ng-model="vm.frequentlyAskedQuestionStateHistory.faqStateNew" id="field_faqStateNew" required><option value="CREATED" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.CREATED">CREATED</option><option value="DONE" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.DONE">DONE</option><option value="READY_FOR_PUBLICATION" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.READY_FOR_PUBLICATION">READY_FOR_PUBLICATION</option><option value="PUBLIC" data-translate="teJHipsterApp.FrequentlyAskedQuestionState.PUBLIC">PUBLIC</option></select><div ng-show="editForm.faqStateNew.$invalid"><p class="help-block" ng-show="editForm.faqStateNew.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.info" for="field_info">Info</label><input type="text" class="form-control" name="info" id="field_info" ng-model="vm.frequentlyAskedQuestionStateHistory.info"></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.frequentlyAskedQuestion" for="field_frequentlyAskedQuestion">Frequently Asked Question</label><select class="form-control" id="field_frequentlyAskedQuestion" name="frequentlyAskedQuestion" ng-model="vm.frequentlyAskedQuestionStateHistory.frequentlyAskedQuestionId" ng-options="frequentlyAskedQuestion.id as frequentlyAskedQuestion.name for frequentlyAskedQuestion in vm.frequentlyaskedquestions" required><option value=""></option></select></div><div ng-show="editForm.frequentlyAskedQuestion.$invalid"><p class="help-block" ng-show="editForm.frequentlyAskedQuestion.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.frequentlyAskedQuestionStateHistory.updateUser" for="field_updateUser">Update User</label><select class="form-control" id="field_updateUser" name="updateUser" ng-model="vm.frequentlyAskedQuestionStateHistory.updateUserId" ng-options="customUser.id as customUser.id for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.updateUser.$invalid"><p class="help-block" ng-show="editForm.updateUser.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook/handbook-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbook.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbook.delete.question" translate-values="{id: \'{{vm.handbook.id}}\'}">Are you sure you want to delete this Handbook?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook/handbook-detail.html','<div><h2><span data-translate="teJHipsterApp.handbook.detail.title">Handbook</span> {{vm.handbook.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbook.documentType">Document Type</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookDocumentType.\' + vm.handbook.documentType}}">{{vm.handbook.documentType}}</span></dd><dt><span data-translate="teJHipsterApp.handbook.name">Name</span></dt><dd><span>{{vm.handbook.name}}</span></dd><dt><span data-translate="teJHipsterApp.handbook.isTemplate">Is Template</span></dt><dd><span>{{vm.handbook.isTemplate}}</span></dd><dt><span data-translate="teJHipsterApp.handbook.isPublic">Is Public</span></dt><dd><span>{{vm.handbook.isPublic}}</span></dd><dt><span data-translate="teJHipsterApp.handbook.documentDataType">Document Data Type</span></dt><dd><span data-translate="{{\'teJHipsterApp.DocumentDataType.\' + vm.handbook.documentDataType}}">{{vm.handbook.documentDataType}}</span></dd><dt><span data-translate="teJHipsterApp.handbook.additionalInfo">Additional Info</span></dt><dd><span>{{vm.handbook.additionalInfo}}</span></dd><dt><span data-translate="teJHipsterApp.handbook.visibleFor">Visible For</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookVisibleFor.\' + vm.handbook.visibleFor}}">{{vm.handbook.visibleFor}}</span></dd><dt><span data-translate="teJHipsterApp.handbook.professionalArea">Professional Area</span></dt><dd><a ui-sref="professional-area-detail({id:vm.handbook.professionalAreaId})">{{vm.handbook.professionalAreaName}}</a></dd><dt><span data-translate="teJHipsterApp.handbook.template">Template</span></dt><dd><a ui-sref="handbook-detail({id:vm.handbook.templateId})">{{vm.handbook.templateName}}</a></dd><dt><span data-translate="teJHipsterApp.handbook.owner">Owner</span></dt><dd><a ui-sref="custom-user-detail({id:vm.handbook.ownerId})">{{vm.handbook.ownerEmail}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-detail.edit({id:vm.handbook.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook/handbook-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookLabel" data-translate="teJHipsterApp.handbook.home.createOrEditLabel">Create or edit a Handbook</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbook.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbook.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbook.documentType" for="field_documentType">Document Type</label><select class="form-control" name="documentType" ng-model="vm.handbook.documentType" id="field_documentType" required><option value="PROFESSIONAL_AREA_HANDBOOK" data-translate="teJHipsterApp.HandbookDocumentType.PROFESSIONAL_AREA_HANDBOOK">PROFESSIONAL_AREA_HANDBOOK</option><option value="OTHER" data-translate="teJHipsterApp.HandbookDocumentType.OTHER">OTHER</option></select><div ng-show="editForm.documentType.$invalid"><p class="help-block" ng-show="editForm.documentType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbook.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.handbook.name"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbook.isTemplate" for="field_isTemplate">Is Template</label><input type="checkbox" name="isTemplate" id="field_isTemplate" ng-model="vm.handbook.isTemplate"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbook.isPublic" for="field_isPublic">Is Public</label><input type="checkbox" name="isPublic" id="field_isPublic" ng-model="vm.handbook.isPublic"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbook.documentDataType" for="field_documentDataType">Document Data Type</label><select class="form-control" name="documentDataType" ng-model="vm.handbook.documentDataType" id="field_documentDataType" required><option value="STRUCTURED" data-translate="teJHipsterApp.DocumentDataType.STRUCTURED">STRUCTURED</option><option value="FILE" data-translate="teJHipsterApp.DocumentDataType.FILE">FILE</option></select><div ng-show="editForm.documentDataType.$invalid"><p class="help-block" ng-show="editForm.documentDataType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbook.additionalInfo" for="field_additionalInfo">Additional Info</label><input type="text" class="form-control" name="additionalInfo" id="field_additionalInfo" ng-model="vm.handbook.additionalInfo"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbook.visibleFor" for="field_visibleFor">Visible For</label><select class="form-control" name="visibleFor" ng-model="vm.handbook.visibleFor" id="field_visibleFor" required><option value="ANONYMOUS" data-translate="teJHipsterApp.HandbookVisibleFor.ANONYMOUS">ANONYMOUS</option><option value="REGISTERED" data-translate="teJHipsterApp.HandbookVisibleFor.REGISTERED">REGISTERED</option><option value="PAYER" data-translate="teJHipsterApp.HandbookVisibleFor.PAYER">PAYER</option><option value="EXPERT" data-translate="teJHipsterApp.HandbookVisibleFor.EXPERT">EXPERT</option><option value="MANAGER" data-translate="teJHipsterApp.HandbookVisibleFor.MANAGER">MANAGER</option></select><div ng-show="editForm.visibleFor.$invalid"><p class="help-block" ng-show="editForm.visibleFor.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="teJHipsterApp.handbook.professionalArea" for="field_professionalArea">Professional Area</label><select class="form-control" id="field_professionalArea" name="professionalArea" ng-model="vm.handbook.professionalAreaId" ng-options="professionalArea.id as professionalArea.name for professionalArea in vm.professionalareas" required><option value=""></option></select></div><div ng-show="editForm.professionalArea.$invalid"><p class="help-block" ng-show="editForm.professionalArea.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.handbook.template" for="field_template">Template</label><select class="form-control" id="field_template" name="template" ng-model="vm.handbook.templateId" ng-options="handbook.id as handbook.name for handbook in vm.handbooks"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbook.owner" for="field_owner">Owner</label><select class="form-control" id="field_owner" name="owner" ng-model="vm.handbook.ownerId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.owner.$invalid"><p class="help-block" ng-show="editForm.owner.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook/handbooks.html','<div><h2 data-translate="teJHipsterApp.handbook.home.title">Handbooks</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbook.home.createLabel">Create new Handbook</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbook.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="documentType"><span data-translate="teJHipsterApp.handbook.documentType">Document Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="teJHipsterApp.handbook.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isTemplate"><span data-translate="teJHipsterApp.handbook.isTemplate">Is Template</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="isPublic"><span data-translate="teJHipsterApp.handbook.isPublic">Is Public</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="documentDataType"><span data-translate="teJHipsterApp.handbook.documentDataType">Document Data Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="additionalInfo"><span data-translate="teJHipsterApp.handbook.additionalInfo">Additional Info</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visibleFor"><span data-translate="teJHipsterApp.handbook.visibleFor">Visible For</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="professionalAreaName"><span data-translate="teJHipsterApp.handbook.professionalArea">Professional Area</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="templateName"><span data-translate="teJHipsterApp.handbook.template">Template</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ownerEmail"><span data-translate="teJHipsterApp.handbook.owner">Owner</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbook in vm.handbooks track by handbook.id"><td><a ui-sref="handbook-detail({id:handbook.id})">{{handbook.id}}</a></td><td data-translate="{{\'teJHipsterApp.HandbookDocumentType.\' + handbook.documentType}}">{{handbook.documentType}}</td><td>{{handbook.name}}</td><td>{{handbook.isTemplate}}</td><td>{{handbook.isPublic}}</td><td data-translate="{{\'teJHipsterApp.DocumentDataType.\' + handbook.documentDataType}}">{{handbook.documentDataType}}</td><td>{{handbook.additionalInfo}}</td><td data-translate="{{\'teJHipsterApp.HandbookVisibleFor.\' + handbook.visibleFor}}">{{handbook.visibleFor}}</td><td><a ui-sref="professional-area-detail({id:handbook.professionalAreaId})">{{handbook.professionalAreaName}}</a></td><td><a ui-sref="handbook-detail({id:handbook.templateId})">{{handbook.templateName}}</a></td><td><a ui-sref="custom-user-detail({id:handbook.ownerId})">{{handbook.ownerEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-detail({id:handbook.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook.edit({id:handbook.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook.delete({id:handbook.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/handbook-folder/handbook-folder-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbookFolder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbookFolder.delete.question" translate-values="{id: \'{{vm.handbookFolder.id}}\'}">Are you sure you want to delete this Handbook Folder?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook-folder/handbook-folder-detail.html','<div><h2><span data-translate="teJHipsterApp.handbookFolder.detail.title">Handbook Folder</span> {{vm.handbookFolder.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbookFolder.name">Name</span></dt><dd><span>{{vm.handbookFolder.name}}</span></dd><dt><span data-translate="teJHipsterApp.handbookFolder.customUser">Custom User</span></dt><dd><a ui-sref="custom-user-detail({id:vm.handbookFolder.customUserId})">{{vm.handbookFolder.customUserEmail}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-folder-detail.edit({id:vm.handbookFolder.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook-folder/handbook-folder-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookFolderLabel" data-translate="teJHipsterApp.handbookFolder.home.createOrEditLabel">Create or edit a Handbook Folder</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbookFolder.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbookFolder.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookFolder.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.handbookFolder.name" required ng-minlength="1"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p></div></div><div class="form-group"><label data-translate="teJHipsterApp.handbookFolder.customUser" for="field_customUser">Custom User</label><select class="form-control" id="field_customUser" name="customUser" ng-model="vm.handbookFolder.customUserId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.customUser.$invalid"><p class="help-block" ng-show="editForm.customUser.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook-folder/handbook-folders.html','<div><h2 data-translate="teJHipsterApp.handbookFolder.home.title">Handbook Folders</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook-folder.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbookFolder.home.createLabel">Create new Handbook Folder</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbookFolder.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="teJHipsterApp.handbookFolder.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customUserEmail"><span data-translate="teJHipsterApp.handbookFolder.customUser">Custom User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbookFolder in vm.handbookFolders track by handbookFolder.id"><td><a ui-sref="handbook-folder-detail({id:handbookFolder.id})">{{handbookFolder.id}}</a></td><td>{{handbookFolder.name}}</td><td><a ui-sref="custom-user-detail({id:handbookFolder.customUserId})">{{handbookFolder.customUserEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-folder-detail({id:handbookFolder.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook-folder.edit({id:handbookFolder.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook-folder.delete({id:handbookFolder.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/handbook-merge-header/handbook-merge-header-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbookMergeHeader.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbookMergeHeader.delete.question" translate-values="{id: \'{{vm.handbookMergeHeader.id}}\'}">Are you sure you want to delete this Handbook Merge Header?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook-merge-header/handbook-merge-header-detail.html','<div><h2><span data-translate="teJHipsterApp.handbookMergeHeader.detail.title">Handbook Merge Header</span> {{vm.handbookMergeHeader.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbookMergeHeader.startTime">Start Time</span></dt><dd><span>{{vm.handbookMergeHeader.startTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookMergeHeader.finishTime">Finish Time</span></dt><dd><span>{{vm.handbookMergeHeader.finishTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookMergeHeader.handbook">Handbook</span></dt><dd><a ui-sref="handbook-detail({id:vm.handbookMergeHeader.handbookId})">{{vm.handbookMergeHeader.handbookName}}</a></dd><dt><span data-translate="teJHipsterApp.handbookMergeHeader.oldVersion">Old Version</span></dt><dd><a ui-sref="handbook-version-detail({id:vm.handbookMergeHeader.oldVersionId})">{{vm.handbookMergeHeader.oldVersionVersion}}</a></dd><dt><span data-translate="teJHipsterApp.handbookMergeHeader.newVersion">New Version</span></dt><dd><a ui-sref="handbook-version-detail({id:vm.handbookMergeHeader.newVersionId})">{{vm.handbookMergeHeader.newVersionVersion}}</a></dd><dt><span data-translate="teJHipsterApp.handbookMergeHeader.customUser">Custom User</span></dt><dd><a ui-sref="custom-user-detail({id:vm.handbookMergeHeader.customUserId})">{{vm.handbookMergeHeader.customUserEmail}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-merge-header-detail.edit({id:vm.handbookMergeHeader.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook-merge-header/handbook-merge-header-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookMergeHeaderLabel" data-translate="teJHipsterApp.handbookMergeHeader.home.createOrEditLabel">Create or edit a Handbook Merge Header</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbookMergeHeader.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbookMergeHeader.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookMergeHeader.startTime" for="field_startTime">Start Time</label><div class="input-group"><input id="field_startTime" type="text" class="form-control" name="startTime" datetime-picker="{{dateformat}}" ng-model="vm.handbookMergeHeader.startTime" is-open="vm.datePickerOpenStatus.startTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.startTime.$invalid"><p class="help-block" ng-show="editForm.startTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.startTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookMergeHeader.finishTime" for="field_finishTime">Finish Time</label><div class="input-group"><input id="field_finishTime" type="text" class="form-control" name="finishTime" datetime-picker="{{dateformat}}" ng-model="vm.handbookMergeHeader.finishTime" is-open="vm.datePickerOpenStatus.finishTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finishTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="teJHipsterApp.handbookMergeHeader.handbook" for="field_handbook">Handbook</label><select class="form-control" id="field_handbook" name="handbook" ng-model="vm.handbookMergeHeader.handbookId" ng-options="handbook.id as handbook.name for handbook in vm.handbooks" required><option value=""></option></select></div><div ng-show="editForm.handbook.$invalid"><p class="help-block" ng-show="editForm.handbook.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.handbookMergeHeader.oldVersion" for="field_oldVersion">Old Version</label><select class="form-control" id="field_oldVersion" name="oldVersion" ng-model="vm.handbookMergeHeader.oldVersionId" ng-options="handbookVersion.id as handbookVersion.version for handbookVersion in vm.handbookversions" required><option value=""></option></select></div><div ng-show="editForm.oldVersion.$invalid"><p class="help-block" ng-show="editForm.oldVersion.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.handbookMergeHeader.newVersion" for="field_newVersion">New Version</label><select class="form-control" id="field_newVersion" name="newVersion" ng-model="vm.handbookMergeHeader.newVersionId" ng-options="handbookVersion.id as handbookVersion.version for handbookVersion in vm.handbookversions"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbookMergeHeader.customUser" for="field_customUser">Custom User</label><select class="form-control" id="field_customUser" name="customUser" ng-model="vm.handbookMergeHeader.customUserId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.customUser.$invalid"><p class="help-block" ng-show="editForm.customUser.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook-merge-header/handbook-merge-headers.html','<div><h2 data-translate="teJHipsterApp.handbookMergeHeader.home.title">Handbook Merge Headers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook-merge-header.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbookMergeHeader.home.createLabel">Create new Handbook Merge Header</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbookMergeHeader.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startTime"><span data-translate="teJHipsterApp.handbookMergeHeader.startTime">Start Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="finishTime"><span data-translate="teJHipsterApp.handbookMergeHeader.finishTime">Finish Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="handbookName"><span data-translate="teJHipsterApp.handbookMergeHeader.handbook">Handbook</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="oldVersionVersion"><span data-translate="teJHipsterApp.handbookMergeHeader.oldVersion">Old Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="newVersionVersion"><span data-translate="teJHipsterApp.handbookMergeHeader.newVersion">New Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="customUserEmail"><span data-translate="teJHipsterApp.handbookMergeHeader.customUser">Custom User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbookMergeHeader in vm.handbookMergeHeaders track by handbookMergeHeader.id"><td><a ui-sref="handbook-merge-header-detail({id:handbookMergeHeader.id})">{{handbookMergeHeader.id}}</a></td><td>{{handbookMergeHeader.startTime | date:\'medium\'}}</td><td>{{handbookMergeHeader.finishTime | date:\'medium\'}}</td><td><a ui-sref="handbook-detail({id:handbookMergeHeader.handbookId})">{{handbookMergeHeader.handbookName}}</a></td><td><a ui-sref="handbook-version-detail({id:handbookMergeHeader.oldVersionId})">{{handbookMergeHeader.oldVersionVersion}}</a></td><td><a ui-sref="handbook-version-detail({id:handbookMergeHeader.newVersionId})">{{handbookMergeHeader.newVersionVersion}}</a></td><td><a ui-sref="custom-user-detail({id:handbookMergeHeader.customUserId})">{{handbookMergeHeader.customUserEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-merge-header-detail({id:handbookMergeHeader.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook-merge-header.edit({id:handbookMergeHeader.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook-merge-header.delete({id:handbookMergeHeader.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/handbook-node/handbook-node-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbookNode.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbookNode.delete.question" translate-values="{id: \'{{vm.handbookNode.id}}\'}">Are you sure you want to delete this Handbook Node?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook-node/handbook-node-detail.html','<div><h2><span data-translate="teJHipsterApp.handbookNode.detail.title">Handbook Node</span> {{vm.handbookNode.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbookNode.content">Content</span></dt><dd><span>{{vm.handbookNode.content}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.type">Type</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookNodeType.\' + vm.handbookNode.type}}">{{vm.handbookNode.type}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.accessRights">Access Rights</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookNodeAccessRights.\' + vm.handbookNode.accessRights}}">{{vm.handbookNode.accessRights}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.visible">Visible</span></dt><dd><span>{{vm.handbookNode.visible}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.nodeUUID">Node UUID</span></dt><dd><span>{{vm.handbookNode.nodeUUID}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.canAddHeading">Can Add Heading</span></dt><dd><span>{{vm.handbookNode.canAddHeading}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.canDelete">Can Delete</span></dt><dd><span>{{vm.handbookNode.canDelete}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.canEdit">Can Edit</span></dt><dd><span>{{vm.handbookNode.canEdit}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.info">Info</span></dt><dd><span>{{vm.handbookNode.info}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.treeLabel">Tree Label</span></dt><dd><span>{{vm.handbookNode.treeLabel}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.treeCheckboxVisible">Tree Checkbox Visible</span></dt><dd><span>{{vm.handbookNode.treeCheckboxVisible}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.mergeState">Merge State</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookNodeMergeState.\' + vm.handbookNode.mergeState}}">{{vm.handbookNode.mergeState}}</span></dd><dt><span data-translate="teJHipsterApp.handbookNode.handbookVersion">Handbook Version</span></dt><dd><a ui-sref="handbook-version-detail({id:vm.handbookNode.handbookVersionId})">{{vm.handbookNode.handbookVersionId}}</a></dd><dt><span data-translate="teJHipsterApp.handbookNode.parentNode">Parent Node</span></dt><dd><a ui-sref="handbook-node-detail({id:vm.handbookNode.parentNodeId})">{{vm.handbookNode.parentNodeId}}</a></dd><dt><span data-translate="teJHipsterApp.handbookNode.file">File</span></dt><dd><a ui-sref="file-detail({id:vm.handbookNode.fileId})">{{vm.handbookNode.fileName}}</a></dd><dt><span data-translate="teJHipsterApp.handbookNode.previousSiblingNode">Previous Sibling Node</span></dt><dd><a ui-sref="handbook-node-detail({id:vm.handbookNode.previousSiblingNodeId})">{{vm.handbookNode.previousSiblingNodeId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-node-detail.edit({id:vm.handbookNode.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook-node/handbook-node-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookNodeLabel" data-translate="teJHipsterApp.handbookNode.home.createOrEditLabel">Create or edit a Handbook Node</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbookNode.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbookNode.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.content" for="field_content">Content</label><input type="text" class="form-control" name="content" id="field_content" ng-model="vm.handbookNode.content"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.handbookNode.type" id="field_type" required><option value="HEADING" data-translate="teJHipsterApp.HandbookNodeType.HEADING">HEADING</option><option value="TEXT" data-translate="teJHipsterApp.HandbookNodeType.TEXT">TEXT</option><option value="IMAGE" data-translate="teJHipsterApp.HandbookNodeType.IMAGE">IMAGE</option><option value="ATTACHMENT" data-translate="teJHipsterApp.HandbookNodeType.ATTACHMENT">ATTACHMENT</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.accessRights" for="field_accessRights">Access Rights</label><select class="form-control" name="accessRights" ng-model="vm.handbookNode.accessRights" id="field_accessRights" required><option value="REGISTERED" data-translate="teJHipsterApp.HandbookNodeAccessRights.REGISTERED">REGISTERED</option><option value="PAYER" data-translate="teJHipsterApp.HandbookNodeAccessRights.PAYER">PAYER</option><option value="POWER_USER" data-translate="teJHipsterApp.HandbookNodeAccessRights.POWER_USER">POWER_USER</option></select><div ng-show="editForm.accessRights.$invalid"><p class="help-block" ng-show="editForm.accessRights.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.visible" for="field_visible">Visible</label><input type="checkbox" name="visible" id="field_visible" ng-model="vm.handbookNode.visible"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.nodeUUID" for="field_nodeUUID">Node UUID</label><input type="text" class="form-control" name="nodeUUID" id="field_nodeUUID" ng-model="vm.handbookNode.nodeUUID" required><div ng-show="editForm.nodeUUID.$invalid"><p class="help-block" ng-show="editForm.nodeUUID.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.canAddHeading" for="field_canAddHeading">Can Add Heading</label><input type="checkbox" name="canAddHeading" id="field_canAddHeading" ng-model="vm.handbookNode.canAddHeading"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.canDelete" for="field_canDelete">Can Delete</label><input type="checkbox" name="canDelete" id="field_canDelete" ng-model="vm.handbookNode.canDelete"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.canEdit" for="field_canEdit">Can Edit</label><input type="checkbox" name="canEdit" id="field_canEdit" ng-model="vm.handbookNode.canEdit"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.info" for="field_info">Info</label><input type="text" class="form-control" name="info" id="field_info" ng-model="vm.handbookNode.info"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.treeLabel" for="field_treeLabel">Tree Label</label><input type="text" class="form-control" name="treeLabel" id="field_treeLabel" ng-model="vm.handbookNode.treeLabel"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.treeCheckboxVisible" for="field_treeCheckboxVisible">Tree Checkbox Visible</label><input type="checkbox" name="treeCheckboxVisible" id="field_treeCheckboxVisible" ng-model="vm.handbookNode.treeCheckboxVisible"><div ng-show="editForm.treeCheckboxVisible.$invalid"><p class="help-block" ng-show="editForm.treeCheckboxVisible.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookNode.mergeState" for="field_mergeState">Merge State</label><select class="form-control" name="mergeState" ng-model="vm.handbookNode.mergeState" id="field_mergeState"><option value="NONE" data-translate="teJHipsterApp.HandbookNodeMergeState.NONE">NONE</option><option value="ADDITION" data-translate="teJHipsterApp.HandbookNodeMergeState.ADDITION">ADDITION</option><option value="REMOVING" data-translate="teJHipsterApp.HandbookNodeMergeState.REMOVING">REMOVING</option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbookNode.handbookVersion" for="field_handbookVersion">Handbook Version</label><select class="form-control" id="field_handbookVersion" name="handbookVersion" ng-model="vm.handbookNode.handbookVersionId" ng-options="handbookVersion.id as handbookVersion.id for handbookVersion in vm.handbookversions"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbookNode.parentNode" for="field_parentNode">Parent Node</label><select class="form-control" id="field_parentNode" name="parentNode" ng-model="vm.handbookNode.parentNodeId" ng-options="handbookNode.id as handbookNode.id for handbookNode in vm.handbooknodes"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbookNode.file" for="field_file">File</label><select class="form-control" id="field_file" name="file" ng-model="vm.handbookNode.fileId" ng-options="file.id as file.name for file in vm.files"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbookNode.previousSiblingNode" for="field_previousSiblingNode">Previous Sibling Node</label><select class="form-control" id="field_previousSiblingNode" name="previousSiblingNode" ng-model="vm.handbookNode.previousSiblingNodeId" ng-options="handbookNode.id as handbookNode.id for handbookNode in vm.previoussiblingnodes | orderBy:\'id\'"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook-node/handbook-nodes.html','<div><h2 data-translate="teJHipsterApp.handbookNode.home.title">Handbook Nodes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook-node.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbookNode.home.createLabel">Create new Handbook Node</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbookNode.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span data-translate="teJHipsterApp.handbookNode.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="teJHipsterApp.handbookNode.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="accessRights"><span data-translate="teJHipsterApp.handbookNode.accessRights">Access Rights</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="visible"><span data-translate="teJHipsterApp.handbookNode.visible">Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nodeUUID"><span data-translate="teJHipsterApp.handbookNode.nodeUUID">Node UUID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="canAddHeading"><span data-translate="teJHipsterApp.handbookNode.canAddHeading">Can Add Heading</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="canDelete"><span data-translate="teJHipsterApp.handbookNode.canDelete">Can Delete</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="canEdit"><span data-translate="teJHipsterApp.handbookNode.canEdit">Can Edit</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="info"><span data-translate="teJHipsterApp.handbookNode.info">Info</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="treeLabel"><span data-translate="teJHipsterApp.handbookNode.treeLabel">Tree Label</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="treeCheckboxVisible"><span data-translate="teJHipsterApp.handbookNode.treeCheckboxVisible">Tree Checkbox Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mergeState"><span data-translate="teJHipsterApp.handbookNode.mergeState">Merge State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="handbookVersionId"><span data-translate="teJHipsterApp.handbookNode.handbookVersion">Handbook Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="parentNodeId"><span data-translate="teJHipsterApp.handbookNode.parentNode">Parent Node</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileName"><span data-translate="teJHipsterApp.handbookNode.file">File</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="previousSiblingNodeId"><span data-translate="teJHipsterApp.handbookNode.previousSiblingNode">Previous Sibling Node</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbookNode in vm.handbookNodes track by handbookNode.id"><td><a ui-sref="handbook-node-detail({id:handbookNode.id})">{{handbookNode.id}}</a></td><td>{{handbookNode.content}}</td><td data-translate="{{\'teJHipsterApp.HandbookNodeType.\' + handbookNode.type}}">{{handbookNode.type}}</td><td data-translate="{{\'teJHipsterApp.HandbookNodeAccessRights.\' + handbookNode.accessRights}}">{{handbookNode.accessRights}}</td><td>{{handbookNode.visible}}</td><td>{{handbookNode.nodeUUID}}</td><td>{{handbookNode.canAddHeading}}</td><td>{{handbookNode.canDelete}}</td><td>{{handbookNode.canEdit}}</td><td>{{handbookNode.info}}</td><td>{{handbookNode.treeLabel}}</td><td>{{handbookNode.treeCheckboxVisible}}</td><td data-translate="{{\'teJHipsterApp.HandbookNodeMergeState.\' + handbookNode.mergeState}}">{{handbookNode.mergeState}}</td><td><a ui-sref="handbook-version-detail({id:handbookNode.handbookVersionId})">{{handbookNode.handbookVersionId}}</a></td><td><a ui-sref="handbook-node-detail({id:handbookNode.parentNodeId})">{{handbookNode.parentNodeId}}</a></td><td><a ui-sref="file-detail({id:handbookNode.fileId})">{{handbookNode.fileName}}</a></td><td><a ui-sref="handbook-node-detail({id:handbookNode.previousSiblingNodeId})">{{handbookNode.previousSiblingNodeId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-node-detail({id:handbookNode.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook-node.edit({id:handbookNode.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook-node.delete({id:handbookNode.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/handbook-merge-item/handbook-merge-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbookMergeItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbookMergeItem.delete.question" translate-values="{id: \'{{vm.handbookMergeItem.id}}\'}">Are you sure you want to delete this Handbook Merge Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook-merge-item/handbook-merge-item-detail.html','<div><h2><span data-translate="teJHipsterApp.handbookMergeItem.detail.title">Handbook Merge Item</span> {{vm.handbookMergeItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbookMergeItem.nodeUUID">Node UUID</span></dt><dd><span>{{vm.handbookMergeItem.nodeUUID}}</span></dd><dt><span data-translate="teJHipsterApp.handbookMergeItem.changeType">Change Type</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookMergeItemChangeType.\' + vm.handbookMergeItem.changeType}}">{{vm.handbookMergeItem.changeType}}</span></dd><dt><span data-translate="teJHipsterApp.handbookMergeItem.changeIn">Change In</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookMergeItemChangeIn.\' + vm.handbookMergeItem.changeIn}}">{{vm.handbookMergeItem.changeIn}}</span></dd><dt><span data-translate="teJHipsterApp.handbookMergeItem.merged">Merged</span></dt><dd><span>{{vm.handbookMergeItem.merged | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookMergeItem.templateSourceNode">Template Source Node</span></dt><dd><a ui-sref="handbook-node-detail({id:vm.handbookMergeItem.templateSourceNodeId})">{{vm.handbookMergeItem.templateSourceNodeId}}</a></dd><dt><span data-translate="teJHipsterApp.handbookMergeItem.templateTargetNode">Template Target Node</span></dt><dd><a ui-sref="handbook-node-detail({id:vm.handbookMergeItem.templateTargetNodeId})">{{vm.handbookMergeItem.templateTargetNodeId}}</a></dd><dt><span data-translate="teJHipsterApp.handbookMergeItem.handbookMergeHeader">Handbook Merge Header</span></dt><dd><a ui-sref="handbook-merge-header-detail({id:vm.handbookMergeItem.handbookMergeHeaderId})">{{vm.handbookMergeItem.handbookMergeHeaderId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-merge-item-detail.edit({id:vm.handbookMergeItem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook-merge-item/handbook-merge-item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookMergeItemLabel" data-translate="teJHipsterApp.handbookMergeItem.home.createOrEditLabel">Create or edit a Handbook Merge Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbookMergeItem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbookMergeItem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookMergeItem.nodeUUID" for="field_nodeUUID">Node UUID</label><input type="text" class="form-control" name="nodeUUID" id="field_nodeUUID" ng-model="vm.handbookMergeItem.nodeUUID" required><div ng-show="editForm.nodeUUID.$invalid"><p class="help-block" ng-show="editForm.nodeUUID.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookMergeItem.changeType" for="field_changeType">Change Type</label><select class="form-control" name="changeType" ng-model="vm.handbookMergeItem.changeType" id="field_changeType" required><option value="ADD" data-translate="teJHipsterApp.HandbookMergeItemChangeType.ADD">ADD</option><option value="REMOVE" data-translate="teJHipsterApp.HandbookMergeItemChangeType.REMOVE">REMOVE</option><option value="CHANGE" data-translate="teJHipsterApp.HandbookMergeItemChangeType.CHANGE">CHANGE</option></select><div ng-show="editForm.changeType.$invalid"><p class="help-block" ng-show="editForm.changeType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookMergeItem.changeIn" for="field_changeIn">Change In</label><select class="form-control" name="changeIn" ng-model="vm.handbookMergeItem.changeIn" id="field_changeIn"><option value="CONTENT" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.CONTENT">CONTENT</option><option value="ACCESS_RIGHTS" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.ACCESS_RIGHTS">ACCESS_RIGHTS</option><option value="PARENT" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.PARENT">PARENT</option><option value="PREVIOUS_SIBLING" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.PREVIOUS_SIBLING">PREVIOUS_SIBLING</option><option value="FILE_CONTENT" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.FILE_CONTENT">FILE_CONTENT</option><option value="FLAGS" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.FLAGS">FLAGS</option><option value="INFO" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.INFO">INFO</option><option value="VISIBLE" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.VISIBLE">VISIBLE</option><option value="TREE_LABEL_OR_VISIBLE" data-translate="teJHipsterApp.HandbookMergeItemChangeIn.TREE_LABEL_OR_VISIBLE">TREE_LABEL_OR_VISIBLE</option></select></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookMergeItem.merged" for="field_merged">Merged</label><div class="input-group"><input id="field_merged" type="text" class="form-control" name="merged" datetime-picker="{{dateformat}}" ng-model="vm.handbookMergeItem.merged" is-open="vm.datePickerOpenStatus.merged"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'merged\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="teJHipsterApp.handbookMergeItem.templateSourceNode" for="field_templateSourceNode">Template Source Node</label><select class="form-control" id="field_templateSourceNode" name="templateSourceNode" ng-model="vm.handbookMergeItem.templateSourceNodeId" ng-options="handbookNode.id as handbookNode.id for handbookNode in vm.handbooknodes"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbookMergeItem.templateTargetNode" for="field_templateTargetNode">Template Target Node</label><select class="form-control" id="field_templateTargetNode" name="templateTargetNode" ng-model="vm.handbookMergeItem.templateTargetNodeId" ng-options="handbookNode.id as handbookNode.id for handbookNode in vm.handbooknodes"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.handbookMergeItem.handbookMergeHeader" for="field_handbookMergeHeader">Handbook Merge Header</label><select class="form-control" id="field_handbookMergeHeader" name="handbookMergeHeader" ng-model="vm.handbookMergeItem.handbookMergeHeaderId" ng-options="handbookMergeHeader.id as handbookMergeHeader.id for handbookMergeHeader in vm.handbookmergeheaders" required><option value=""></option></select></div><div ng-show="editForm.handbookMergeHeader.$invalid"><p class="help-block" ng-show="editForm.handbookMergeHeader.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook-merge-item/handbook-merge-items.html','<div><h2 data-translate="teJHipsterApp.handbookMergeItem.home.title">Handbook Merge Items</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook-merge-item.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbookMergeItem.home.createLabel">Create new Handbook Merge Item</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbookMergeItem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nodeUUID"><span data-translate="teJHipsterApp.handbookMergeItem.nodeUUID">Node UUID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="changeType"><span data-translate="teJHipsterApp.handbookMergeItem.changeType">Change Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="changeIn"><span data-translate="teJHipsterApp.handbookMergeItem.changeIn">Change In</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="merged"><span data-translate="teJHipsterApp.handbookMergeItem.merged">Merged</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="templateSourceNodeId"><span data-translate="teJHipsterApp.handbookMergeItem.templateSourceNode">Template Source Node</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="templateTargetNodeId"><span data-translate="teJHipsterApp.handbookMergeItem.templateTargetNode">Template Target Node</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="handbookMergeHeaderId"><span data-translate="teJHipsterApp.handbookMergeItem.handbookMergeHeader">Handbook Merge Header</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbookMergeItem in vm.handbookMergeItems track by handbookMergeItem.id"><td><a ui-sref="handbook-merge-item-detail({id:handbookMergeItem.id})">{{handbookMergeItem.id}}</a></td><td>{{handbookMergeItem.nodeUUID}}</td><td data-translate="{{\'teJHipsterApp.HandbookMergeItemChangeType.\' + handbookMergeItem.changeType}}">{{handbookMergeItem.changeType}}</td><td data-translate="{{\'teJHipsterApp.HandbookMergeItemChangeIn.\' + handbookMergeItem.changeIn}}">{{handbookMergeItem.changeIn}}</td><td>{{handbookMergeItem.merged | date:\'medium\'}}</td><td><a ui-sref="handbook-node-detail({id:handbookMergeItem.templateSourceNodeId})">{{handbookMergeItem.templateSourceNodeId}}</a></td><td><a ui-sref="handbook-node-detail({id:handbookMergeItem.templateTargetNodeId})">{{handbookMergeItem.templateTargetNodeId}}</a></td><td><a ui-sref="handbook-merge-header-detail({id:handbookMergeItem.handbookMergeHeaderId})">{{handbookMergeItem.handbookMergeHeaderId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-merge-item-detail({id:handbookMergeItem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook-merge-item.edit({id:handbookMergeItem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook-merge-item.delete({id:handbookMergeItem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/handbook-statistic/handbook-statistic-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbookStatistic.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbookStatistic.delete.question" translate-values="{id: \'{{vm.handbookStatistic.id}}\'}">Are you sure you want to delete this Handbook Statistic?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook-statistic/handbook-statistic-detail.html','<div><h2><span data-translate="teJHipsterApp.handbookStatistic.detail.title">Handbook Statistic</span> {{vm.handbookStatistic.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbookStatistic.type">Type</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookStatisticType.\' + vm.handbookStatistic.type}}">{{vm.handbookStatistic.type}}</span></dd><dt><span data-translate="teJHipsterApp.handbookStatistic.value">Value</span></dt><dd><span>{{vm.handbookStatistic.value}}</span></dd><dt><span data-translate="teJHipsterApp.handbookStatistic.handbook">Handbook</span></dt><dd><a ui-sref="handbook-detail({id:vm.handbookStatistic.handbookId})">{{vm.handbookStatistic.handbookName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-statistic-detail.edit({id:vm.handbookStatistic.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook-statistic/handbook-statistic-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookStatisticLabel" data-translate="teJHipsterApp.handbookStatistic.home.createOrEditLabel">Create or edit a Handbook Statistic</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbookStatistic.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbookStatistic.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookStatistic.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.handbookStatistic.type" id="field_type" required><option value="PAYER_NODE_COUNT" data-translate="teJHipsterApp.HandbookStatisticType.PAYER_NODE_COUNT">PAYER_NODE_COUNT</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookStatistic.value" for="field_value">Value</label><input type="text" class="form-control" name="value" id="field_value" ng-model="vm.handbookStatistic.value"></div><div class="form-group"><label data-translate="teJHipsterApp.handbookStatistic.handbook" for="field_handbook">Handbook</label><select class="form-control" id="field_handbook" name="handbook" ng-model="vm.handbookStatistic.handbookId" ng-options="handbook.id as handbook.name for handbook in vm.handbooks" required><option value=""></option></select></div><div ng-show="editForm.handbook.$invalid"><p class="help-block" ng-show="editForm.handbook.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook-statistic/handbook-statistics.html','<div><h2 data-translate="teJHipsterApp.handbookStatistic.home.title">Handbook Statistics</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook-statistic.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbookStatistic.home.createLabel">Create new Handbook Statistic</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbookStatistic.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="teJHipsterApp.handbookStatistic.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="teJHipsterApp.handbookStatistic.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="handbookName"><span data-translate="teJHipsterApp.handbookStatistic.handbook">Handbook</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbookStatistic in vm.handbookStatistics track by handbookStatistic.id"><td><a ui-sref="handbook-statistic-detail({id:handbookStatistic.id})">{{handbookStatistic.id}}</a></td><td data-translate="{{\'teJHipsterApp.HandbookStatisticType.\' + handbookStatistic.type}}">{{handbookStatistic.type}}</td><td>{{handbookStatistic.value}}</td><td><a ui-sref="handbook-detail({id:handbookStatistic.handbookId})">{{handbookStatistic.handbookName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-statistic-detail({id:handbookStatistic.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook-statistic.edit({id:handbookStatistic.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook-statistic.delete({id:handbookStatistic.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/handbook-version/handbook-version-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbookVersion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbookVersion.delete.question" translate-values="{id: \'{{vm.handbookVersion.id}}\'}">Are you sure you want to delete this Handbook Version?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook-version/handbook-version-detail.html','<div><h2><span data-translate="teJHipsterApp.handbookVersion.detail.title">Handbook Version</span> {{vm.handbookVersion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbookVersion.version">Version</span></dt><dd><span>{{vm.handbookVersion.version}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.validFrom">Valid From</span></dt><dd><span>{{vm.handbookVersion.validFrom | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.validUntil">Valid Until</span></dt><dd><span>{{vm.handbookVersion.validUntil | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.publicationDate">Publication Date</span></dt><dd><span>{{vm.handbookVersion.publicationDate | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.state">State</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookVersionState.\' + vm.handbookVersion.state}}">{{vm.handbookVersion.state}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.significantChange">Significant Change</span></dt><dd><span>{{vm.handbookVersion.significantChange}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.note">Note</span></dt><dd><span>{{vm.handbookVersion.note}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.creationTime">Creation Time</span></dt><dd><span>{{vm.handbookVersion.creationTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.revisionTime">Revision Time</span></dt><dd><span>{{vm.handbookVersion.revisionTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersion.handbook">Handbook</span></dt><dd><a ui-sref="handbook-detail({id:vm.handbookVersion.handbookId})">{{vm.handbookVersion.handbookName}}</a></dd><dt><span data-translate="teJHipsterApp.handbookVersion.author">Author</span></dt><dd><a ui-sref="custom-user-detail({id:vm.handbookVersion.authorId})">{{vm.handbookVersion.authorEmail}}</a></dd><dt><span data-translate="teJHipsterApp.handbookVersion.lastTemplateVersion">Last Template Version</span></dt><dd><a ui-sref="handbook-version-detail({id:vm.handbookVersion.lastTemplateVersionId})">{{vm.handbookVersion.lastTemplateVersionId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-version-detail.edit({id:vm.handbookVersion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook-version/handbook-version-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookVersionLabel" data-translate="teJHipsterApp.handbookVersion.home.createOrEditLabel">Create or edit a Handbook Version</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbookVersion.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbookVersion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.version" for="field_version">Version</label><input type="number" class="form-control" name="version" id="field_version" ng-model="vm.handbookVersion.version" required><div ng-show="editForm.version.$invalid"><p class="help-block" ng-show="editForm.version.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.version.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.validFrom" for="field_validFrom">Valid From</label><div class="input-group"><input id="field_validFrom" type="text" class="form-control" name="validFrom" datetime-picker="{{dateformat}}" ng-model="vm.handbookVersion.validFrom" is-open="vm.datePickerOpenStatus.validFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.validUntil" for="field_validUntil">Valid Until</label><div class="input-group"><input id="field_validUntil" type="text" class="form-control" name="validUntil" datetime-picker="{{dateformat}}" ng-model="vm.handbookVersion.validUntil" is-open="vm.datePickerOpenStatus.validUntil"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validUntil\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.publicationDate" for="field_publicationDate">Publication Date</label><div class="input-group"><input id="field_publicationDate" type="text" class="form-control" name="publicationDate" datetime-picker="{{dateformat}}" ng-model="vm.handbookVersion.publicationDate" is-open="vm.datePickerOpenStatus.publicationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'publicationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.state" for="field_state">State</label><select class="form-control" name="state" ng-model="vm.handbookVersion.state" id="field_state" required><option value="CREATED" data-translate="teJHipsterApp.HandbookVersionState.CREATED">CREATED</option><option value="DONE" data-translate="teJHipsterApp.HandbookVersionState.DONE">DONE</option><option value="REJECTED" data-translate="teJHipsterApp.HandbookVersionState.REJECTED">REJECTED</option><option value="READY_FOR_PUBLICATION" data-translate="teJHipsterApp.HandbookVersionState.READY_FOR_PUBLICATION">READY_FOR_PUBLICATION</option><option value="PUBLIC" data-translate="teJHipsterApp.HandbookVersionState.PUBLIC">PUBLIC</option><option value="CLOSED" data-translate="teJHipsterApp.HandbookVersionState.CLOSED">CLOSED</option></select><div ng-show="editForm.state.$invalid"><p class="help-block" ng-show="editForm.state.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.significantChange" for="field_significantChange">Significant Change</label><input type="checkbox" name="significantChange" id="field_significantChange" ng-model="vm.handbookVersion.significantChange"><div ng-show="editForm.significantChange.$invalid"><p class="help-block" ng-show="editForm.significantChange.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.note" for="field_note">Note</label><input type="text" class="form-control" name="note" id="field_note" ng-model="vm.handbookVersion.note"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.creationTime" for="field_creationTime">Creation Time</label><div class="input-group"><input id="field_creationTime" type="text" class="form-control" name="creationTime" datetime-picker="{{dateformat}}" ng-model="vm.handbookVersion.creationTime" is-open="vm.datePickerOpenStatus.creationTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersion.revisionTime" for="field_revisionTime">Revision Time</label><div class="input-group"><input id="field_revisionTime" type="text" class="form-control" name="revisionTime" datetime-picker="{{dateformat}}" ng-model="vm.handbookVersion.revisionTime" is-open="vm.datePickerOpenStatus.revisionTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'revisionTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="teJHipsterApp.handbookVersion.handbook" for="field_handbook">Handbook</label><select class="form-control" id="field_handbook" name="handbook" ng-model="vm.handbookVersion.handbookId" ng-options="handbook.id as handbook.name for handbook in vm.handbooks" required><option value=""></option></select></div><div ng-show="editForm.handbook.$invalid"><p class="help-block" ng-show="editForm.handbook.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.handbookVersion.author" for="field_author">Author</label><select class="form-control" id="field_author" name="author" ng-model="vm.handbookVersion.authorId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.author.$invalid"><p class="help-block" ng-show="editForm.author.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.handbookVersion.lastTemplateVersion" for="field_lastTemplateVersion">Last Template Version</label><select class="form-control" id="field_lastTemplateVersion" name="lastTemplateVersion" ng-model="vm.handbookVersion.lastTemplateVersionId" ng-options="handbookVersion.id as handbookVersion.id for handbookVersion in vm.handbookversions"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/handbook-version/handbook-versions.html','<div><h2 data-translate="teJHipsterApp.handbookVersion.home.title">Handbook Versions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook-version.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbookVersion.home.createLabel">Create new Handbook Version</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbookVersion.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="version"><span data-translate="teJHipsterApp.handbookVersion.version">Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validFrom"><span data-translate="teJHipsterApp.handbookVersion.validFrom">Valid From</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validUntil"><span data-translate="teJHipsterApp.handbookVersion.validUntil">Valid Until</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicationDate"><span data-translate="teJHipsterApp.handbookVersion.publicationDate">Publication Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="state"><span data-translate="teJHipsterApp.handbookVersion.state">State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="significantChange"><span data-translate="teJHipsterApp.handbookVersion.significantChange">Significant Change</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="note"><span data-translate="teJHipsterApp.handbookVersion.note">Note</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationTime"><span data-translate="teJHipsterApp.handbookVersion.creationTime">Creation Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="revisionTime"><span data-translate="teJHipsterApp.handbookVersion.revisionTime">Revision Time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="handbookName"><span data-translate="teJHipsterApp.handbookVersion.handbook">Handbook</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="authorEmail"><span data-translate="teJHipsterApp.handbookVersion.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastTemplateVersionId"><span data-translate="teJHipsterApp.handbookVersion.lastTemplateVersion">Last Template Version</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbookVersion in vm.handbookVersions track by handbookVersion.id"><td><a ui-sref="handbook-version-detail({id:handbookVersion.id})">{{handbookVersion.id}}</a></td><td>{{handbookVersion.version}}</td><td>{{handbookVersion.validFrom | date:\'medium\'}}</td><td>{{handbookVersion.validUntil | date:\'medium\'}}</td><td>{{handbookVersion.publicationDate | date:\'medium\'}}</td><td data-translate="{{\'teJHipsterApp.HandbookVersionState.\' + handbookVersion.state}}">{{handbookVersion.state}}</td><td>{{handbookVersion.significantChange}}</td><td>{{handbookVersion.note}}</td><td>{{handbookVersion.creationTime | date:\'medium\'}}</td><td>{{handbookVersion.revisionTime | date:\'medium\'}}</td><td><a ui-sref="handbook-detail({id:handbookVersion.handbookId})">{{handbookVersion.handbookName}}</a></td><td><a ui-sref="custom-user-detail({id:handbookVersion.authorId})">{{handbookVersion.authorEmail}}</a></td><td><a ui-sref="handbook-version-detail({id:handbookVersion.lastTemplateVersionId})">{{handbookVersion.lastTemplateVersionId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-version-detail({id:handbookVersion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook-version.edit({id:handbookVersion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook-version.delete({id:handbookVersion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/handbook-version-state-history/handbook-version-state-histories.html','<div><h2 data-translate="teJHipsterApp.handbookVersionStateHistory.home.title">Handbook Version State Histories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="handbook-version-state-history.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.handbookVersionStateHistory.home.createLabel">Create new Handbook Version State History</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.handbookVersionStateHistory.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="stateSetTimestamp"><span data-translate="teJHipsterApp.handbookVersionStateHistory.stateSetTimestamp">State Set Timestamp</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="stateOld"><span data-translate="teJHipsterApp.handbookVersionStateHistory.stateOld">State Old</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="stateNew"><span data-translate="teJHipsterApp.handbookVersionStateHistory.stateNew">State New</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="info"><span data-translate="teJHipsterApp.handbookVersionStateHistory.info">Info</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="handbookVersionId"><span data-translate="teJHipsterApp.handbookVersionStateHistory.handbookVersion">Handbook Version</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="updateUserEmail"><span data-translate="teJHipsterApp.handbookVersionStateHistory.updateUser">Update User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="handbookVersionStateHistory in vm.handbookVersionStateHistories track by handbookVersionStateHistory.id"><td><a ui-sref="handbook-version-state-history-detail({id:handbookVersionStateHistory.id})">{{handbookVersionStateHistory.id}}</a></td><td>{{handbookVersionStateHistory.stateSetTimestamp | date:\'medium\'}}</td><td data-translate="{{\'teJHipsterApp.HandbookVersionState.\' + handbookVersionStateHistory.stateOld}}">{{handbookVersionStateHistory.stateOld}}</td><td data-translate="{{\'teJHipsterApp.HandbookVersionState.\' + handbookVersionStateHistory.stateNew}}">{{handbookVersionStateHistory.stateNew}}</td><td>{{handbookVersionStateHistory.info}}</td><td><a ui-sref="handbook-version-detail({id:handbookVersionStateHistory.handbookVersionId})">{{handbookVersionStateHistory.handbookVersionId}}</a></td><td><a ui-sref="custom-user-detail({id:handbookVersionStateHistory.updateUserId})">{{handbookVersionStateHistory.updateUserEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="handbook-version-state-history-detail({id:handbookVersionStateHistory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="handbook-version-state-history.edit({id:handbookVersionStateHistory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="handbook-version-state-history.delete({id:handbookVersionStateHistory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/handbook-version-state-history/handbook-version-state-history-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.handbookVersionStateHistory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.handbookVersionStateHistory.delete.question" translate-values="{id: \'{{vm.handbookVersionStateHistory.id}}\'}">Are you sure you want to delete this Handbook Version State History?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/handbook-version-state-history/handbook-version-state-history-detail.html','<div><h2><span data-translate="teJHipsterApp.handbookVersionStateHistory.detail.title">Handbook Version State History</span> {{vm.handbookVersionStateHistory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.handbookVersionStateHistory.stateSetTimestamp">State Set Timestamp</span></dt><dd><span>{{vm.handbookVersionStateHistory.stateSetTimestamp | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersionStateHistory.stateOld">State Old</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookVersionState.\' + vm.handbookVersionStateHistory.stateOld}}">{{vm.handbookVersionStateHistory.stateOld}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersionStateHistory.stateNew">State New</span></dt><dd><span data-translate="{{\'teJHipsterApp.HandbookVersionState.\' + vm.handbookVersionStateHistory.stateNew}}">{{vm.handbookVersionStateHistory.stateNew}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersionStateHistory.info">Info</span></dt><dd><span>{{vm.handbookVersionStateHistory.info}}</span></dd><dt><span data-translate="teJHipsterApp.handbookVersionStateHistory.handbookVersion">Handbook Version</span></dt><dd><a ui-sref="handbook-version-detail({id:vm.handbookVersionStateHistory.handbookVersionId})">{{vm.handbookVersionStateHistory.handbookVersionId}}</a></dd><dt><span data-translate="teJHipsterApp.handbookVersionStateHistory.updateUser">Update User</span></dt><dd><a ui-sref="custom-user-detail({id:vm.handbookVersionStateHistory.updateUserId})">{{vm.handbookVersionStateHistory.updateUserEmail}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="handbook-version-state-history-detail.edit({id:vm.handbookVersionStateHistory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/handbook-version-state-history/handbook-version-state-history-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHandbookVersionStateHistoryLabel" data-translate="teJHipsterApp.handbookVersionStateHistory.home.createOrEditLabel">Create or edit a Handbook Version State History</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.handbookVersionStateHistory.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.handbookVersionStateHistory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersionStateHistory.stateSetTimestamp" for="field_stateSetTimestamp">State Set Timestamp</label><div class="input-group"><input id="field_stateSetTimestamp" type="text" class="form-control" name="stateSetTimestamp" datetime-picker="{{dateformat}}" ng-model="vm.handbookVersionStateHistory.stateSetTimestamp" is-open="vm.datePickerOpenStatus.stateSetTimestamp" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'stateSetTimestamp\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.stateSetTimestamp.$invalid"><p class="help-block" ng-show="editForm.stateSetTimestamp.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.stateSetTimestamp.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersionStateHistory.stateOld" for="field_stateOld">State Old</label><select class="form-control" name="stateOld" ng-model="vm.handbookVersionStateHistory.stateOld" id="field_stateOld"><option value="CREATED" data-translate="teJHipsterApp.HandbookVersionState.CREATED">CREATED</option><option value="DONE" data-translate="teJHipsterApp.HandbookVersionState.DONE">DONE</option><option value="REJECTED" data-translate="teJHipsterApp.HandbookVersionState.REJECTED">REJECTED</option><option value="READY_FOR_PUBLICATION" data-translate="teJHipsterApp.HandbookVersionState.READY_FOR_PUBLICATION">READY_FOR_PUBLICATION</option><option value="PUBLIC" data-translate="teJHipsterApp.HandbookVersionState.PUBLIC">PUBLIC</option><option value="CLOSED" data-translate="teJHipsterApp.HandbookVersionState.CLOSED">CLOSED</option></select></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersionStateHistory.stateNew" for="field_stateNew">State New</label><select class="form-control" name="stateNew" ng-model="vm.handbookVersionStateHistory.stateNew" id="field_stateNew" required><option value="CREATED" data-translate="teJHipsterApp.HandbookVersionState.CREATED">CREATED</option><option value="DONE" data-translate="teJHipsterApp.HandbookVersionState.DONE">DONE</option><option value="REJECTED" data-translate="teJHipsterApp.HandbookVersionState.REJECTED">REJECTED</option><option value="READY_FOR_PUBLICATION" data-translate="teJHipsterApp.HandbookVersionState.READY_FOR_PUBLICATION">READY_FOR_PUBLICATION</option><option value="PUBLIC" data-translate="teJHipsterApp.HandbookVersionState.PUBLIC">PUBLIC</option><option value="CLOSED" data-translate="teJHipsterApp.HandbookVersionState.CLOSED">CLOSED</option></select><div ng-show="editForm.stateNew.$invalid"><p class="help-block" ng-show="editForm.stateNew.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.handbookVersionStateHistory.info" for="field_info">Info</label><input type="text" class="form-control" name="info" id="field_info" ng-model="vm.handbookVersionStateHistory.info"></div><div class="form-group"><label data-translate="teJHipsterApp.handbookVersionStateHistory.handbookVersion" for="field_handbookVersion">Handbook Version</label><select class="form-control" id="field_handbookVersion" name="handbookVersion" ng-model="vm.handbookVersionStateHistory.handbookVersionId" ng-options="handbookVersion.id as handbookVersion.id for handbookVersion in vm.handbookversions" required><option value=""></option></select></div><div ng-show="editForm.handbookVersion.$invalid"><p class="help-block" ng-show="editForm.handbookVersion.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.handbookVersionStateHistory.updateUser" for="field_updateUser">Update User</label><select class="form-control" id="field_updateUser" name="updateUser" ng-model="vm.handbookVersionStateHistory.updateUserId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.updateUser.$invalid"><p class="help-block" ng-show="editForm.updateUser.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/help/help-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.help.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.help.delete.question" translate-values="{id: \'{{vm.help.id}}\'}">Are you sure you want to delete this Help?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/help/help-detail.html','<div><h2><span data-translate="teJHipsterApp.help.detail.title">Help</span> {{vm.help.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.help.name">Name</span></dt><dd><span>{{vm.help.name}}</span></dd><dt><span data-translate="teJHipsterApp.help.content">Content</span></dt><dd><span>{{vm.help.content}}</span></dd><dt><span data-translate="teJHipsterApp.help.helpId">Help Id</span></dt><dd><span>{{vm.help.helpId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="help-detail.edit({id:vm.help.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/help/help-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHelpLabel" data-translate="teJHipsterApp.help.home.createOrEditLabel">Create or edit a Help</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.help.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.help.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.help.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.help.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.help.content" for="field_content">Content</label><textarea class="form-control" name="content" id="field_content" ng-model="vm.help.content">\n            </textarea></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.help.helpId" for="field_helpId">Help Id</label><input type="text" class="form-control" name="helpId" id="field_helpId" ng-model="vm.help.helpId" required><div ng-show="editForm.helpId.$invalid"><p class="help-block" ng-show="editForm.helpId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/help/helps.html','<div><h2 data-translate="teJHipsterApp.help.home.title">Helps</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="help.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.help.home.createLabel">Create new Help</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.help.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="teJHipsterApp.help.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span data-translate="teJHipsterApp.help.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="helpId"><span data-translate="teJHipsterApp.help.helpId">Help Id</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="help in vm.helps track by help.id"><td><a ui-sref="help-detail({id:help.id})">{{help.id}}</a></td><td>{{help.name}}</td><td>{{help.content}}</td><td>{{help.helpId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="help-detail({id:help.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="help.edit({id:help.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="help.delete({id:help.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/professional-area/professional-area-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.professionalArea.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.professionalArea.delete.question" translate-values="{id: \'{{vm.professionalArea.id}}\'}">Are you sure you want to delete this Professional Area?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/professional-area/professional-area-detail.html','<div><h2><span data-translate="teJHipsterApp.professionalArea.detail.title">Professional Area</span> {{vm.professionalArea.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.professionalArea.areaId">Area Id</span></dt><dd><span>{{vm.professionalArea.areaId}}</span></dd><dt><span data-translate="teJHipsterApp.professionalArea.name">Name</span></dt><dd><span>{{vm.professionalArea.name}}</span></dd><dt><span data-translate="teJHipsterApp.professionalArea.description">Description</span></dt><dd><span>{{vm.professionalArea.description}}</span></dd><dt><span data-translate="teJHipsterApp.professionalArea.showInFaqList">Show In Faq List</span></dt><dd><span>{{vm.professionalArea.showInFaqList}}</span></dd><dt><span data-translate="teJHipsterApp.professionalArea.showInDocumentList">Show In Document List</span></dt><dd><span>{{vm.professionalArea.showInDocumentList}}</span></dd><dt><span data-translate="teJHipsterApp.professionalArea.garant">Garant</span></dt><dd><a ui-sref="custom-user-detail({id:vm.professionalArea.garantId})">{{vm.professionalArea.garantEmail}}</a></dd><dt><span data-translate="teJHipsterApp.professionalArea.professionalAreaGroup">Professional Area Group</span></dt><dd><a ui-sref="professional-area-group-detail({id:vm.professionalArea.professionalAreaGroupId})">{{vm.professionalArea.professionalAreaGroupName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="professional-area-detail.edit({id:vm.professionalArea.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/professional-area/professional-area-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfessionalAreaLabel" data-translate="teJHipsterApp.professionalArea.home.createOrEditLabel">Create or edit a Professional Area</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.professionalArea.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.professionalArea.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalArea.areaId" for="field_areaId">Area Id</label><input type="text" class="form-control" name="areaId" id="field_areaId" ng-model="vm.professionalArea.areaId" required><div ng-show="editForm.areaId.$invalid"><p class="help-block" ng-show="editForm.areaId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalArea.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.professionalArea.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalArea.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.professionalArea.description"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalArea.showInFaqList" for="field_showInFaqList">Show In Faq List</label><input type="checkbox" name="showInFaqList" id="field_showInFaqList" ng-model="vm.professionalArea.showInFaqList"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalArea.showInDocumentList" for="field_showInDocumentList">Show In Document List</label><input type="checkbox" name="showInDocumentList" id="field_showInDocumentList" ng-model="vm.professionalArea.showInDocumentList"></div><div class="form-group"><label data-translate="teJHipsterApp.professionalArea.garant" for="field_garant">Garant</label><select class="form-control" id="field_garant" name="garant" ng-model="vm.professionalArea.garantId" ng-options="customUser.id as customUser.email for customUser in vm.customusers"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.professionalArea.professionalAreaGroup" for="field_professionalAreaGroup">Professional Area Group</label><select class="form-control" id="field_professionalAreaGroup" name="professionalAreaGroup" ng-model="vm.professionalArea.professionalAreaGroupId" ng-options="professionalAreaGroup.id as professionalAreaGroup.name for professionalAreaGroup in vm.professionalareagroups"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/professional-area/professional-areas.html','<div><h2 data-translate="teJHipsterApp.professionalArea.home.title">Professional Areas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="professional-area.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.professionalArea.home.createLabel">Create new Professional Area</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.professionalArea.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areaId"><span data-translate="teJHipsterApp.professionalArea.areaId">Area Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="teJHipsterApp.professionalArea.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="teJHipsterApp.professionalArea.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="showInFaqList"><span data-translate="teJHipsterApp.professionalArea.showInFaqList">Show In Faq List</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="showInDocumentList"><span data-translate="teJHipsterApp.professionalArea.showInDocumentList">Show In Document List</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="garantEmail"><span data-translate="teJHipsterApp.professionalArea.garant">Garant</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="professionalAreaGroupName"><span data-translate="teJHipsterApp.professionalArea.professionalAreaGroup">Professional Area Group</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="professionalArea in vm.professionalAreas track by professionalArea.id"><td><a ui-sref="professional-area-detail({id:professionalArea.id})">{{professionalArea.id}}</a></td><td>{{professionalArea.areaId}}</td><td>{{professionalArea.name}}</td><td>{{professionalArea.description}}</td><td>{{professionalArea.showInFaqList}}</td><td>{{professionalArea.showInDocumentList}}</td><td><a ui-sref="custom-user-detail({id:professionalArea.garantId})">{{professionalArea.garantEmail}}</a></td><td><a ui-sref="professional-area-group-detail({id:professionalArea.professionalAreaGroupId})">{{professionalArea.professionalAreaGroupName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="professional-area-detail({id:professionalArea.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="professional-area.edit({id:professionalArea.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="professional-area.delete({id:professionalArea.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/professional-area-group/professional-area-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.professionalAreaGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.professionalAreaGroup.delete.question" translate-values="{id: \'{{vm.professionalAreaGroup.id}}\'}">Are you sure you want to delete this Professional Area Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/professional-area-group/professional-area-group-detail.html','<div><h2><span data-translate="teJHipsterApp.professionalAreaGroup.detail.title">Professional Area Group</span> {{vm.professionalAreaGroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.professionalAreaGroup.name">Name</span></dt><dd><span>{{vm.professionalAreaGroup.name}}</span></dd><dt><span data-translate="teJHipsterApp.professionalAreaGroup.description">Description</span></dt><dd><span>{{vm.professionalAreaGroup.description}}</span></dd><dt><span data-translate="teJHipsterApp.professionalAreaGroup.groupId">Group Id</span></dt><dd><span>{{vm.professionalAreaGroup.groupId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="professional-area-group-detail.edit({id:vm.professionalAreaGroup.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/professional-area-group/professional-area-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfessionalAreaGroupLabel" data-translate="teJHipsterApp.professionalAreaGroup.home.createOrEditLabel">Create or edit a Professional Area Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.professionalAreaGroup.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.professionalAreaGroup.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalAreaGroup.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.professionalAreaGroup.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalAreaGroup.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.professionalAreaGroup.description"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.professionalAreaGroup.groupId" for="field_groupId">Group Id</label><input type="text" class="form-control" name="groupId" id="field_groupId" ng-model="vm.professionalAreaGroup.groupId" required><div ng-show="editForm.groupId.$invalid"><p class="help-block" ng-show="editForm.groupId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/professional-area-group/professional-area-groups.html','<div><h2 data-translate="teJHipsterApp.professionalAreaGroup.home.title">Professional Area Groups</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="professional-area-group.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.professionalAreaGroup.home.createLabel">Create new Professional Area Group</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.professionalAreaGroup.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="teJHipsterApp.professionalAreaGroup.name">Name</span></th><th><span data-translate="teJHipsterApp.professionalAreaGroup.description">Description</span></th><th><span data-translate="teJHipsterApp.professionalAreaGroup.groupId">Group Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="professionalAreaGroup in vm.professionalAreaGroups track by professionalAreaGroup.id"><td><a ui-sref="professional-area-group-detail({id:professionalAreaGroup.id})">{{professionalAreaGroup.id}}</a></td><td>{{professionalAreaGroup.name}}</td><td>{{professionalAreaGroup.description}}</td><td>{{professionalAreaGroup.groupId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="professional-area-group-detail({id:professionalAreaGroup.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="professional-area-group.edit({id:professionalAreaGroup.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="professional-area-group.delete({id:professionalAreaGroup.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/specific-question/specific-question-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.specificQuestion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.specificQuestion.delete.question" translate-values="{id: \'{{vm.specificQuestion.id}}\'}">Are you sure you want to delete this Specific Question?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/specific-question/specific-question-detail.html','<div><h2><span data-translate="teJHipsterApp.specificQuestion.detail.title">Specific Question</span> {{vm.specificQuestion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.specificQuestion.sender">Sender</span></dt><dd><span>{{vm.specificQuestion.sender}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.content">Content</span></dt><dd><span>{{vm.specificQuestion.content}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.creationtime">Creationtime</span></dt><dd><span>{{vm.specificQuestion.creationtime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.answertime">Answertime</span></dt><dd><span>{{vm.specificQuestion.answertime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.specificquestionstate">Specificquestionstate</span></dt><dd><span data-translate="{{\'teJHipsterApp.SpecificQuestionState.\' + vm.specificQuestion.specificquestionstate}}">{{vm.specificQuestion.specificquestionstate}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.name">Name</span></dt><dd><span>{{vm.specificQuestion.name}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.subject">Subject</span></dt><dd><span>{{vm.specificQuestion.subject}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.senderSecondaryEmail">Sender Secondary Email</span></dt><dd><span>{{vm.specificQuestion.senderSecondaryEmail}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.selectedAnswer">Selected Answer</span></dt><dd><a ui-sref="answer-detail({id:vm.specificQuestion.selectedAnswerId})">{{vm.specificQuestion.selectedAnswerId}}</a></dd><dt><span data-translate="teJHipsterApp.specificQuestion.comments">Comments</span></dt><dd><span ng-repeat="comments in vm.specificQuestion.comments"><a ui-sref="comment-detail({id: comments.id})">{{comments.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="teJHipsterApp.specificQuestion.tasks">Tasks</span></dt><dd><span ng-repeat="tasks in vm.specificQuestion.tasks"><a ui-sref="task-detail({id: tasks.id})">{{tasks.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="specific-question-detail.edit({id:vm.specificQuestion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/specific-question/specific-question-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySpecificQuestionLabel" data-translate="teJHipsterApp.specificQuestion.home.createOrEditLabel">Create or edit a Specific Question</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.specificQuestion.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.specificQuestion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.sender" for="field_sender">Sender</label><input type="text" class="form-control" name="sender" id="field_sender" ng-model="vm.specificQuestion.sender" required ng-pattern="/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$/"><div ng-show="editForm.sender.$invalid"><p class="help-block" ng-show="editForm.sender.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.sender.$error.pattern" data-translate="entity.validation.pattern" translate-value-pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$">This field should follow pattern "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$".</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.content" for="field_content">Content</label><input type="text" class="form-control" name="content" id="field_content" ng-model="vm.specificQuestion.content"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.creationtime" for="field_creationtime">Creationtime</label><div class="input-group"><input id="field_creationtime" type="text" class="form-control" name="creationtime" datetime-picker="{{dateformat}}" ng-model="vm.specificQuestion.creationtime" is-open="vm.datePickerOpenStatus.creationtime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationtime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.creationtime.$invalid"><p class="help-block" ng-show="editForm.creationtime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.creationtime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.answertime" for="field_answertime">Answertime</label><div class="input-group"><input id="field_answertime" type="text" class="form-control" name="answertime" datetime-picker="{{dateformat}}" ng-model="vm.specificQuestion.answertime" is-open="vm.datePickerOpenStatus.answertime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'answertime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.specificquestionstate" for="field_specificquestionstate">Specificquestionstate</label><select class="form-control" name="specificquestionstate" ng-model="vm.specificQuestion.specificquestionstate" id="field_specificquestionstate" required><option value="CREATED" data-translate="teJHipsterApp.SpecificQuestionState.CREATED">CREATED</option><option value="SENT_TO_QUESTIONER" data-translate="teJHipsterApp.SpecificQuestionState.SENT_TO_QUESTIONER">SENT_TO_QUESTIONER</option></select><div ng-show="editForm.specificquestionstate.$invalid"><p class="help-block" ng-show="editForm.specificquestionstate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.specificQuestion.name"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.subject" for="field_subject">Subject</label><input type="text" class="form-control" name="subject" id="field_subject" ng-model="vm.specificQuestion.subject"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.specificQuestion.senderSecondaryEmail" for="field_senderSecondaryEmail">Sender Secondary Email</label><input type="text" class="form-control" name="senderSecondaryEmail" id="field_senderSecondaryEmail" ng-model="vm.specificQuestion.senderSecondaryEmail" ng-pattern="/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$/"><div ng-show="editForm.senderSecondaryEmail.$invalid"><p class="help-block" ng-show="editForm.senderSecondaryEmail.$error.pattern" data-translate="entity.validation.pattern" translate-value-pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$">This field should follow pattern "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$".</p></div></div><div class="form-group"><label data-translate="teJHipsterApp.specificQuestion.selectedAnswer" for="field_selectedAnswer">Selected Answer</label><select class="form-control" id="field_selectedAnswer" name="selectedAnswer" ng-model="vm.specificQuestion.selectedAnswerId" ng-options="answer.id as answer.id for answer in vm.selectedanswers | orderBy:\'id\'"><option value=""></option></select></div><div class="form-group"><label data-translate="teJHipsterApp.specificQuestion.comments" for="field_comments">Comments</label><select class="form-control" id="field_comments" multiple="multiple" name="comments" ng-model="vm.specificQuestion.comments" ng-options="comment as comment.id for comment in vm.comments track by comment.id"></select></div><div class="form-group"><label data-translate="teJHipsterApp.specificQuestion.tasks" for="field_tasks">Tasks</label><select class="form-control" id="field_tasks" multiple="multiple" name="tasks" ng-model="vm.specificQuestion.tasks" ng-options="task as task.id for task in vm.tasks track by task.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/specific-question/specific-questions.html','<div><h2 data-translate="teJHipsterApp.specificQuestion.home.title">Specific Questions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="specific-question.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.specificQuestion.home.createLabel">Create new Specific Question</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.specificQuestion.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sender"><span data-translate="teJHipsterApp.specificQuestion.sender">Sender</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span data-translate="teJHipsterApp.specificQuestion.content">Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationtime"><span data-translate="teJHipsterApp.specificQuestion.creationtime">Creationtime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="answertime"><span data-translate="teJHipsterApp.specificQuestion.answertime">Answertime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="specificquestionstate"><span data-translate="teJHipsterApp.specificQuestion.specificquestionstate">Specificquestionstate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="teJHipsterApp.specificQuestion.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subject"><span data-translate="teJHipsterApp.specificQuestion.subject">Subject</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="senderSecondaryEmail"><span data-translate="teJHipsterApp.specificQuestion.senderSecondaryEmail">Sender Secondary Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="selectedAnswerId"><span data-translate="teJHipsterApp.specificQuestion.selectedAnswer">Selected Answer</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="specificQuestion in vm.specificQuestions track by specificQuestion.id"><td><a ui-sref="specific-question-detail({id:specificQuestion.id})">{{specificQuestion.id}}</a></td><td>{{specificQuestion.sender}}</td><td>{{specificQuestion.content}}</td><td>{{specificQuestion.creationtime | date:\'medium\'}}</td><td>{{specificQuestion.answertime | date:\'medium\'}}</td><td data-translate="{{\'teJHipsterApp.SpecificQuestionState.\' + specificQuestion.specificquestionstate}}">{{specificQuestion.specificquestionstate}}</td><td>{{specificQuestion.name}}</td><td>{{specificQuestion.subject}}</td><td>{{specificQuestion.senderSecondaryEmail}}</td><td><a ui-sref="answer-detail({id:specificQuestion.selectedAnswerId})">{{specificQuestion.selectedAnswerId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="specific-question-detail({id:specificQuestion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="specific-question.edit({id:specificQuestion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="specific-question.delete({id:specificQuestion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/task/task-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.task.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.task.delete.question" translate-values="{id: \'{{vm.task.id}}\'}">Are you sure you want to delete this Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/task/task-detail.html','<div><h2><span data-translate="teJHipsterApp.task.detail.title">Task</span> {{vm.task.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.task.assignmenttime">Assignmenttime</span></dt><dd><span>{{vm.task.assignmenttime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.task.completiontime">Completiontime</span></dt><dd><span>{{vm.task.completiontime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.task.tasktype">Tasktype</span></dt><dd><span data-translate="{{\'teJHipsterApp.TaskType.\' + vm.task.tasktype}}">{{vm.task.tasktype}}</span></dd><dt><span data-translate="teJHipsterApp.task.completionInfo">Completion Info</span></dt><dd><span>{{vm.task.completionInfo}}</span></dd><dt><span data-translate="teJHipsterApp.task.completedInPositiveWay">Completed In Positive Way</span></dt><dd><span>{{vm.task.completedInPositiveWay}}</span></dd><dt><span data-translate="teJHipsterApp.task.assignmentInfo">Assignment Info</span></dt><dd><span>{{vm.task.assignmentInfo}}</span></dd><dt><span data-translate="teJHipsterApp.task.createdBy">Created By</span></dt><dd><a ui-sref="custom-user-detail({id:vm.task.createdById})">{{vm.task.createdByEmail}}</a></dd><dt><span data-translate="teJHipsterApp.task.assignedTo">Assigned To</span></dt><dd><a ui-sref="custom-user-detail({id:vm.task.assignedToId})">{{vm.task.assignedToEmail}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="task-detail.edit({id:vm.task.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/task/task-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTaskLabel" data-translate="teJHipsterApp.task.home.createOrEditLabel">Create or edit a Task</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.task.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.task.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.task.assignmenttime" for="field_assignmenttime">Assignmenttime</label><div class="input-group"><input id="field_assignmenttime" type="text" class="form-control" name="assignmenttime" datetime-picker="{{dateformat}}" ng-model="vm.task.assignmenttime" is-open="vm.datePickerOpenStatus.assignmenttime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assignmenttime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.assignmenttime.$invalid"><p class="help-block" ng-show="editForm.assignmenttime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.assignmenttime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.task.completiontime" for="field_completiontime">Completiontime</label><div class="input-group"><input id="field_completiontime" type="text" class="form-control" name="completiontime" datetime-picker="{{dateformat}}" ng-model="vm.task.completiontime" is-open="vm.datePickerOpenStatus.completiontime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'completiontime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.task.tasktype" for="field_tasktype">Tasktype</label><select class="form-control" name="tasktype" ng-model="vm.task.tasktype" id="field_tasktype" required><option value="ASSIGN_SPECIFIC_QUESTION_TO_EXPERTS" data-translate="teJHipsterApp.TaskType.ASSIGN_SPECIFIC_QUESTION_TO_EXPERTS">ASSIGN_SPECIFIC_QUESTION_TO_EXPERTS</option><option value="CREATE_ANSWER" data-translate="teJHipsterApp.TaskType.CREATE_ANSWER">CREATE_ANSWER</option><option value="REWRITE_ANSWER" data-translate="teJHipsterApp.TaskType.REWRITE_ANSWER">REWRITE_ANSWER</option><option value="APPROVE_ANSWER" data-translate="teJHipsterApp.TaskType.APPROVE_ANSWER">APPROVE_ANSWER</option><option value="FAQ_DONE" data-translate="teJHipsterApp.TaskType.FAQ_DONE">FAQ_DONE</option><option value="REWRITE_FAQ" data-translate="teJHipsterApp.TaskType.REWRITE_FAQ">REWRITE_FAQ</option><option value="FAQ_READY_FOR_PUBLICATION" data-translate="teJHipsterApp.TaskType.FAQ_READY_FOR_PUBLICATION">FAQ_READY_FOR_PUBLICATION</option><option value="FAQ_PUBLISHED" data-translate="teJHipsterApp.TaskType.FAQ_PUBLISHED">FAQ_PUBLISHED</option></select><div ng-show="editForm.tasktype.$invalid"><p class="help-block" ng-show="editForm.tasktype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.task.completionInfo" for="field_completionInfo">Completion Info</label><input type="text" class="form-control" name="completionInfo" id="field_completionInfo" ng-model="vm.task.completionInfo"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.task.completedInPositiveWay" for="field_completedInPositiveWay">Completed In Positive Way</label><input type="checkbox" name="completedInPositiveWay" id="field_completedInPositiveWay" ng-model="vm.task.completedInPositiveWay"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.task.assignmentInfo" for="field_assignmentInfo">Assignment Info</label><input type="text" class="form-control" name="assignmentInfo" id="field_assignmentInfo" ng-model="vm.task.assignmentInfo"></div><div class="form-group"><label data-translate="teJHipsterApp.task.createdBy" for="field_createdBy">Created By</label><select class="form-control" id="field_createdBy" name="createdBy" ng-model="vm.task.createdById" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.createdBy.$invalid"><p class="help-block" ng-show="editForm.createdBy.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="teJHipsterApp.task.assignedTo" for="field_assignedTo">Assigned To</label><select class="form-control" id="field_assignedTo" name="assignedTo" ng-model="vm.task.assignedToId" ng-options="customUser.id as customUser.email for customUser in vm.customusers" required><option value=""></option></select></div><div ng-show="editForm.assignedTo.$invalid"><p class="help-block" ng-show="editForm.assignedTo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/task/tasks.html','<div><h2 data-translate="teJHipsterApp.task.home.title">Tasks</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="task.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.task.home.createLabel">Create new Task</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.task.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="assignmenttime"><span data-translate="teJHipsterApp.task.assignmenttime">Assignmenttime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="completiontime"><span data-translate="teJHipsterApp.task.completiontime">Completiontime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tasktype"><span data-translate="teJHipsterApp.task.tasktype">Tasktype</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="completionInfo"><span data-translate="teJHipsterApp.task.completionInfo">Completion Info</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="completedInPositiveWay"><span data-translate="teJHipsterApp.task.completedInPositiveWay">Completed In Positive Way</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="assignmentInfo"><span data-translate="teJHipsterApp.task.assignmentInfo">Assignment Info</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdByEmail"><span data-translate="teJHipsterApp.task.createdBy">Created By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="assignedToEmail"><span data-translate="teJHipsterApp.task.assignedTo">Assigned To</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="task in vm.tasks track by task.id"><td><a ui-sref="task-detail({id:task.id})">{{task.id}}</a></td><td>{{task.assignmenttime | date:\'medium\'}}</td><td>{{task.completiontime | date:\'medium\'}}</td><td data-translate="{{\'teJHipsterApp.TaskType.\' + task.tasktype}}">{{task.tasktype}}</td><td>{{task.completionInfo}}</td><td>{{task.completedInPositiveWay}}</td><td>{{task.assignmentInfo}}</td><td><a ui-sref="custom-user-detail({id:task.createdById})">{{task.createdByEmail}}</a></td><td><a ui-sref="custom-user-detail({id:task.assignedToId})">{{task.assignedToEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="task-detail({id:task.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="task.edit({id:task.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="task.delete({id:task.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/task-object-type/task-object-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.taskObjectType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.taskObjectType.delete.question" translate-values="{id: \'{{vm.taskObjectType.id}}\'}">Are you sure you want to delete this Task Object Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/task-object-type/task-object-type-detail.html','<div><h2><span data-translate="teJHipsterApp.taskObjectType.detail.title">Task Object Type</span> {{vm.taskObjectType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.taskObjectType.key">Key</span></dt><dd><span>{{vm.taskObjectType.key}}</span></dd><dt><span data-translate="teJHipsterApp.taskObjectType.apiUrl">Api Url</span></dt><dd><span>{{vm.taskObjectType.apiUrl}}</span></dd><dt><span data-translate="teJHipsterApp.taskObjectType.backendUrl">Backend Url</span></dt><dd><span>{{vm.taskObjectType.backendUrl}}</span></dd><dt><span data-translate="teJHipsterApp.taskObjectType.frontendUrl">Frontend Url</span></dt><dd><span>{{vm.taskObjectType.frontendUrl}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="task-object-type-detail.edit({id:vm.taskObjectType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/task-object-type/task-object-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTaskObjectTypeLabel" data-translate="teJHipsterApp.taskObjectType.home.createOrEditLabel">Create or edit a Task Object Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.taskObjectType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.taskObjectType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.taskObjectType.key" for="field_key">Key</label><input type="text" class="form-control" name="key" id="field_key" ng-model="vm.taskObjectType.key" required><div ng-show="editForm.key.$invalid"><p class="help-block" ng-show="editForm.key.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.taskObjectType.apiUrl" for="field_apiUrl">Api Url</label><input type="text" class="form-control" name="apiUrl" id="field_apiUrl" ng-model="vm.taskObjectType.apiUrl"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.taskObjectType.backendUrl" for="field_backendUrl">Backend Url</label><input type="text" class="form-control" name="backendUrl" id="field_backendUrl" ng-model="vm.taskObjectType.backendUrl"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.taskObjectType.frontendUrl" for="field_frontendUrl">Frontend Url</label><input type="text" class="form-control" name="frontendUrl" id="field_frontendUrl" ng-model="vm.taskObjectType.frontendUrl"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/task-object-type/task-object-types.html','<div><h2 data-translate="teJHipsterApp.taskObjectType.home.title">Task Object Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="task-object-type.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.taskObjectType.home.createLabel">Create new Task Object Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.taskObjectType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="key"><span data-translate="teJHipsterApp.taskObjectType.key">Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="apiUrl"><span data-translate="teJHipsterApp.taskObjectType.apiUrl">Api Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="backendUrl"><span data-translate="teJHipsterApp.taskObjectType.backendUrl">Backend Url</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="frontendUrl"><span data-translate="teJHipsterApp.taskObjectType.frontendUrl">Frontend Url</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="taskObjectType in vm.taskObjectTypes track by taskObjectType.id"><td><a ui-sref="task-object-type-detail({id:taskObjectType.id})">{{taskObjectType.id}}</a></td><td>{{taskObjectType.key}}</td><td>{{taskObjectType.apiUrl}}</td><td>{{taskObjectType.backendUrl}}</td><td>{{taskObjectType.frontendUrl}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="task-object-type-detail({id:taskObjectType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="task-object-type.edit({id:taskObjectType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="task-object-type.delete({id:taskObjectType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/user-activation/user-activation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userActivation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="teJHipsterApp.userActivation.delete.question" translate-values="{id: \'{{vm.userActivation.id}}\'}">Are you sure you want to delete this User Activation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/user-activation/user-activation-detail.html','<div><h2><span data-translate="teJHipsterApp.userActivation.detail.title">User Activation</span> {{vm.userActivation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="teJHipsterApp.userActivation.activated">Activated</span></dt><dd><span>{{vm.userActivation.activated}}</span></dd><dt><span data-translate="teJHipsterApp.userActivation.lastSyncTime">Last Sync Time</span></dt><dd><span>{{vm.userActivation.lastSyncTime | date:\'medium\'}}</span></dd><dt><span data-translate="teJHipsterApp.userActivation.customUser">Custom User</span></dt><dd><a ui-sref="custom-user-detail({id:vm.userActivation.customUserId})">{{vm.userActivation.customUserEmail}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="user-activation-detail.edit({id:vm.userActivation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/user-activation/user-activation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserActivationLabel" data-translate="teJHipsterApp.userActivation.home.createOrEditLabel">Create or edit a User Activation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.userActivation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.userActivation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.userActivation.activated" for="field_activated">Activated</label><input type="checkbox" name="activated" id="field_activated" ng-model="vm.userActivation.activated"><div ng-show="editForm.activated.$invalid"><p class="help-block" ng-show="editForm.activated.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="teJHipsterApp.userActivation.lastSyncTime" for="field_lastSyncTime">Last Sync Time</label><div class="input-group"><input id="field_lastSyncTime" type="text" class="form-control" name="lastSyncTime" datetime-picker="{{dateformat}}" ng-model="vm.userActivation.lastSyncTime" is-open="vm.datePickerOpenStatus.lastSyncTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastSyncTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.lastSyncTime.$invalid"><p class="help-block" ng-show="editForm.lastSyncTime.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastSyncTime.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label data-translate="teJHipsterApp.userActivation.customUser" for="field_customUser">Custom User</label><select class="form-control" id="field_customUser" name="customUser" ng-model="vm.userActivation.customUserId" ng-options="customUser.id as customUser.email for customUser in vm.customusers | orderBy:\'id\'" required><option value=""></option></select></div><div ng-show="editForm.customUser.$invalid"><p class="help-block" ng-show="editForm.customUser.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/user-activation/user-activations.html','<div><h2 data-translate="teJHipsterApp.userActivation.home.title">User Activations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-activation.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="teJHipsterApp.userActivation.home.createLabel">Create new User Activation</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'teJHipsterApp.userActivation.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="teJHipsterApp.userActivation.activated">Activated</span></th><th><span data-translate="teJHipsterApp.userActivation.lastSyncTime">Last Sync Time</span></th><th><span data-translate="teJHipsterApp.userActivation.customUser">Custom User</span></th><th></th></tr></thead><tbody><tr ng-repeat="userActivation in vm.userActivations track by userActivation.id"><td><a ui-sref="user-activation-detail({id:userActivation.id})">{{userActivation.id}}</a></td><td>{{userActivation.activated}}</td><td>{{userActivation.lastSyncTime | date:\'medium\'}}</td><td><a ui-sref="custom-user-detail({id:userActivation.customUserId})">{{userActivation.customUserEmail}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-activation-detail({id:userActivation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-activation.edit({id:userActivation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-activation.delete({id:userActivation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">TE_JHipster</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="answer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.answer">Answer</span></a></li><li ui-sref-active="active"><a ui-sref="comment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.comment">Comment</span></a></li><li ui-sref-active="active"><a ui-sref="custom-user" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.customUser">Custom User</span></a></li><li ui-sref-active="active"><a ui-sref="frequently-asked-question" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.frequentlyAskedQuestion">Frequently Asked Question</span></a></li><li ui-sref-active="active"><a ui-sref="professional-area" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.professionalArea">Professional Area</span></a></li><li ui-sref-active="active"><a ui-sref="specific-question" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.specificQuestion">Specific Question</span></a></li><li ui-sref-active="active"><a ui-sref="task" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.task">Task</span></a></li><li ui-sref-active="active"><a ui-sref="task-object-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.taskObjectType">Task Object Type</span></a></li><li ui-sref-active="active"><a ui-sref="frequently-asked-question-state-history" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.frequentlyAskedQuestionStateHistory">Frequently Asked Question State History</span></a></li><li ui-sref-active="active"><a ui-sref="handbook" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbook">Handbook</span></a></li><li ui-sref-active="active"><a ui-sref="handbook-version" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbookVersion">Handbook Version</span></a></li><li ui-sref-active="active"><a ui-sref="handbook-node" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbookNode">Handbook Node</span></a></li><li ui-sref-active="active"><a ui-sref="file" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.file">File</span></a></li><li ui-sref-active="active"><a ui-sref="file-content" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.fileContent">File Content</span></a></li><li ui-sref-active="active"><a ui-sref="professional-area-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.professionalAreaGroup">Professional Area Group</span></a></li><li ui-sref-active="active"><a ui-sref="help" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.help">Help</span></a></li><li ui-sref-active="active"><a ui-sref="handbook-version-state-history" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbookVersionStateHistory">Handbook Version State History</span></a></li><li ui-sref-active="active"><a ui-sref="handbook-merge-header" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbookMergeHeader">Handbook Merge Header</span></a></li><li ui-sref-active="active"><a ui-sref="handbook-merge-item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbookMergeItem">Handbook Merge Item</span></a></li><li ui-sref-active="active"><a ui-sref="handbook-folder" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbookFolder">Handbook Folder</span></a></li><li ui-sref-active="active"><a ui-sref="custom-activity" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.customActivity">Custom Activity</span></a></li><li ui-sref-active="active"><a ui-sref="professional-area" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.professionalArea">Professional Area</span></a></li><li ui-sref-active="active"><a ui-sref="handbook-statistic" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.handbookStatistic">Handbook Statistic</span></a></li><li ui-sref-active="active"><a ui-sref="user-activation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.userActivation">User Activation</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="/login" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();